
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("C9t7g", function(module, exports) {

var $hPkGG = parcelRequire("hPkGG");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $8Iwqw = parcelRequire("8Iwqw");


var $iDdJP = parcelRequire("iDdJP");


var $1PREo = parcelRequire("1PREo");


var $kyH1y = parcelRequire("kyH1y");

var $2khPJ = parcelRequire("2khPJ");


var $cXPtd = parcelRequire("cXPtd");


var $aJMnP = parcelRequire("aJMnP");


var $42SFg = parcelRequire("42SFg");


var $4Mzej = parcelRequire("4Mzej");





var $dinVW = parcelRequire("dinVW");





var $eaC3G = parcelRequire("eaC3G");

const $e00e30008af53db7$var$ShortcutsMenuComponent = ({ shortcutItems: shortcutItems = [], product: product, openInSameTab: openInSameTab, invitedAppProductLinks: invitedAppProductLinks })=>{
    const mappedShortcutItems = (0, $cozmU.useMemo)(()=>{
        return shortcutItems.map((item)=>{
            if (item.type === 'link' && item.apsKey) {
                const key = item.apsKey;
                const filteredProductLinks = invitedAppProductLinks[item.apsKey];
                // By the time we got here, we've already decided we're eligible etc.,
                // During SSR, we don't have the product links yet
                // so we return the item without URL to ensure rendering the shortcut
                // After the product links are loaded, the shortcut will be updated with the URL
                if (!filteredProductLinks) return {
                    ...item,
                    key: key
                };
                // we only want to take single link items as we are not supporting expand menus
                if (filteredProductLinks.length === 1 && !item.url) return {
                    ...item,
                    key: key,
                    url: filteredProductLinks[0].url
                };
            }
            return null;
        }).filter(Boolean);
    }, [
        shortcutItems,
        invitedAppProductLinks
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        testId: "shortcuts-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, mappedShortcutItems.map((shortcut)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaC3G.ShortcutMenuItem), {
            key: shortcut.key,
            shortcut: shortcut,
            product: product,
            openInSameTab: openInSameTab
        }))));
};
const $e00e30008af53db7$export$4519a9392cf3004e = /*#__PURE__*/ (0, $cozmU.memo)($e00e30008af53db7$var$ShortcutsMenuComponent);



var $fEmGS = parcelRequire("fEmGS");


var $jMyy4 = parcelRequire("jMyy4");


var $b3j2Y = parcelRequire("b3j2Y");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $dPJCf = parcelRequire("dPJCf");


var $epLE5 = parcelRequire("epLE5");


var $jmjWc = parcelRequire("jmjWc");


var $kvJHJ = parcelRequire("kvJHJ");


var $6adZX = parcelRequire("6adZX");


var $hrvfP = parcelRequire("hrvfP");


var $dA1Sn = parcelRequire("dA1Sn");


var $8dN99 = parcelRequire("8dN99");


var $bDgLe = parcelRequire("bDgLe");


var $u7mpJ = parcelRequire("u7mpJ");

const $12338c25dd8aaf48$var$STANDARD_ITEMS_HIDDEN = [
    {
        menuId: 'recent',
        visible: false
    },
    {
        menuId: 'starred',
        visible: false
    },
    {
        menuId: 'companyHubShortcut',
        visible: false
    },
    {
        menuId: 'teamsShortcut',
        visible: false
    }
];
const $12338c25dd8aaf48$export$2471979fb08e1cdf = (platformCustomizations)=>{
    const $ = (0, $bDgLe.c)(14);
    const { navCustomization: navCustomization } = (0, $u7mpJ.useCreationFocusedNavLand)(true);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    let customizedForExperiment = t0;
    if (navCustomization === (0, $u7mpJ.loading)) {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = [
                ...$12338c25dd8aaf48$var$STANDARD_ITEMS_HIDDEN,
                {
                    menuId: "templates",
                    visible: false
                }
            ];
            $[1] = t1;
        } else t1 = $[1];
        customizedForExperiment = t1;
    } else {
        if (navCustomization === (0, $u7mpJ.d0)) {
            let t1;
            if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = [
                    ...$12338c25dd8aaf48$var$STANDARD_ITEMS_HIDDEN,
                    {
                        menuId: "templates",
                        visible: true
                    }
                ];
                $[2] = t1;
            } else t1 = $[2];
            customizedForExperiment = t1;
        } else if (navCustomization === (0, $u7mpJ.d1)) {
            let t1;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = [
                    {
                        menuId: "templates",
                        visible: true
                    }
                ];
                $[3] = t1;
            } else t1 = $[3];
            customizedForExperiment = t1;
        }
    }
    let t1;
    if ($[4] !== platformCustomizations) {
        t1 = new Set(platformCustomizations.map($12338c25dd8aaf48$var$_temp));
        $[4] = platformCustomizations;
        $[5] = t1;
    } else t1 = $[5];
    const customizedMenuIds = t1;
    let t2;
    if ($[6] !== customizedForExperiment || $[7] !== customizedMenuIds) {
        t2 = customizedForExperiment.filter((item_0)=>!customizedMenuIds.has(item_0.menuId));
        $[6] = customizedForExperiment;
        $[7] = customizedMenuIds;
        $[8] = t2;
    } else t2 = $[8];
    const itemsToCustomize = t2;
    let t3;
    if ($[9] !== itemsToCustomize || $[10] !== platformCustomizations) {
        t3 = [
            ...platformCustomizations,
            ...itemsToCustomize
        ];
        $[9] = itemsToCustomize;
        $[10] = platformCustomizations;
        $[11] = t3;
    } else t3 = $[11];
    const platformCustomizationsWithSimplifyNav = t3;
    let t4;
    if ($[12] !== platformCustomizationsWithSimplifyNav) {
        t4 = {
            platformCustomizationsWithSimplifyNav: platformCustomizationsWithSimplifyNav
        };
        $[12] = platformCustomizationsWithSimplifyNav;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
};
function $12338c25dd8aaf48$var$_temp(item) {
    return item.menuId;
}



var $1uFsv = parcelRequire("1uFsv");








var $1UWNP = parcelRequire("1UWNP");


var $3ricL = parcelRequire("3ricL");





var $1NBp8 = parcelRequire("1NBp8");


var $1ytiN = parcelRequire("1ytiN");


var $cEgMD = parcelRequire("cEgMD");


var $eSLr0 = parcelRequire("eSLr0");


var $6ld6a = parcelRequire("6ld6a");


var $eI95o = parcelRequire("eI95o");


var $1jJCz = parcelRequire("1jJCz");


var $h7d8T = parcelRequire("h7d8T");

const $5cb9965cd3125e0a$var$AuthenticationEnumMap = {
    //0 least privileged, 3 most privileged
    [(0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS]: 0,
    [(0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS]: 1,
    [(0, $d9tcB.AccessStatus).EXTERNAL_SHARE_ACCESS]: 0,
    [(0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS]: 3,
    [(0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS]: 2,
    [(0, $d9tcB.AccessStatus).NOT_PERMITTED]: 0,
    [(0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS]: 1
};
// Default configuration for all possible top-level items in Confluence Global Nav
const $5cb9965cd3125e0a$var$defaultMenuConfiguration = {
    customHome: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        isCustomizable: false
    },
    yourWork: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: false
    },
    companyHub: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: false
    },
    recent: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS,
        isCustomizable: true
    },
    starred: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS,
        isCustomizable: true
    },
    spaces: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        isCustomizable: true
    },
    apps: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        isCustomizable: true
    },
    goals: {
        //todo: where does this go?
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        href: '#',
        apsKey: 'GOALS'
    },
    topics: {
        //todo: where does this go?
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        isCustomizable: true,
        href: '#'
    },
    teams: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        href: (0, $1NBp8.CONFLUENCE_PEOPLE_DIRECTORY_SEARCH).toUrl()
    },
    drafts: {
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        href: (0, $1NBp8.HOME).toUrl({
            view: 'drafts'
        })
    },
    tasks: {
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        href: (0, $1NBp8.HOME).toUrl({
            view: 'tasks'
        })
    },
    templates: {
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        isCustomizable: true,
        href: (0, $1NBp8.TEMPLATE_GALLERY).toUrl()
    },
    companyHubShortcut: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        isAppShortcut: true,
        href: (0, $1NBp8.COMPANY_HUB).toUrl()
    },
    jiraShortcut: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        isAppShortcut: true,
        apsKey: 'JIRA_SOFTWARE'
    },
    loomShortcut: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        isAppShortcut: true,
        apsKey: 'LOOM'
    },
    teamsShortcut: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        isAppShortcut: true,
        apsKey: 'TEAMS'
    },
    customize: {
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: false
    }
};
const $5cb9965cd3125e0a$var$defaultPlatformCustomizationList = Object.entries($5cb9965cd3125e0a$var$defaultMenuConfiguration).filter(([, { isCustomizable: isCustomizable }])=>isCustomizable).map(([menuId, { defaultVisibility: defaultVisibility, isAppShortcut: isAppShortcut }])=>({
        menuId: menuId,
        visible: defaultVisibility,
        isAppShortcut: isAppShortcut || false
    }));
const $5cb9965cd3125e0a$var$mergeCustomizationsWithDefaults = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((platformCustomizations)=>{
    const validatedCustomizations = [];
    const customizedMenuIds = new Set();
    platformCustomizations?.forEach((item)=>{
        if ($5cb9965cd3125e0a$var$defaultMenuConfiguration[item.menuId]) {
            validatedCustomizations.push(item);
            customizedMenuIds.add(item.menuId);
        }
    });
    // These items always appear first
    const finalMenuItems = [
        {
            menuId: 'customHome',
            visible: true
        },
        {
            menuId: 'yourWork',
            visible: true
        }
    ];
    // Add any customized menu items
    validatedCustomizations.forEach((item)=>{
        finalMenuItems.push(item);
    });
    // Add any default items that were not customized
    $5cb9965cd3125e0a$var$defaultPlatformCustomizationList.forEach((item)=>{
        if (!customizedMenuIds.has(item.menuId)) finalMenuItems.push(item);
    });
    // Company Hub is an app shortcut.
    finalMenuItems.push({
        menuId: 'companyHub',
        visible: true
    });
    // Customize always appears last
    finalMenuItems.push({
        menuId: 'customize',
        visible: true
    });
    return finalMenuItems;
});
const $5cb9965cd3125e0a$var$createMenuItem = (menuId, config)=>({
        menuId: menuId,
        isCustomizable: config.isCustomizable,
        ...config.href && {
            href: config.href
        },
        ...config.isAppShortcut && {
            isAppShortcut: config.isAppShortcut
        }
    });
const $5cb9965cd3125e0a$var$createMenuItemNext = (menuId, config, visible)=>({
        menuId: menuId,
        visible: visible,
        isNotCustomizable: !config.isCustomizable,
        isNotToggleable: !config.isCustomizable,
        ...config.href && {
            href: config.href
        },
        ...config.isAppShortcut && {
            isAppShortcut: config.isAppShortcut
        }
    });
const $5cb9965cd3125e0a$export$9ef0020da7b7dcc4 = (showCustomization, accessStatus, platformCustomizations, visibilityOverrides, getFilteredProductLinks, fallbackUrls)=>{
    const globalMenuItems = [];
    const moreMenuItems = [];
    const appShortcutMenuItems = [];
    const allMenuItems = [];
    const orderedItems = $5cb9965cd3125e0a$var$mergeCustomizationsWithDefaults(platformCustomizations);
    const customizeItemId = 'customize';
    orderedItems.forEach((item)=>{
        const menuId = item.menuId;
        const defaultConfig = $5cb9965cd3125e0a$var$defaultMenuConfiguration[menuId];
        const accessStatusLevel = accessStatus && $5cb9965cd3125e0a$var$AuthenticationEnumMap[accessStatus] || 0; //if accessStatus is null, we default to anon level access
        if (//check if auth level is equal to or greater than what's required for each menu item
        $5cb9965cd3125e0a$var$AuthenticationEnumMap[defaultConfig.authenticationLevelRequired] <= accessStatusLevel && visibilityOverrides?.[menuId] !== false && menuId !== customizeItemId && !defaultConfig.isAppShortcut) {
            const menuItem = $5cb9965cd3125e0a$var$createMenuItem(menuId, defaultConfig);
            (item.visible ? globalMenuItems : moreMenuItems).push(menuItem);
            allMenuItems.push($5cb9965cd3125e0a$var$createMenuItemNext(menuId, defaultConfig, item.visible));
        }
        // APP SHORTCUTS
        if (visibilityOverrides?.[menuId] && defaultConfig.isAppShortcut) {
            const pushConfig = {
                ...defaultConfig
            };
            if (getFilteredProductLinks && defaultConfig.apsKey) pushConfig.href = getFilteredProductLinks(defaultConfig.apsKey)?.links[0]?.url ?? fallbackUrls?.[menuId];
            if (pushConfig.apsKey && pushConfig.href || !pushConfig.apsKey) {
                appShortcutMenuItems.push($5cb9965cd3125e0a$var$createMenuItemNext(item.menuId, pushConfig, item.visible));
                if (!item.visible) moreMenuItems.push($5cb9965cd3125e0a$var$createMenuItem(item.menuId, pushConfig));
            }
        }
    });
    // customize sidebar item should be the last item of the more items menu
    // unless there are no items, then it should be in the global menu items
    if (showCustomization && visibilityOverrides?.[customizeItemId] !== false) {
        const customizeItem = $5cb9965cd3125e0a$var$createMenuItem(customizeItemId, $5cb9965cd3125e0a$var$defaultMenuConfiguration[customizeItemId]);
        (moreMenuItems.length === 0 ? globalMenuItems : moreMenuItems).push(customizeItem);
    }
    return {
        globalMenuItems: globalMenuItems,
        moreMenuItems: moreMenuItems,
        allMenuItems: allMenuItems,
        appShortcutMenuItems: appShortcutMenuItems
    };
};
const $5cb9965cd3125e0a$export$aad046bd9909db8f = (showCustomization, accessStatus, platformCustomizations, getFilteredProductLinks)=>{
    const $ = (0, $bDgLe.c)(23);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
            allowedWebItems: [
                $5cb9965cd3125e0a$export$8fa81f0104234d32,
                $5cb9965cd3125e0a$export$78f3e9dc1aa1d31d
            ]
        };
        $[0] = t0;
    } else t0 = $[0];
    const { loading: webItemsLoading, webItems: webItems } = (0, $6ld6a.useWebItemLocation)(t0);
    const fallbackUrls = (0, $h7d8T.useFallbackUrls)();
    const { hasJira: hasJira, hasLoom: hasLoom } = (0, $1jJCz.useLicensedProducts)();
    const { homepageUri: homepageUri } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const { isPeopleVisible: isPeopleVisible, isCompanyHubVisible: isCompanyHubVisible } = (0, $eI95o.useShortcutVisibilityOverrides)();
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $3ricL.isFeatureEnabled)("confluence", "confluence-forge-apps-sidebar");
        $[1] = t1;
    } else t1 = $[1];
    const shouldHideAppsSideBarInIsolatedCloud = !t1;
    let t2;
    if ($[2] !== webItems || $[3] !== webItemsLoading) {
        t2 = !webItemsLoading && !!webItems.find($5cb9965cd3125e0a$var$_temp);
        $[2] = webItems;
        $[3] = webItemsLoading;
        $[4] = t2;
    } else t2 = $[4];
    const isSpacesVisible = t2;
    let t3;
    if ($[5] !== homepageUri || $[6] !== isCompanyHubVisible) {
        t3 = isCompanyHubVisible && homepageUri.includes((0, $cEgMD.getCompanyHubSpaceKey)());
        $[5] = homepageUri;
        $[6] = isCompanyHubVisible;
        $[7] = t3;
    } else t3 = $[7];
    const isCompanyHubSetAsCustomHome = t3;
    let t4;
    if ($[8] !== homepageUri || $[9] !== isCompanyHubSetAsCustomHome) {
        t4 = !isCompanyHubSetAsCustomHome && ![
            "/spa.action",
            "",
            "homepageUri"
        ].includes(homepageUri);
        $[8] = homepageUri;
        $[9] = isCompanyHubSetAsCustomHome;
        $[10] = t4;
    } else t4 = $[10];
    const isCustomHomeVisible = t4;
    let t5;
    if ($[11] !== accessStatus || $[12] !== fallbackUrls || $[13] !== getFilteredProductLinks || $[14] !== hasJira || $[15] !== hasLoom || $[16] !== isCompanyHubVisible || $[17] !== isCustomHomeVisible || $[18] !== isPeopleVisible || $[19] !== isSpacesVisible || $[20] !== platformCustomizations || $[21] !== showCustomization) {
        const visibilityOverrides = {
            customHome: isCustomHomeVisible,
            companyHub: false,
            spaces: isSpacesVisible,
            teams: false,
            topics: false,
            goals: false,
            templates: true,
            drafts: true,
            apps: !shouldHideAppsSideBarInIsolatedCloud,
            tasks: true,
            customize: true,
            companyHubShortcut: isCompanyHubVisible,
            jiraShortcut: hasJira,
            loomShortcut: hasLoom,
            teamsShortcut: isPeopleVisible
        };
        t5 = $5cb9965cd3125e0a$export$9ef0020da7b7dcc4(showCustomization, accessStatus, platformCustomizations, visibilityOverrides, getFilteredProductLinks, fallbackUrls);
        $[11] = accessStatus;
        $[12] = fallbackUrls;
        $[13] = getFilteredProductLinks;
        $[14] = hasJira;
        $[15] = hasLoom;
        $[16] = isCompanyHubVisible;
        $[17] = isCustomHomeVisible;
        $[18] = isPeopleVisible;
        $[19] = isSpacesVisible;
        $[20] = platformCustomizations;
        $[21] = showCustomization;
        $[22] = t5;
    } else t5 = $[22];
    return t5;
};
const $5cb9965cd3125e0a$export$8fa81f0104234d32 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-spaces-link';
const $5cb9965cd3125e0a$export$78f3e9dc1aa1d31d = 'com.atlassian.confluence.plugins.confluence-space-ia:header-people-link';
function $5cb9965cd3125e0a$var$_temp(item) {
    return item.completeKey === $5cb9965cd3125e0a$export$8fa81f0104234d32;
}






var $kSwu1 = parcelRequire("kSwu1");


var $InD31 = parcelRequire("InD31");


var $QodSn = parcelRequire("QodSn");


var $cwlZp = parcelRequire("cwlZp");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $145zT = parcelRequire("145zT");


var $huaOC = parcelRequire("huaOC");


var $aZIBq = parcelRequire("aZIBq");


var $63PsI = parcelRequire("63PsI");














var $V3JOP = parcelRequire("V3JOP");


var $eHDih = parcelRequire("eHDih");














var $7aRa9 = parcelRequire("7aRa9");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");











var $1kHsc = parcelRequire("1kHsc");


const $d3915af5fe8217ec$var$lazyOnClick = async (args)=>{
    const { companyHubItemCallback: companyHubItemCallback } = await (parcelRequire("kX2dA"));
    await companyHubItemCallback(args);
};
const $d3915af5fe8217ec$export$40e9528e11a75d6b = (0, $7aRa9.withFlags)(/*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { children: children, flags: flags, navVersion: navVersion } = t0;
    const companyHubName = (0, $63PsI.useCompanyHubName)();
    const { match: match, push: push } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const routeName = match?.name;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== experienceTracker || $[2] !== flags || $[3] !== navVersion || $[4] !== push || $[5] !== routeName) {
        t1 = async ()=>{
            $d3915af5fe8217ec$var$lazyOnClick({
                createAnalyticsEvent: createAnalyticsEvent,
                experienceTracker: experienceTracker,
                flags: flags,
                isFirstTimeVisit: false,
                push: push,
                routeName: routeName,
                navVersion: navVersion
            });
        };
        $[0] = createAnalyticsEvent;
        $[1] = experienceTracker;
        $[2] = flags;
        $[3] = navVersion;
        $[4] = push;
        $[5] = routeName;
        $[6] = t1;
    } else t1 = $[6];
    const onClick = t1;
    let t2;
    if ($[7] !== children || $[8] !== companyHubName || $[9] !== onClick || $[10] !== routeName || $[11] !== spaceKey) {
        const isSelected = routeName === (0, $1NBp8.COMPANY_HUB).name || routeName !== (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name && routeName !== (0, $1NBp8.COMPANY_HUB_ANALYTICS).name && routeName !== (0, $1NBp8.COMPANY_HUB_SETTINGS).name && (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
        t2 = children({
            companyHubName: companyHubName,
            isSelected: isSelected,
            namedRoute: (0, $1NBp8.COMPANY_HUB),
            onClick: onClick
        });
        $[7] = children;
        $[8] = companyHubName;
        $[9] = onClick;
        $[10] = routeName;
        $[11] = spaceKey;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
}));


const $67a256fbfa808886$var$DEFAULT_COMPANY_HUB_NAME = 'Company Hub';
const $67a256fbfa808886$var$i18n = (0, $kSwu1.defineMessages)({
    CompanyHubName: {
        id: "side-navigation.custom.company-hub.shortcut-name",
        defaultMessage: "Company Hub"
    }
});
const $67a256fbfa808886$export$7d5e579a7612f1c2 = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { isHidden: isHidden, onClick: onClick } = t0;
    if (isHidden) return null;
    let t1;
    if ($[0] !== onClick) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d3915af5fe8217ec$export$40e9528e11a75d6b), {
            navVersion: "4"
        }, (t2)=>{
            const { companyHubName: companyHubName, isSelected: isSelected, namedRoute: namedRoute, onClick: onAbstractCompanyHubItemClick } = t2;
            const elemBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eHDih.HubIcon), {
                size: "xsmall"
            });
            const elemAfter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
                label: "",
                spacing: "spacious",
                size: "small"
            });
            const onMenuLinkItemClick = ()=>{
                onClick?.();
                onAbstractCompanyHubItemClick();
            };
            const isDefaultCompanyHubName = companyHubName === $67a256fbfa808886$var$DEFAULT_COMPANY_HUB_NAME;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
                elemAfter: elemAfter,
                elemBefore: elemBefore,
                href: namedRoute?.toUrl() || "#",
                isSelected: isSelected,
                onClick: onMenuLinkItemClick,
                target: "_blank"
            }, isDefaultCompanyHubName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $67a256fbfa808886$var$i18n.CompanyHubName) : companyHubName);
        });
        $[0] = onClick;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};



var $1LksZ = parcelRequire("1LksZ");


var $cxU8R = parcelRequire("cxU8R");


const $6bf303f52478ae0b$var$AddFeaturesSidebarSpotlightLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zs9s-",
    name: "AddFeaturesSidebarSpotlightLoader",
    loader: async ()=>(await (parcelRequire("bABP9"))).AddFeaturesSidebarSpotlight
});
const $6bf303f52478ae0b$export$e967513bbeba0537 = ({ moreMenuItems: moreMenuItems, isOpen: isOpen, toggleMenu: toggleMenu, onClick: onClick, peekingId: peekingId, isCollapsed: isCollapsed })=>{
    const companyHubName = (0, $63PsI.useCompanyHubName)();
    const iconByMenuId = (0, $cxU8R.useIconByMenuId)();
    if (!moreMenuItems || moreMenuItems?.length <= 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $InD31.Popup), {
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6bf303f52478ae0b$var$AddFeaturesSidebarSpotlightLoader, {
        isCollapsed: isCollapsed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cwlZp.PopupTrigger), null, ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
            ref: ref,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            elemBefore: (0, $cxU8R.MoreIconComponent),
            onClick: toggleMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $1LksZ.i18n).more)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $6bf303f52478ae0b$var$popupContentContainerStyles,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QodSn.PopupContent), {
        placement: "bottom-start",
        // Offset the top margin of the menu section.
        // This will keep an even spacing of menu items between those inside the dropdown and those above,
        // and keep the icons aligned
        offset: [
            -4,
            4
        ],
        onClose: toggleMenu,
        shouldRenderToParent: true,
        strategy: "absolute",
        shouldFitContainer: true
    }, ()=>{
        // The number of visible / non-null menu items so that proper dividers can be added.
        let nonNullMenuItemCount = 0;
        const menuItems = moreMenuItems.map(({ menuId: menuId, href: href, isAppShortcut: isAppShortcut })=>{
            if (peekingId && menuId === peekingId) return null; //if an item is peeking, do not render it in this menu
            ++nonNullMenuItemCount;
            if (menuId === 'companyHub') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, nonNullMenuItemCount !== 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZIBq.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67a256fbfa808886$export$7d5e579a7612f1c2), {
                key: menuId,
                onClick: ()=>onClick(menuId),
                setIsCustomizeSidebarDialogVisible: ()=>{}
            }));
            let node;
            if (href) node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
                href: href,
                onClick: ()=>onClick(menuId),
                elemBefore: iconByMenuId[menuId],
                key: menuId,
                target: isAppShortcut ? '_blank' : undefined
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $1LksZ.i18n)[menuId],
                values: menuId === 'companyHubShortcut' ? {
                    companyHubName: companyHubName
                } : {}
            }));
            else node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
                onClick: ()=>onClick(menuId),
                elemBefore: iconByMenuId[menuId],
                key: menuId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $1LksZ.i18n)[menuId],
                values: menuId === 'companyHubShortcut' ? {
                    companyHubName: companyHubName
                } : {}
            }));
            // The item "Customize sidebar" is visually divided from the preceeding global items and/or app shortcuts:
            if (node && nonNullMenuItemCount !== 1 && menuId === 'customize') node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZIBq.Divider), null), node);
            return node;
        });
        // PopupContent has an `xcss` prop, but it casts its value to `string` and thus isn't suitable.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $6bf303f52478ae0b$var$popupContentStyles,
            role: "list"
        }, menuItems);
    })));
};
const $6bf303f52478ae0b$var$popupContentContainerStyles = (0, $buxP3.xcss)({
    position: 'relative',
    marginInline: 'space.negative.050',
    height: '0',
    // Establishes a stacking context so the open popup appears above subsequent
    // sibling elements (e.g. ConnectorPromoSidebar) in the same MenuList.
    // Without this, shouldRenderToParent popup content loses to later DOM siblings.
    // This matches the popup z index
    zIndex: 'layer'
});
const $6bf303f52478ae0b$var$popupContentStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});


















var $czzzJ = parcelRequire("czzzJ");


var $gtMdU = parcelRequire("gtMdU");







const $fd7af3b9b55c9b5d$export$4bb4a114d280c175 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (globalShortcutsItemMap, customizationMenuConfig)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    bb0: {
        if (!customizationMenuConfig || customizationMenuConfig.length === 0) {
            let t1;
            if ($[0] !== globalShortcutsItemMap) {
                t1 = Object.values(globalShortcutsItemMap);
                $[0] = globalShortcutsItemMap;
                $[1] = t1;
            } else t1 = $[1];
            t0 = t1;
            break bb0;
        }
        let t1;
        if ($[2] !== customizationMenuConfig) {
            t1 = new Map(customizationMenuConfig.map($fd7af3b9b55c9b5d$var$_temp));
            $[2] = customizationMenuConfig;
            $[3] = t1;
        } else t1 = $[3];
        const configMap = t1;
        let result;
        if ($[4] !== configMap || $[5] !== customizationMenuConfig || $[6] !== globalShortcutsItemMap) {
            result = [];
            const addedKeys = new Set();
            customizationMenuConfig.forEach((t2)=>{
                const { menuId: menuId, visible: visible } = t2;
                if (visible && globalShortcutsItemMap[menuId]) {
                    result.push(globalShortcutsItemMap[menuId]);
                    addedKeys.add(menuId);
                }
            });
            Object.entries(globalShortcutsItemMap).forEach((t3)=>{
                const [key, value] = t3;
                if (!addedKeys.has(key)) {
                    const config_0 = configMap.get(key);
                    if (!config_0) result.push(value);
                }
            });
            $[4] = configMap;
            $[5] = customizationMenuConfig;
            $[6] = globalShortcutsItemMap;
            $[7] = result;
        } else result = $[7];
        t0 = result;
    }
    return t0;
} : (globalShortcutsItemMap, customizationMenuConfig)=>{
    return (0, $cozmU.useMemo)(()=>{
        // return the original config if no customizationMenuConfig is provided
        if (!customizationMenuConfig || customizationMenuConfig.length === 0) return Object.values(globalShortcutsItemMap);
        // Create a map for low complexity lookups
        const configMap = new Map(customizationMenuConfig.map((config)=>[
                config.menuId,
                config
            ]));
        const result = [];
        const addedKeys = new Set();
        // First pass: add items in the order specified by customizationMenuConfig
        customizationMenuConfig.forEach(({ menuId: menuId, visible: visible })=>{
            if (visible && globalShortcutsItemMap[menuId]) {
                result.push(globalShortcutsItemMap[menuId]);
                addedKeys.add(menuId);
            }
        });
        // Second pass: add remaining items that aren't in customizationMenuConfig or aren't visible
        Object.entries(globalShortcutsItemMap).forEach(([key, value])=>{
            if (!addedKeys.has(key)) {
                const config_0 = configMap.get(key);
                // Add if not in config (assume visible) or if in config but not visible
                if (!config_0) result.push(value);
            }
        });
        return result;
    }, [
        globalShortcutsItemMap,
        customizationMenuConfig
    ]);
};
function $fd7af3b9b55c9b5d$var$_temp(config) {
    return [
        config.menuId,
        config
    ];
}






var $7DAwP = parcelRequire("7DAwP");


var $aGiXn = parcelRequire("aGiXn");

const $7d243d65a15d9065$export$69209b4d7b9e00bc = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { orderedMenuConfig: t1, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, shouldHandOverJiraShortcut: t2, shouldHandOverLoomShortcut: t3 } = t0;
    let t4;
    if ($[0] !== t1) {
        t4 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t4;
    } else t4 = $[1];
    const orderedMenuConfig = t4;
    const shouldHandOverJiraShortcut = t2 === undefined ? false : t2;
    const shouldHandOverLoomShortcut = t3 === undefined ? false : t3;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { config: teamsShortcutConfig, component: teamsShortcutComponent } = (0, $aGiXn.useTeamsAppShortcut)();
    let t5;
    if ($[2] !== onUpdateGetFilteredProductLinks) {
        t5 = (getFilteredProductLinks)=>{
            if (onUpdateGetFilteredProductLinks) onUpdateGetFilteredProductLinks(getFilteredProductLinks);
        };
        $[2] = onUpdateGetFilteredProductLinks;
        $[3] = t5;
    } else t5 = $[3];
    const updateGetFilteredProductLinks = t5;
    let t6;
    if ($[4] !== teamsShortcutConfig) {
        t6 = {
            teamsShortcutConfig: teamsShortcutConfig
        };
        $[4] = teamsShortcutConfig;
        $[5] = t6;
    } else t6 = $[5];
    const shortcutItemsConfig = (0, $7DAwP.useShortcutItemsConfig)(t6);
    let t7;
    bb0: {
        if (!shouldHandOverJiraShortcut && !shouldHandOverLoomShortcut) {
            t7 = shortcutItemsConfig;
            break bb0;
        }
        let t8;
        if ($[6] !== shortcutItemsConfig || $[7] !== shouldHandOverJiraShortcut || $[8] !== shouldHandOverLoomShortcut) {
            let t9;
            if ($[10] !== shouldHandOverJiraShortcut || $[11] !== shouldHandOverLoomShortcut) {
                t9 = (config, t10)=>{
                    const [key, shortcut] = t10;
                    if (key === "jiraShortcut" && shouldHandOverJiraShortcut || key === "loomShortcut" && shouldHandOverLoomShortcut) return config;
                    return {
                        ...config,
                        [key]: shortcut
                    };
                };
                $[10] = shouldHandOverJiraShortcut;
                $[11] = shouldHandOverLoomShortcut;
                $[12] = t9;
            } else t9 = $[12];
            t8 = Object.entries(shortcutItemsConfig).reduce(t9, {});
            $[6] = shortcutItemsConfig;
            $[7] = shouldHandOverJiraShortcut;
            $[8] = shouldHandOverLoomShortcut;
            $[9] = t8;
        } else t8 = $[9];
        t7 = t8;
    }
    const shortcutItemsConfigReduced = t7;
    const orderedShortcuts = (0, $fd7af3b9b55c9b5d$export$4bb4a114d280c175)(shortcutItemsConfigReduced, orderedMenuConfig);
    let t8;
    if ($[13] !== cloudId || $[14] !== orderedShortcuts || $[15] !== updateGetFilteredProductLinks) {
        const globalShortcutsProps = {
            testId: "global-app-shortcuts",
            cloudId: cloudId,
            shortcutItems: orderedShortcuts,
            product: "confluence",
            onUpdateGetFilteredProductLinks: updateGetFilteredProductLinks
        };
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $czzzJ.GlobalShortcuts), globalShortcutsProps);
        $[13] = cloudId;
        $[14] = orderedShortcuts;
        $[15] = updateGetFilteredProductLinks;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== orderedShortcuts.length) {
        t9 = orderedShortcuts.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PREo.TopLevelSpacer), null);
        $[17] = orderedShortcuts.length;
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== t8 || $[20] !== t9 || $[21] !== teamsShortcutComponent) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t8, t9, teamsShortcutComponent);
        $[19] = t8;
        $[20] = t9;
        $[21] = teamsShortcutComponent;
        $[22] = t10;
    } else t10 = $[22];
    return t10;
};


const $c495d3eaf0ec763f$export$8a66e0b504449f1 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { orderedMenuConfig: orderedMenuConfig, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, shouldHandOverJiraShortcut: shouldHandOverJiraShortcut, shouldHandOverLoomShortcut: shouldHandOverLoomShortcut } = t0;
    let t1;
    if ($[0] !== onUpdateGetFilteredProductLinks || $[1] !== orderedMenuConfig || $[2] !== shouldHandOverJiraShortcut || $[3] !== shouldHandOverLoomShortcut) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7d243d65a15d9065$export$69209b4d7b9e00bc), {
            orderedMenuConfig: orderedMenuConfig,
            onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks,
            shouldHandOverJiraShortcut: shouldHandOverJiraShortcut,
            shouldHandOverLoomShortcut: shouldHandOverLoomShortcut
        });
        $[0] = onUpdateGetFilteredProductLinks;
        $[1] = orderedMenuConfig;
        $[2] = shouldHandOverJiraShortcut;
        $[3] = shouldHandOverLoomShortcut;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};


















var $jlIaF = parcelRequire("jlIaF");













const $15140e42b692bfde$var$i18n = (0, $kSwu1.defineMessages)({
    CustomHomeLink: {
        id: "side-navigation.custom.home.link",
        defaultMessage: "Custom Home Page"
    }
});

const $15140e42b692bfde$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("ecTjk"))).fireCustomHomepageClickedAnalytics);
const $15140e42b692bfde$export$adaf351fc9d12cd2 = ()=>{
    const $ = (0, $bDgLe.c)(10);
    const { location: location, match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireClickAnalytics = $15140e42b692bfde$var$useLazyClickAnalytics(createAnalyticsEvent, match?.name);
    const { homepageUri: homepageUri, homepageTitle: homepageTitle } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    let t0;
    if ($[0] !== homepageUri || $[1] !== location) {
        t0 = !!location && location.pathname === `${0, $jlIaF.CONTEXT_PATH}${homepageUri}` && location.search.includes("mode=global");
        $[0] = homepageUri;
        $[1] = location;
        $[2] = t0;
    } else t0 = $[2];
    const isSelected = t0;
    const t1 = `${(0, $jlIaF.CONTEXT_PATH)}${homepageUri}?mode=global`;
    let t2;
    if ($[3] !== homepageTitle) {
        t2 = homepageTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $15140e42b692bfde$var$i18n.CustomHomeLink);
        $[3] = homepageTitle;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== fireClickAnalytics || $[6] !== isSelected || $[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            href: t1,
            elemBefore: (0, $cxU8R.HomeIconComponent),
            isSelected: isSelected,
            onClick: fireClickAnalytics
        }, t2);
        $[5] = fireClickAnalytics;
        $[6] = isSelected;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
};



























var $gnkil = parcelRequire("gnkil");


var $euozR = parcelRequire("euozR");


var $9vJRo = parcelRequire("9vJRo");





var $9wGTI = parcelRequire("9wGTI");


var $aKkeT = parcelRequire("aKkeT");








var $4ByCJ = parcelRequire("4ByCJ");


const $b9c6e796d679cd96$var$EditorForYouSpotlightLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "js-_l",
    name: "EditorForYouSpotlightLoader",
    loader: async ()=>(await (parcelRequire("eOScq"))).EditorForYouSpotlight
});

const $b9c6e796d679cd96$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("ecTjk"))).fireHomeClickedAnalytics);
const $b9c6e796d679cd96$var$isOnHomeSelector = {
    selector: (routeUrl)=>{
        if (!routeUrl) return false;
        return routeUrl === (0, $1NBp8.HOME).toUrl() || routeUrl === (0, $1NBp8.WIKI).toUrl();
    }
};
const $b9c6e796d679cd96$export$bad442268319468b = ()=>{
    const $ = (0, $bDgLe.c)(9);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireClickAnalytics = $b9c6e796d679cd96$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const isSelected = (0, $dPJCf.useRouteUrl)($b9c6e796d679cd96$var$isOnHomeSelector);
    const isEditorOpen = (0, $euozR.useIsEditorOpen)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $1NBp8.HOME).toUrl();
        $[0] = t0;
    } else t0 = $[0];
    const homeUrl = t0;
    const t1 = !isEditorOpen ? (0, $gnkil.GO_HOME_SHORTCUT) : undefined;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $1LksZ.i18n).forYou);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== fireClickAnalytics || $[3] !== isSelected) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9vJRo.HomeOnboardingTakeoverV2HomeNudge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b9c6e796d679cd96$var$EditorForYouSpotlightLoader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            href: homeUrl,
            elemBefore: (0, $cxU8R.ForYouIconComponent),
            isSelected: isSelected,
            onClick: fireClickAnalytics
        }, t2)));
        $[2] = fireClickAnalytics;
        $[3] = isSelected;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== fireClickAnalytics || $[6] !== t1 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aKkeT.KeyboardShortcutWrapper), {
            href: homeUrl,
            deprecatedKeyboardShortcut: t1,
            keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_HOME_SHORTCUT),
            isAppNavigationShortcut: true,
            onShortcutTriggered: fireClickAnalytics
        }, t3);
        $[5] = fireClickAnalytics;
        $[6] = t1;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
const $b9c6e796d679cd96$export$e0de4d71efbccd92 = ()=>{
    const $ = (0, $bDgLe.c)(7);
    const { forYouItem: forYouItem } = (0, $4ByCJ.useForYouConfig)();
    if (!forYouItem) return null;
    const { isSelected: isSelected, ItemWrapper: ItemWrapper } = forYouItem;
    const url = forYouItem.url ?? "";
    const Wrapper = ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $1LksZ.i18n).forYou);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== isSelected || $[2] !== url) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            href: url,
            elemBefore: (0, $cxU8R.ForYouIconComponent),
            isSelected: isSelected
        }, t0);
        $[1] = isSelected;
        $[2] = url;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== Wrapper || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, null, t1);
        $[4] = Wrapper;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
const $b9c6e796d679cd96$export$d16f83425c70386f = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $9wGTI.fg)("navx-global-side-nav-confluence") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b9c6e796d679cd96$export$e0de4d71efbccd92, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b9c6e796d679cd96$export$bad442268319468b, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};















var $91jNq = parcelRequire("91jNq");

var $cVdZm = parcelRequire("cVdZm");

var $9aB3o = parcelRequire("9aB3o");














var $irVI7 = parcelRequire("irVI7");





var $aJPUt = parcelRequire("aJPUt");























var $XO4by = parcelRequire("XO4by");


var $9cHD3 = parcelRequire("9cHD3");










const $3bf409fa34ce0763$export$27f33b8cbd60853b = (menuId, isSelected, isHidden, peekingId, setPeekingId)=>{
    const $ = (0, $bDgLe.c)(14);
    const isPeeking = isSelected && isHidden;
    const [isAnyFlyoutPeeking] = (0, $6adZX.useIsFlyoutOpen)(peekingId);
    let t0;
    if ($[0] !== isAnyFlyoutPeeking || $[1] !== isPeeking || $[2] !== menuId || $[3] !== peekingId || $[4] !== setPeekingId) {
        t0 = ()=>{
            const peekingInState = peekingId === menuId;
            if (setPeekingId) {
                if (isPeeking && !peekingInState && !isAnyFlyoutPeeking) setPeekingId(menuId);
                if (!isPeeking && peekingInState) setPeekingId(undefined);
            }
        };
        $[0] = isAnyFlyoutPeeking;
        $[1] = isPeeking;
        $[2] = menuId;
        $[3] = peekingId;
        $[4] = setPeekingId;
        $[5] = t0;
    } else t0 = $[5];
    let t1;
    if ($[6] !== isAnyFlyoutPeeking || $[7] !== isHidden || $[8] !== isPeeking || $[9] !== isSelected || $[10] !== menuId || $[11] !== peekingId || $[12] !== setPeekingId) {
        t1 = [
            isHidden,
            peekingId,
            setPeekingId,
            menuId,
            isSelected,
            isPeeking,
            isAnyFlyoutPeeking
        ];
        $[6] = isAnyFlyoutPeeking;
        $[7] = isHidden;
        $[8] = isPeeking;
        $[9] = isSelected;
        $[10] = menuId;
        $[11] = peekingId;
        $[12] = setPeekingId;
        $[13] = t1;
    } else t1 = $[13];
    (0, $cozmU.useEffect)(t0, t1);
    return !!(isHidden && !isPeeking);
};



const $43bbe423a7434a33$export$af1f39df90a1145e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r-0zb",
    name: "RecentContentMenuLoader",
    loader: async ()=>(await (parcelRequire("hjBFA"))).RecentContentMenu,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9cHD3.ContentMenuLoadingState), null)
});

const $43bbe423a7434a33$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("ecTjk"))).fireRecentsClickedAnalytics);
const $43bbe423a7434a33$var$MENU_ID = 'recent';
const $43bbe423a7434a33$export$f1cccf52bb5faf3f = (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const { isFlyoutOpen: isFlyoutOpen, openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyout)($43bbe423a7434a33$var$MENU_ID);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasBeenOpenedBefore = (0, $cozmU.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireClickAnalytics = $43bbe423a7434a33$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isEditorOpen = (0, $euozR.useIsEditorOpen)();
    let t1;
    if ($[0] !== experienceTracker) {
        t1 = ()=>{
            experienceTracker.abort({
                name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
                reason: "Primary dropdown menu: closed by user",
                attributes: {
                    navVersion: "4",
                    dropdownType: "recent"
                }
            });
        };
        $[0] = experienceTracker;
        $[1] = t1;
    } else t1 = $[1];
    const abortExperienceTracker = t1;
    let t2;
    if ($[2] !== experienceTracker) {
        t2 = ()=>{
            experienceTracker.start({
                name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
                attributes: {
                    navVersion: "4",
                    dropdownType: "recent"
                }
            });
        };
        $[2] = experienceTracker;
        $[3] = t2;
    } else t2 = $[3];
    const startExperienceTracker = t2;
    let t3;
    if ($[4] !== abortExperienceTracker || $[5] !== closeFlyout || $[6] !== fireClickAnalytics || $[7] !== isFlyoutOpen || $[8] !== openFlyout) {
        t3 = (newIsOpen)=>{
            if (!newIsOpen) {
                abortExperienceTracker();
                isFlyoutOpen && closeFlyout();
                if (hasBeenOpenedBefore.current) fireClickAnalytics(false);
            } else {
                openFlyout();
                hasBeenOpenedBefore.current = true;
            }
        };
        $[4] = abortExperienceTracker;
        $[5] = closeFlyout;
        $[6] = fireClickAnalytics;
        $[7] = isFlyoutOpen;
        $[8] = openFlyout;
        $[9] = t3;
    } else t3 = $[9];
    const onOpenChange = t3;
    let t4;
    if ($[10] !== fireClickAnalytics || $[11] !== isFlyoutOpen || $[12] !== isHidden || $[13] !== openFlyout || $[14] !== startExperienceTracker) {
        t4 = ()=>{
            if (!isFlyoutOpen) {
                fireClickAnalytics(true, true, isHidden);
                startExperienceTracker();
                openFlyout();
            }
        };
        $[10] = fireClickAnalytics;
        $[11] = isFlyoutOpen;
        $[12] = isHidden;
        $[13] = openFlyout;
        $[14] = startExperienceTracker;
        $[15] = t4;
    } else t4 = $[15];
    const onShortcutTriggered = t4;
    let t5;
    if ($[16] !== closeFlyout || $[17] !== fireClickAnalytics || $[18] !== isFlyoutOpen || $[19] !== openFlyout || $[20] !== startExperienceTracker) {
        t5 = ()=>{
            if (!isFlyoutOpen) {
                openFlyout();
                startExperienceTracker();
                fireClickAnalytics(true);
            } else closeFlyout();
        };
        $[16] = closeFlyout;
        $[17] = fireClickAnalytics;
        $[18] = isFlyoutOpen;
        $[19] = openFlyout;
        $[20] = startExperienceTracker;
        $[21] = t5;
    } else t5 = $[21];
    const onClick = t5;
    let t6;
    if ($[22] !== cloudId || $[23] !== isFlyoutOpen) {
        t6 = ()=>{
            if (!isFlyoutOpen) {
                $43bbe423a7434a33$export$af1f39df90a1145e.preload();
                (0, $XO4by.preloadRecentContentMenu)(cloudId);
            }
        };
        $[22] = cloudId;
        $[23] = isFlyoutOpen;
        $[24] = t6;
    } else t6 = $[24];
    const onHover = t6;
    const isSelected = (0, $dPJCf.useRouteUrl)($43bbe423a7434a33$var$isOnRecentRoute);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)($43bbe423a7434a33$var$MENU_ID, isSelected || isFlyoutOpen, isHidden, peekingId, setPeekingId);
    const t7 = !isEditorOpen ? (0, $gnkil.GO_TO_RECENT_SHORTCUT) : undefined;
    let t8;
    if ($[25] !== closeFlyout || $[26] !== isFlyoutOpen || $[27] !== isSelected || $[28] !== onClick || $[29] !== onHover || $[30] !== onOpenChange || $[31] !== shouldHide) {
        t8 = !shouldHide && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            onMouseEnter: onHover,
            onFocus: onHover
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91jNq.FlyoutMenuItem), {
            onOpenChange: onOpenChange,
            isOpen: isFlyoutOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9aB3o.FlyoutMenuItemTrigger), {
            elemBefore: (0, $cxU8R.ClockIconComponent),
            onClick: onClick,
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $1LksZ.i18n).recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVdZm.FlyoutMenuItemContent), {
            onClose: ()=>isFlyoutOpen && closeFlyout(),
            autoFocus: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($43bbe423a7434a33$export$af1f39df90a1145e, null))));
        $[25] = closeFlyout;
        $[26] = isFlyoutOpen;
        $[27] = isSelected;
        $[28] = onClick;
        $[29] = onHover;
        $[30] = onOpenChange;
        $[31] = shouldHide;
        $[32] = t8;
    } else t8 = $[32];
    let t9;
    if ($[33] !== onShortcutTriggered || $[34] !== t7 || $[35] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aKkeT.KeyboardShortcutWrapper), {
            deprecatedKeyboardShortcut: t7,
            keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_TO_RECENT_SHORTCUT),
            isAppNavigationShortcut: true,
            onShortcutTriggered: onShortcutTriggered
        }, t8);
        $[33] = onShortcutTriggered;
        $[34] = t7;
        $[35] = t8;
        $[36] = t9;
    } else t9 = $[36];
    return t9;
};
const $43bbe423a7434a33$var$isOnRecentRoute = {
    selector: (routeUrl)=>routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'recent'
        })
};





























































var $eLFsG = parcelRequire("eLFsG");






const $d78d93494cd6b93d$export$17b89e6a36c6b530 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ayHpY",
    name: "StarredContentMenuLoader",
    loader: async ()=>(await (parcelRequire("E8xvU"))).StarredContentMenu,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9cHD3.ContentMenuLoadingState), null)
});

const $d78d93494cd6b93d$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("ecTjk"))).fireStarredClickedAnalytics);
const $d78d93494cd6b93d$var$MENU_ID = 'starred';
const $d78d93494cd6b93d$export$d11aa717bebc8f86 = (t0)=>{
    const $ = (0, $bDgLe.c)(46);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const { isFlyoutOpen: isFlyoutOpen, openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyout)($d78d93494cd6b93d$var$MENU_ID);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const hasBeenOpenedBefore = (0, $cozmU.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireClickAnalytics = $d78d93494cd6b93d$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isEditorOpen = (0, $euozR.useIsEditorOpen)();
    let t1;
    if ($[0] !== experienceTracker) {
        t1 = ()=>{
            experienceTracker.abort({
                name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
                reason: "Primary dropdown menu: closed by user",
                attributes: {
                    navVersion: "4",
                    dropdownType: "starred"
                }
            });
        };
        $[0] = experienceTracker;
        $[1] = t1;
    } else t1 = $[1];
    const abortExperienceTracker = t1;
    let t2;
    if ($[2] !== experienceTracker) {
        t2 = ()=>{
            experienceTracker.start({
                name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
                attributes: {
                    navVersion: "4",
                    dropdownType: "starred"
                }
            });
        };
        $[2] = experienceTracker;
        $[3] = t2;
    } else t2 = $[3];
    const startExperienceTracker = t2;
    let t3;
    if ($[4] !== abortExperienceTracker || $[5] !== closeFlyout || $[6] !== fireClickAnalytics || $[7] !== isFlyoutOpen || $[8] !== openFlyout) {
        t3 = (newIsOpen)=>{
            if (!newIsOpen) {
                abortExperienceTracker();
                if (hasBeenOpenedBefore.current) fireClickAnalytics(false);
                isFlyoutOpen && closeFlyout();
            } else {
                openFlyout();
                hasBeenOpenedBefore.current = true;
            }
        };
        $[4] = abortExperienceTracker;
        $[5] = closeFlyout;
        $[6] = fireClickAnalytics;
        $[7] = isFlyoutOpen;
        $[8] = openFlyout;
        $[9] = t3;
    } else t3 = $[9];
    const onOpenChange = t3;
    let t4;
    if ($[10] !== fireClickAnalytics || $[11] !== isFlyoutOpen || $[12] !== isHidden || $[13] !== openFlyout || $[14] !== startExperienceTracker) {
        t4 = ()=>{
            if (!isFlyoutOpen) {
                fireClickAnalytics(true, true, isHidden);
                startExperienceTracker();
                openFlyout();
            }
        };
        $[10] = fireClickAnalytics;
        $[11] = isFlyoutOpen;
        $[12] = isHidden;
        $[13] = openFlyout;
        $[14] = startExperienceTracker;
        $[15] = t4;
    } else t4 = $[15];
    const onShortcutTriggered = t4;
    let t5;
    if ($[16] !== closeFlyout || $[17] !== fireClickAnalytics || $[18] !== isFlyoutOpen || $[19] !== openFlyout || $[20] !== startExperienceTracker) {
        t5 = ()=>{
            if (!isFlyoutOpen) {
                openFlyout();
                startExperienceTracker();
                fireClickAnalytics(true);
            } else closeFlyout();
        };
        $[16] = closeFlyout;
        $[17] = fireClickAnalytics;
        $[18] = isFlyoutOpen;
        $[19] = openFlyout;
        $[20] = startExperienceTracker;
        $[21] = t5;
    } else t5 = $[21];
    const onClick = t5;
    let t6;
    if ($[22] !== isFlyoutOpen) {
        t6 = ()=>{
            if (!isFlyoutOpen) {
                $d78d93494cd6b93d$export$17b89e6a36c6b530.preload();
                (0, $eLFsG.preloadStarredContentMenu)();
            }
        };
        $[22] = isFlyoutOpen;
        $[23] = t6;
    } else t6 = $[23];
    const onHover = t6;
    const isSelected = (0, $dPJCf.useRouteUrl)($d78d93494cd6b93d$var$isOnStarredRoute);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)($d78d93494cd6b93d$var$MENU_ID, isSelected || isFlyoutOpen, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    const t7 = !isEditorOpen ? (0, $gnkil.GO_TO_STARRED_SHORTCUT) : undefined;
    let t8;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $1LksZ.i18n).starred);
        $[24] = t8;
    } else t8 = $[24];
    let t9;
    if ($[25] !== isSelected || $[26] !== onClick) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9aB3o.FlyoutMenuItemTrigger), {
            elemBefore: (0, $cxU8R.StarIconComponent),
            onClick: onClick,
            isSelected: isSelected
        }, t8);
        $[25] = isSelected;
        $[26] = onClick;
        $[27] = t9;
    } else t9 = $[27];
    let t10;
    if ($[28] !== closeFlyout || $[29] !== isFlyoutOpen) {
        t10 = ()=>isFlyoutOpen && closeFlyout();
        $[28] = closeFlyout;
        $[29] = isFlyoutOpen;
        $[30] = t10;
    } else t10 = $[30];
    let t11;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d78d93494cd6b93d$export$17b89e6a36c6b530, null);
        $[31] = t11;
    } else t11 = $[31];
    let t12;
    if ($[32] !== t10) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVdZm.FlyoutMenuItemContent), {
            onClose: t10,
            autoFocus: false
        }, t11);
        $[32] = t10;
        $[33] = t12;
    } else t12 = $[33];
    let t13;
    if ($[34] !== isFlyoutOpen || $[35] !== onOpenChange || $[36] !== t12 || $[37] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91jNq.FlyoutMenuItem), {
            onOpenChange: onOpenChange,
            isOpen: isFlyoutOpen
        }, t9, t12);
        $[34] = isFlyoutOpen;
        $[35] = onOpenChange;
        $[36] = t12;
        $[37] = t9;
        $[38] = t13;
    } else t13 = $[38];
    let t14;
    if ($[39] !== onHover || $[40] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            onMouseEnter: onHover,
            onFocus: onHover
        }, t13);
        $[39] = onHover;
        $[40] = t13;
        $[41] = t14;
    } else t14 = $[41];
    let t15;
    if ($[42] !== onShortcutTriggered || $[43] !== t14 || $[44] !== t7) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aKkeT.KeyboardShortcutWrapper), {
            deprecatedKeyboardShortcut: t7,
            keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_TO_STARRED_SHORTCUT),
            isAppNavigationShortcut: true,
            onShortcutTriggered: onShortcutTriggered
        }, t14);
        $[42] = onShortcutTriggered;
        $[43] = t14;
        $[44] = t7;
        $[45] = t15;
    } else t15 = $[45];
    return t15;
};
const $d78d93494cd6b93d$var$isOnStarredRoute = {
    selector: (routeUrl)=>routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'starred'
        })
};






















var $5WLjq = parcelRequire("5WLjq");













parcelRequire("a0CEX");
var $7peCC = parcelRequire("7peCC");

















var $6mKj3 = parcelRequire("6mKj3");


var $fafDF = parcelRequire("fafDF");








const $b163ca06b80c33e1$var$spacesDropdownUpdatedEmptyStateProps = {
    updatedEmptyState: (0, $fafDF.SpacesEmptyStateLoader)
};
const $b163ca06b80c33e1$var$MENU_ID = 'spaces';

const $b163ca06b80c33e1$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("ecTjk"))).fireSpacesClickedAnalytics);
const $b163ca06b80c33e1$export$e60b35895fc7fef7 = (t0)=>{
    const $ = (0, $bDgLe.c)(38);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const { isFlyoutOpen: isFlyoutOpen, openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyout)($b163ca06b80c33e1$var$MENU_ID);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const selectedSpaceKey = spaceKey;
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const isMounted = (0, $cozmU.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireClickAnalytics = $b163ca06b80c33e1$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== experienceTracker) {
        t1 = ()=>{
            experienceTracker.abort({
                name: (0, $irVI7.APP_NAV_SPACES_DROPDOWN_EXPERIENCE),
                reason: "Primary dropdown menu: closed by user",
                attributes: {
                    navVersion: "4",
                    dropdownType: "spaces"
                }
            });
        };
        $[0] = experienceTracker;
        $[1] = t1;
    } else t1 = $[1];
    const abortExperienceTracker = t1;
    let t2;
    if ($[2] !== experienceTracker) {
        t2 = ()=>{
            experienceTracker.start({
                name: (0, $irVI7.APP_NAV_SPACES_DROPDOWN_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
                attributes: {
                    navVersion: "4",
                    dropdownType: "spaces"
                }
            });
        };
        $[2] = experienceTracker;
        $[3] = t2;
    } else t2 = $[3];
    const startExperienceTracker = t2;
    let t3;
    if ($[4] !== abortExperienceTracker || $[5] !== closeFlyout || $[6] !== fireClickAnalytics || $[7] !== isFlyoutOpen || $[8] !== openFlyout) {
        t3 = (newIsOpen)=>{
            if (!isMounted.current) {
                isMounted.current = true;
                return;
            }
            if (!newIsOpen) {
                abortExperienceTracker();
                fireClickAnalytics(false);
                isFlyoutOpen && closeFlyout();
            } else openFlyout();
        };
        $[4] = abortExperienceTracker;
        $[5] = closeFlyout;
        $[6] = fireClickAnalytics;
        $[7] = isFlyoutOpen;
        $[8] = openFlyout;
        $[9] = t3;
    } else t3 = $[9];
    const onOpenChange = t3;
    let t4;
    if ($[10] !== closeFlyout || $[11] !== fireClickAnalytics || $[12] !== isFlyoutOpen || $[13] !== openFlyout || $[14] !== startExperienceTracker) {
        t4 = ()=>{
            if (!isFlyoutOpen) {
                openFlyout();
                startExperienceTracker();
                fireClickAnalytics(true);
            } else closeFlyout();
        };
        $[10] = closeFlyout;
        $[11] = fireClickAnalytics;
        $[12] = isFlyoutOpen;
        $[13] = openFlyout;
        $[14] = startExperienceTracker;
        $[15] = t4;
    } else t4 = $[15];
    const onClick = t4;
    let t5;
    if ($[16] !== isFlyoutOpen || $[17] !== isLicensed || $[18] !== selectedSpaceKey) {
        t5 = ()=>{
            if (!isFlyoutOpen) {
                (0, $7peCC.SpacesDropdownLoader).preload();
                if (selectedSpaceKey) (0, $5WLjq.preloadSpacesList)({
                    isLicensed: isLicensed,
                    selectedSpaceKey: selectedSpaceKey
                });
            }
        };
        $[16] = isFlyoutOpen;
        $[17] = isLicensed;
        $[18] = selectedSpaceKey;
        $[19] = t5;
    } else t5 = $[19];
    const onMouseEnter = t5;
    const isSelected = (0, $dPJCf.useRouteName)($b163ca06b80c33e1$var$isOnSpacesRoute);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)($b163ca06b80c33e1$var$MENU_ID, isSelected || isFlyoutOpen, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t6;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $1LksZ.i18n).spaces);
        $[20] = t6;
    } else t6 = $[20];
    let t7;
    if ($[21] !== isSelected || $[22] !== onClick) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9aB3o.FlyoutMenuItemTrigger), {
            elemBefore: (0, $6mKj3.expVal)("confluence_space_icon_update", "isEnabled", false) ? (0, $cxU8R.SpacesIconComponent) : (0, $cxU8R.GlobeIconComponent),
            onClick: onClick,
            isSelected: isSelected
        }, t6);
        $[21] = isSelected;
        $[22] = onClick;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== closeFlyout || $[25] !== isFlyoutOpen) {
        t8 = ()=>isFlyoutOpen && closeFlyout();
        $[24] = closeFlyout;
        $[25] = isFlyoutOpen;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7peCC.SpacesDropdownLoader), {
            closePopup: undefined,
            ...$b163ca06b80c33e1$var$spacesDropdownUpdatedEmptyStateProps
        });
        $[27] = t9;
    } else t9 = $[27];
    let t10;
    if ($[28] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVdZm.FlyoutMenuItemContent), {
            onClose: t8,
            autoFocus: false
        }, t9);
        $[28] = t8;
        $[29] = t10;
    } else t10 = $[29];
    let t11;
    if ($[30] !== isFlyoutOpen || $[31] !== onOpenChange || $[32] !== t10 || $[33] !== t7) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91jNq.FlyoutMenuItem), {
            onOpenChange: onOpenChange,
            isOpen: isFlyoutOpen
        }, t7, t10);
        $[30] = isFlyoutOpen;
        $[31] = onOpenChange;
        $[32] = t10;
        $[33] = t7;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== onMouseEnter || $[36] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            onMouseEnter: onMouseEnter,
            onFocus: onMouseEnter
        }, t11));
        $[35] = onMouseEnter;
        $[36] = t11;
        $[37] = t12;
    } else t12 = $[37];
    return t12;
};
const $b163ca06b80c33e1$var$isOnSpacesRoute = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_DIRECTORY).name
};












var $KDAt0 = parcelRequire("KDAt0");





var $d5um7 = parcelRequire("d5um7");

var $jZuGB = parcelRequire("jZuGB");

var $gMhPZ = parcelRequire("gMhPZ");























var $3b6WO = parcelRequire("3b6WO");






























var $a9aSv = parcelRequire("a9aSv");


var $Tqphp = parcelRequire("Tqphp");


var $iMnC5 = parcelRequire("iMnC5");














var $gmhHk = parcelRequire("gmhHk");

var $4X3mP = parcelRequire("4X3mP");








var $9fBoq = parcelRequire("9fBoq");











var $5tgcI = parcelRequire("5tgcI");


var $g0ob9 = parcelRequire("g0ob9");


const $f16994fe41446773$var$AsyncDiscoverSection = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ABCqb",
    name: "AsyncDiscoverSection",
    loader: async ()=>(await (parcelRequire("3JnRC"))).DiscoverSection
});

const $f16994fe41446773$var$AsyncDiscoverSectionPostOffice = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ZPSeQ",
    name: "AsyncDiscoverSectionPostOffice",
    loader: async ()=>(await (parcelRequire("euip2"))).DiscoverSectionPostOffice
});
const $f16994fe41446773$var$DISCOVER_URL = `${(0, $jlIaF.CONTEXT_PATH)}/marketplace`;
const $f16994fe41446773$export$a8ebc8242442c256 = (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { loading: loading, webItems: webItems, extensions: extensions } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent) {
        t1 = (itemId)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "navigationItem",
                        actionSubjectId: "appsNavigationMenuItem",
                        source: "globalNavigation",
                        attributes: {
                            navigationLayer: "global",
                            navigationContainer: "sidebar",
                            navVersion: "4",
                            componentType: "customItem",
                            itemType: "app",
                            itemId: itemId,
                            section: "yourApps"
                        }
                    }
                }).fire();
            };
        $[0] = createAnalyticsEvent;
        $[1] = t1;
    } else t1 = $[1];
    const fireAppsNavigationItemClicked = t1;
    const location = (0, $KDAt0.useLocation)();
    const hasApps = webItems.length > 0 || extensions.length > 0;
    const displayApps = hasApps && !loading;
    let t2;
    if ($[2] !== displayApps) {
        t2 = displayApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4X3mP.MenuSectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f16994fe41446773$var$i18n.yourApps));
        $[2] = displayApps;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== displayApps || $[5] !== extensions || $[6] !== fireAppsNavigationItemClicked || $[7] !== location?.pathname || $[8] !== webItems) {
        t3 = displayApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f16994fe41446773$var$AppItems, {
            webItems: webItems,
            extensions: extensions,
            pathname: location?.pathname || "",
            fireAppsNavigationItemClicked: fireAppsNavigationItemClicked
        });
        $[4] = displayApps;
        $[5] = extensions;
        $[6] = fireAppsNavigationItemClicked;
        $[7] = location?.pathname;
        $[8] = webItems;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== loading) {
        t4 = loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f16994fe41446773$var$LoadingSkeletons, null);
        $[10] = loading;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== t3 || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, t3, t4);
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== t2 || $[16] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gmhHk.MenuSection), null, t2, t5);
        $[15] = t2;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $9wGTI.fg)("confluence_nav_4_apps_menu_recommend") && ((0, $6mKj3.expVal)("enable_confluence_sidenav_2p_app_recommendations", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f16994fe41446773$var$AsyncDiscoverSectionPostOffice, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f16994fe41446773$var$AsyncDiscoverSection, null));
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== fireAppsNavigationItemClicked || $[20] !== hasApps || $[21] !== loading || $[22] !== location?.pathname) {
        t8 = (0, $3ricL.isFeatureEnabled)("adminhub", "adminhub-apps-discovery") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gmhHk.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            isSelected: location?.pathname?.includes($f16994fe41446773$var$DISCOVER_URL),
            href: $f16994fe41446773$var$DISCOVER_URL,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Tqphp))), {
                label: "",
                color: "currentColor"
            }),
            onClick: fireAppsNavigationItemClicked("exploreApps")
        }, loading || hasApps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f16994fe41446773$var$i18n.exploreMoreApps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f16994fe41446773$var$i18n.exploreApps))));
        $[19] = fireAppsNavigationItemClicked;
        $[20] = hasApps;
        $[21] = loading;
        $[22] = location?.pathname;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== t6 || $[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t6, t7, t8);
        $[24] = t6;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
};
const $f16994fe41446773$var$AppItems = (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { webItems: webItems, extensions: extensions, pathname: pathname, fireAppsNavigationItemClicked: fireAppsNavigationItemClicked } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== fireAppsNavigationItemClicked || $[1] !== intl || $[2] !== pathname || $[3] !== webItems) {
        let t2;
        if ($[5] !== fireAppsNavigationItemClicked || $[6] !== intl || $[7] !== pathname) {
            t2 = (t3)=>{
                const { id: id, url: url, label: label, icon: icon, completeKey: completeKey, styleClass: styleClass } = t3;
                const title = completeKey === (0, $5tgcI.ANALYTICS_KEY) ? intl.formatMessage($f16994fe41446773$var$i18n.analyticsTitle) : label;
                const href = $f16994fe41446773$var$fixWebItemUrl(url, completeKey);
                const injectStyleClass = (element)=>{
                    if (element === null) return;
                    if (typeof styleClass !== "string" || styleClass.length === 0) return;
                    const classList = styleClass.split(" ");
                    element.classList.add(...classList);
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
                    key: id,
                    ref: injectStyleClass,
                    href: href,
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g0ob9.AppIcon), {
                        url: icon?.path,
                        completeKey: completeKey
                    }),
                    isSelected: $f16994fe41446773$var$getIsSelected(pathname, href),
                    onClick: fireAppsNavigationItemClicked(completeKey)
                }, title);
            };
            $[5] = fireAppsNavigationItemClicked;
            $[6] = intl;
            $[7] = pathname;
            $[8] = t2;
        } else t2 = $[8];
        t1 = webItems.map(t2);
        $[0] = fireAppsNavigationItemClicked;
        $[1] = intl;
        $[2] = pathname;
        $[3] = webItems;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[9] !== extensions || $[10] !== pathname) {
        let t3;
        if ($[12] !== pathname) {
            t3 = (extension)=>{
                const href_0 = (0, $1NBp8.GLOBAL_PAGE_FORGE).toUrl({
                    appId: extension.appId,
                    envId: extension.environmentId,
                    forgeManifestRoute: extension.properties.route
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
                    key: extension.key,
                    href: href_0,
                    isSelected: $f16994fe41446773$var$getIsSelected(pathname, href_0),
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g0ob9.AppIcon), {
                        url: extension.properties.icon
                    })
                }, (0, $9fBoq.extensionTitle)(extension));
            };
            $[12] = pathname;
            $[13] = t3;
        } else t3 = $[13];
        t2 = extensions.map(t3);
        $[9] = extensions;
        $[10] = pathname;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[14] !== t1 || $[15] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, t2);
        $[14] = t1;
        $[15] = t2;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
};
const $f16994fe41446773$var$LoadingSkeletons = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlockStart: "space.100",
            testId: "loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "20px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "20px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "20px"
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $f16994fe41446773$var$absoluteUrlCheck = new RegExp('^(?:[a-z]+:)?//', 'i');
const $f16994fe41446773$var$fixWebItemUrl = (url, completeKey)=>{
    if (!url) return '#';
    if (completeKey === (0, $5tgcI.ANALYTICS_KEY) || completeKey === (0, $5tgcI.ANALYTICS_KEY_MODERATE)) return (0, $1NBp8.SITE_ANALYTICS).toUrl();
    if ($f16994fe41446773$var$absoluteUrlCheck.test(url)) return url;
    if (url.startsWith((0, $jlIaF.CONTEXT_PATH))) return url;
    return `${0, $jlIaF.CONTEXT_PATH}${url}`;
};
const $f16994fe41446773$var$getIsSelected = (pathname, href)=>{
    const hrefWithoutQuery = href.split('?')[0];
    return pathname === hrefWithoutQuery;
};
const $f16994fe41446773$var$i18n = (0, $kSwu1.defineMessages)({
    yourApps: {
        id: "side-navigation.global.apps.your-apps",
        defaultMessage: "Your apps"
    },
    exploreApps: {
        id: "side-navigation.global.apps.explore-apps",
        defaultMessage: "Explore apps"
    },
    exploreMoreApps: {
        id: "side-navigation.global.apps.explore-more-apps",
        defaultMessage: "Explore more apps"
    },
    analyticsTitle: {
        id: "side-navigation.global.apps.analytics.label",
        defaultMessage: "Analytics"
    }
});












var $6TaGl = parcelRequire("6TaGl");





var $1sCHt = parcelRequire("1sCHt");


var $4n1IT = parcelRequire("4n1IT");


var $8oBbn = parcelRequire("8oBbn");


var $6IL1T = parcelRequire("6IL1T");














const $b1f880ba7abf8fa5$var$useLazyClickMoreActionsAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("eVSUv"))).fireAppsMoreActionsButtonClicked);

const $b1f880ba7abf8fa5$var$useLazyClickMoreActionsItemAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("eVSUv"))).fireAppsMoreActionsDropdownItemClicked);
const $b1f880ba7abf8fa5$export$a70b62f9ab9df290 = ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireClickMoreActionsAnalytics = $b1f880ba7abf8fa5$var$useLazyClickMoreActionsAnalytics(createAnalyticsEvent);
    let t0;
    if ($[0] !== fireClickMoreActionsAnalytics) {
        t0 = ()=>{
            setIsOpen($b1f880ba7abf8fa5$var$_temp);
            fireClickMoreActionsAnalytics();
        };
        $[0] = fireClickMoreActionsAnalytics;
        $[1] = t0;
    } else t0 = $[1];
    const onClick = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setIsOpen(false);
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== onClick) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                icon: $b1f880ba7abf8fa5$var$_temp3,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $b1f880ba7abf8fa5$var$i18n.moreActions),
                onClick: onClick,
                spacing: "compact",
                appearance: "subtle",
                ...triggerProps
            });
        $[3] = onClick;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== isOpen || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            isOpen: isOpen,
            onClose: t1,
            content: $b1f880ba7abf8fa5$var$_temp2,
            trigger: t2,
            placement: "bottom-start",
            shouldRenderToParent: true
        });
        $[5] = isOpen;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
const $b1f880ba7abf8fa5$var$AppsMoreActionsMenuContent = ()=>{
    const $ = (0, $bDgLe.c)(13);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { environment: environment, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const fireClickMoreActionsItemManageAppsAnalytics = $b1f880ba7abf8fa5$var$useLazyClickMoreActionsItemAnalytics(createAnalyticsEvent, "manageApps");
    const fireClickMoreActionsItemAppAuditLogsAnalytics = $b1f880ba7abf8fa5$var$useLazyClickMoreActionsItemAnalytics(createAnalyticsEvent, "appAuditLogs");
    const fireClickMoreActionsItemViewAppRequestsAnalytics = $b1f880ba7abf8fa5$var$useLazyClickMoreActionsItemAnalytics(createAnalyticsEvent, "viewAppRequests");
    const adminHubBaseUrl = environment == "PRODUCTION" ? "https://admin.atlassian.com" : "https://admin.stg.atlassian.com";
    const adminHubAppRequestsUrl = `${adminHubBaseUrl}/s/${cloudId}/user-connected-apps/tab/requested`;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $1NBp8.DEFAULT_ADMIN_MANAGE_APPS).toUrl();
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $b1f880ba7abf8fa5$var$i18n.manageApps);
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== fireClickMoreActionsItemManageAppsAnalytics) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
            href: t0,
            target: "_blank",
            onClick: fireClickMoreActionsItemManageAppsAnalytics
        }, t1);
        $[2] = fireClickMoreActionsItemManageAppsAnalytics;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== fireClickMoreActionsItemAppAuditLogsAnalytics) {
        t3 = (0, $9wGTI.fg)("show_app_audit_logs_upm_dep") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
            href: (0, $1NBp8.ADMIN_APP_AUDIT_LOGS).toUrl(),
            target: "_blank",
            onClick: fireClickMoreActionsItemAppAuditLogsAnalytics
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $b1f880ba7abf8fa5$var$i18n.appAuditLogs));
        $[4] = fireClickMoreActionsItemAppAuditLogsAnalytics;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== adminHubAppRequestsUrl || $[7] !== fireClickMoreActionsItemViewAppRequestsAnalytics) {
        t4 = (0, $9wGTI.fg)("confluence_frontend_enduser-emcee-discover") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
            href: (0, $9wGTI.fg)("should_redirect_to_admin-hub_for_app_requests") ? adminHubAppRequestsUrl : (0, $1NBp8.MARKETPLACE_APP_REQUESTS).toUrl(),
            target: "_blank",
            onClick: fireClickMoreActionsItemViewAppRequestsAnalytics
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $b1f880ba7abf8fa5$var$i18n.viewAppRequests));
        $[6] = adminHubAppRequestsUrl;
        $[7] = fireClickMoreActionsItemViewAppRequestsAnalytics;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, t2, t3, t4);
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
const $b1f880ba7abf8fa5$var$i18n = (0, $kSwu1.defineMessages)({
    moreActions: {
        id: "side-navigation.global.apps.more-actions",
        defaultMessage: "More actions"
    },
    manageApps: {
        id: "side-navigation.global.apps.manage-apps",
        defaultMessage: "Manage apps"
    },
    appAuditLogs: {
        id: "side-navigation.global.apps.app-audit-log",
        defaultMessage: "App audit logs"
    },
    viewAppRequests: {
        id: "side-navigation.global.apps.view-app-requests",
        defaultMessage: "View app requests"
    }
});
function $b1f880ba7abf8fa5$var$_temp(v) {
    return !v;
}
function $b1f880ba7abf8fa5$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1f880ba7abf8fa5$var$AppsMoreActionsMenuContent, null);
}
function $b1f880ba7abf8fa5$var$_temp3(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        ...iconProps,
        size: "small"
    });
}



var $8dUjs = parcelRequire("8dUjs");


const $9b893ee6ed889345$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("ecTjk"))).fireAppsClickedAnalytics);
const $9b893ee6ed889345$export$4c83861e794746b0 = (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const { edition: edition, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireClickAnalytics = $9b893ee6ed889345$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    let t1;
    if ($[0] !== accessStatus || $[1] !== edition) {
        t1 = (0, $8dUjs.getGlobalAppsParams)({
            edition: edition,
            accessStatus: accessStatus
        });
        $[0] = accessStatus;
        $[1] = edition;
        $[2] = t1;
    } else t1 = $[2];
    const { webItemParams: webItemParams, forgeExtensionParams: forgeExtensionParams } = t1;
    const { webItems: webItems, loading: webItemsLoading, error: webItemsError } = (0, $6ld6a.useWebItemLocation)(webItemParams);
    const { extensions: extensions, loading: extensionsLoading, error: extensionsError } = (0, $3b6WO.useExtensionList)(forgeExtensionParams);
    let t2;
    if ($[3] !== webItems) {
        t2 = webItems.map($9b893ee6ed889345$var$_temp);
        $[3] = webItems;
        $[4] = t2;
    } else t2 = $[4];
    const webItemUrls = t2;
    let t3;
    if ($[5] !== extensions) {
        t3 = extensions.map($9b893ee6ed889345$var$_temp2);
        $[5] = extensions;
        $[6] = t3;
    } else t3 = $[6];
    const extensionsUrls = t3;
    const location = (0, $KDAt0.useLocation)();
    let t4;
    if ($[7] !== extensionsUrls || $[8] !== location?.pathname || $[9] !== webItemUrls) {
        t4 = {
            selector: (routeUrl)=>{
                const path = routeUrl || location?.pathname;
                return webItemUrls.some((appUrl_0)=>path.includes(appUrl_0)) || extensionsUrls.some((appUrl)=>path.includes(appUrl)) || path.includes(`${(0, $jlIaF.CONTEXT_PATH)}/marketplace`);
            }
        };
        $[7] = extensionsUrls;
        $[8] = location?.pathname;
        $[9] = webItemUrls;
        $[10] = t4;
    } else t4 = $[10];
    const isOnAppsRoute = (0, $dPJCf.useRouteUrl)(t4);
    const loading = webItemsLoading || extensionsLoading;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("apps", isOnAppsRoute, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t5;
    if ($[11] !== fireClickAnalytics) {
        t5 = (_, __, analyticsAttributes)=>{
            const { isExpanded: isExpanded } = analyticsAttributes;
            fireClickAnalytics(isExpanded);
        };
        $[11] = fireClickAnalytics;
        $[12] = t5;
    } else t5 = $[12];
    const onClick = t5;
    let t6;
    if ($[13] !== isAdmin) {
        t6 = isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1f880ba7abf8fa5$export$a70b62f9ab9df290), null);
        $[13] = isAdmin;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $1LksZ.i18n).apps);
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== onClick || $[17] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMhPZ.ExpandableMenuItemTrigger), {
            elemBefore: (0, $cxU8R.AppsIconComponent),
            actionsOnHover: t6,
            onClick: onClick
        }, t7);
        $[16] = onClick;
        $[17] = t6;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== extensions || $[20] !== loading || $[21] !== webItems) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jZuGB.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f16994fe41446773$export$a8ebc8242442c256), {
            loading: loading,
            webItems: webItems,
            extensions: extensions
        }));
        $[19] = extensions;
        $[20] = loading;
        $[21] = webItems;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== isOnAppsRoute || $[24] !== t8 || $[25] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5um7.ExpandableMenuItem), {
            isDefaultExpanded: isOnAppsRoute
        }, t8, t9);
        $[23] = isOnAppsRoute;
        $[24] = t8;
        $[25] = t9;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== extensionsError || $[28] !== webItemsError) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b893ee6ed889345$var$ErrorFlag, {
            webItemsError: webItemsError,
            extensionsError: extensionsError
        });
        $[27] = extensionsError;
        $[28] = webItemsError;
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== t10 || $[31] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t10, t11);
        $[30] = t10;
        $[31] = t11;
        $[32] = t12;
    } else t12 = $[32];
    return t12;
};
const $9b893ee6ed889345$var$ErrorFlag = (0, $7aRa9.withFlags)(({ webItemsError: webItemsError, extensionsError: extensionsError, flags: flags })=>{
    (0, $cozmU.useEffect)(()=>{
        if (webItemsError || extensionsError) flags.showFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $9b893ee6ed889345$var$errorI18n.errorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $9b893ee6ed889345$var$errorI18n.errorDescription),
            type: 'error',
            close: 'auto'
        });
    }, [
        webItemsError,
        extensionsError,
        flags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, webItemsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: webItemsError
    }), extensionsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: extensionsError
    }));
});
const $9b893ee6ed889345$var$errorI18n = (0, $kSwu1.defineMessages)({
    errorTitle: {
        id: "side-navigation.global.apps.error-title",
        defaultMessage: "We couldn\u2019t load apps"
    },
    errorDescription: {
        id: "side-navigation.global.apps.error-description",
        defaultMessage: "Refresh and try again."
    }
});
function $9b893ee6ed889345$var$_temp(webItem) {
    return (webItem.url || "").split("?")[0];
}
function $9b893ee6ed889345$var$_temp2(extension) {
    return (0, $1NBp8.GLOBAL_PAGE_FORGE).toUrl({
        appId: extension.appId,
        envId: extension.environmentId,
        forgeManifestRoute: extension.properties.route
    });
}





















const $7313825a48cf91f9$export$67e928cbe0262396 = (t0)=>{
    const $ = (0, $bDgLe.c)(1);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("topics", false, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            href: "#",
            elemBefore: (0, $cxU8R.HashIconComponent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $1LksZ.i18n).topics));
        $[0] = t1;
    } else t1 = $[0];
    return t1;
};





















const $d18e4b06ef32e11b$export$cb6e506fa0abf530 = (t0)=>{
    const $ = (0, $bDgLe.c)(1);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("goals", false, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            href: "#",
            elemBefore: (0, $cxU8R.GoalIconComponent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $1LksZ.i18n).goals));
        $[0] = t1;
    } else t1 = $[0];
    return t1;
};


































const $12bdfaacd20fcb4d$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("ecTjk"))).fireTeamsClickedAnalytics);
const $12bdfaacd20fcb4d$var$isOnPeopleRouteArgs = {
    selector: (routeName)=>{
        if (!routeName) return false;
        return routeName === (0, $1NBp8.PEOPLE_DIRECTORY).name;
    }
};
const $12bdfaacd20fcb4d$export$31c02f8c1cc69561 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isSelected = (0, $dPJCf.useRouteName)($12bdfaacd20fcb4d$var$isOnPeopleRouteArgs);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireClickedAnalytics = $12bdfaacd20fcb4d$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("teams", isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.CONFLUENCE_PEOPLE_DIRECTORY_SEARCH).toUrl();
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $1LksZ.i18n).teams);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== fireClickedAnalytics || $[3] !== isSelected) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            href: t1,
            isSelected: isSelected,
            elemBefore: (0, $cxU8R.TeamsIconComponent),
            onClick: fireClickedAnalytics
        }, t2);
        $[2] = fireClickedAnalytics;
        $[3] = isSelected;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};


































const $b246fff4221da373$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("ecTjk"))).fireDraftsClickedAnalytics);
const $b246fff4221da373$var$onDraftSelector = {
    selector: (routeUrl)=>{
        if (!routeUrl) return false;
        return routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'drafts'
        });
    }
};
const $b246fff4221da373$export$cf67e987117d08e0 = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireClickAnalytics = $b246fff4221da373$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const isSelected = (0, $dPJCf.useRouteUrl)($b246fff4221da373$var$onDraftSelector);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("drafts", isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.HOME).toUrl({
            view: "drafts"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $1LksZ.i18n).drafts);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== fireClickAnalytics || $[3] !== isSelected || $[4] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            href: t1,
            elemBefore: (0, $cxU8R.EditIconComponent),
            isSelected: isSelected,
            onClick: fireClickAnalytics
        }, t2);
        $[2] = fireClickAnalytics;
        $[3] = isSelected;
        $[4] = t1;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};


































const $708853e8a76c69ca$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("ecTjk"))).fireTasksClickedAnalytics);
const $708853e8a76c69ca$var$onTasksSelector = {
    selector: (routeUrl)=>{
        if (!routeUrl) return false;
        return routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'tasks'
        });
    }
};
const $708853e8a76c69ca$export$a0a057c2941dc0bc = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireClickAnalytics = $708853e8a76c69ca$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const isSelected = (0, $dPJCf.useRouteUrl)($708853e8a76c69ca$var$onTasksSelector);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("tasks", isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.HOME).toUrl({
            view: "tasks"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $1LksZ.i18n).tasks);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== fireClickAnalytics || $[3] !== isSelected || $[4] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            href: t1,
            elemBefore: (0, $cxU8R.TaskIconComponent),
            isSelected: isSelected,
            onClick: fireClickAnalytics
        }, t2);
        $[2] = fireClickAnalytics;
        $[3] = isSelected;
        $[4] = t1;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};


































const $6f20c917496dda1e$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("ecTjk"))).fireTemplatesClickedAnalytics);
const $6f20c917496dda1e$var$isOnTemplatesSelector = {
    selector: (routeUrl)=>{
        if (!routeUrl) return false;
        return routeUrl.includes((0, $1NBp8.TEMPLATE_GALLERY).toUrl()); //templates adds a bunch of query components
    }
};
const $6f20c917496dda1e$export$9e7802a7d1db8cfc = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireClickAnalytics = $6f20c917496dda1e$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const isSelected = (0, $dPJCf.useRouteUrl)($6f20c917496dda1e$var$isOnTemplatesSelector);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.TEMPLATE_GALLERY).toUrl();
        $[0] = t1;
    } else t1 = $[0];
    const templateUrl = t1;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("templates", isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $1LksZ.i18n).templates);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== fireClickAnalytics || $[3] !== isSelected) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            href: templateUrl,
            elemBefore: (0, $cxU8R.TemplatesIconComponent),
            isSelected: isSelected,
            onClick: fireClickAnalytics
        }, t2);
        $[2] = fireClickAnalytics;
        $[3] = isSelected;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};































const $95245a9bd03c7ad9$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("ecTjk"))).fireCustomizeSidebarClickedAnalytics);
const $95245a9bd03c7ad9$export$249a65f26e2bc7f5 = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId, setIsCustomizeSidebarDialogVisible: setIsCustomizeSidebarDialogVisible } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireClickAnalytics = $95245a9bd03c7ad9$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    let t1;
    if ($[0] !== fireClickAnalytics || $[1] !== setIsCustomizeSidebarDialogVisible) {
        t1 = ()=>{
            setIsCustomizeSidebarDialogVisible(true);
            fireClickAnalytics();
        };
        $[0] = fireClickAnalytics;
        $[1] = setIsCustomizeSidebarDialogVisible;
        $[2] = t1;
    } else t1 = $[2];
    const onClick = t1;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("customize", false, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $1LksZ.i18n).customize);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
            elemBefore: (0, $cxU8R.CustomizeIconComponent),
            onClick: onClick
        }, t2);
        $[4] = onClick;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};






const $ddfb598ef229bd1a$export$7bd12ce5959bde45 = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { shortcutsConfig: shortcutsConfig, customizationMenuConfig: customizationMenuConfig, children: children } = t0;
    const orderedShortcuts = (0, $fd7af3b9b55c9b5d$export$4bb4a114d280c175)(shortcutsConfig, customizationMenuConfig);
    let t1;
    if ($[0] !== children || $[1] !== orderedShortcuts) {
        t1 = children({
            shortcuts: orderedShortcuts
        });
        $[0] = children;
        $[1] = orderedShortcuts;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};






var $1rYMO = parcelRequire("1rYMO");





var $dFlFg = parcelRequire("dFlFg");


var $laxxL = parcelRequire("laxxL");


var $cwUrm = parcelRequire("cwUrm");

const $e42c1a422737c43c$var$SOURCE_APP = 'confluence';
function $e42c1a422737c43c$export$6219d718450662c3(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { cloudId: cloudId, userId: userId, enabled: enabled } = t0;
    let t1;
    if ($[0] !== cloudId) {
        t1 = (0, $cwUrm.buildInvitedAppShortcutsRecommendationsVariables)(cloudId);
        $[0] = cloudId;
        $[1] = t1;
    } else t1 = $[1];
    const variables = t1;
    const t2 = !enabled;
    let t3;
    if ($[2] !== t2 || $[3] !== variables) {
        t3 = {
            interopApolloAggClient: true,
            variables: variables,
            skip: t2
        };
        $[2] = t2;
        $[3] = variables;
        $[4] = t3;
    } else t3 = $[4];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $laxxL.InvitedAppShortcutsRecommendationsQueryNode), {
        ...t3,
        __callerPackage__: "side-navigation"
    });
    const { recommendedApps: recommendedApps, targetProducts: targetProducts } = (0, $dFlFg.useRecommendedApps)(data);
    let t4;
    if ($[5] !== cloudId || $[6] !== enabled || $[7] !== recommendedApps || $[8] !== targetProducts || $[9] !== userId) {
        t4 = enabled ? {
            enabled: true,
            sourceProduct: $e42c1a422737c43c$var$SOURCE_APP,
            targetProducts: targetProducts,
            cloudId: cloudId,
            userId: userId,
            recommendedApps: recommendedApps
        } : {
            enabled: false
        };
        $[5] = cloudId;
        $[6] = enabled;
        $[7] = recommendedApps;
        $[8] = targetProducts;
        $[9] = userId;
        $[10] = t4;
    } else t4 = $[10];
    const resolverResult = (0, $1rYMO.useInvitedAppShortcuts)(t4);
    let t5;
    if ($[11] !== recommendedApps || $[12] !== resolverResult) {
        t5 = {
            recommendedApps: recommendedApps,
            resolverResult: resolverResult
        };
        $[11] = recommendedApps;
        $[12] = resolverResult;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
}



const $7b79f828379224e7$var$CustomizationModalLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Vj9xc",
    name: "CustomizationModalLoader",
    loader: async ()=>{
        const { CustomizationModalComponent: CustomizationModalComponent } = await (parcelRequire("6S8lk"));
        return CustomizationModalComponent;
    }
});
const $7b79f828379224e7$export$311d3c02bd72bcc0 = 'confluence.sidebar.';

const $7b79f828379224e7$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("ecTjk"))).fireMoreMenuClickedAnalytics);
const $7b79f828379224e7$var$hasAccess = (accessStatus)=>![
        (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS,
        null
    ].includes(accessStatus);
const $7b79f828379224e7$var$hasGlobalAppShortcutsAccess = (accessStatus)=>![
        (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        (0, $d9tcB.AccessStatus).EXTERNAL_SHARE_ACCESS,
        (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS,
        (0, $d9tcB.AccessStatus).NOT_PERMITTED,
        null
    ].includes(accessStatus);
const $7b79f828379224e7$var$GlobalItemComponents = {
    customHome: (0, $15140e42b692bfde$export$adaf351fc9d12cd2),
    yourWork: (0, $b9c6e796d679cd96$export$d16f83425c70386f),
    companyHub: (0, $8dN99.CompanyHubItem),
    recent: (0, $43bbe423a7434a33$export$f1cccf52bb5faf3f),
    starred: (0, $d78d93494cd6b93d$export$d11aa717bebc8f86),
    spaces: (0, $b163ca06b80c33e1$export$e60b35895fc7fef7),
    apps: (0, $9b893ee6ed889345$export$4c83861e794746b0),
    goals: (0, $d18e4b06ef32e11b$export$cb6e506fa0abf530),
    topics: (0, $7313825a48cf91f9$export$67e928cbe0262396),
    teams: (0, $12bdfaacd20fcb4d$export$31c02f8c1cc69561),
    drafts: (0, $b246fff4221da373$export$cf67e987117d08e0),
    tasks: (0, $708853e8a76c69ca$export$a0a057c2941dc0bc),
    templates: (0, $6f20c917496dda1e$export$9e7802a7d1db8cfc),
    customize: (0, $95245a9bd03c7ad9$export$249a65f26e2bc7f5)
};
const $7b79f828379224e7$export$f83d6aa785dd4970 = ({ productSideNavigation: productSideNavigation, isOnAnySettingsScreen: isOnAnySettingsScreen, isCollapsed: isCollapsed })=>{
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const [peekingId, setPeekingId] = (0, $cozmU.useState)(undefined);
    const [isMoreMenuOpen, setIsMoreMenuOpen] = (0, $cozmU.useState)(false);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireClickAnalytics = $7b79f828379224e7$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const { openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    const transitionId = (0, $dPJCf.useTransitionId)();
    const [getFilteredProductLinks, setGetFilteredProductLinks] = (0, $cozmU.useState)(undefined);
    const [isCustomizeSidebarDialogVisible, setIsCustomizeSidebarDialogVisible] = (0, $cozmU.useState)(false);
    const jiraShortcut = (0, $aJMnP.useJira)('');
    const loomShortcut = (0, $42SFg.useLoom)('');
    (0, $cozmU.useEffect)(()=>{
        if (transitionId && transitionId > 0) //on any transition close open flyout. On initial Load transitionId = 0
        closeFlyout();
    }, [
        closeFlyout,
        transitionId
    ]);
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)($7b79f828379224e7$var$GlobalNavigationComponentQuery, {
        interopApolloAggClient: true,
        variables: {
            entityAri: (0, $kyH1y.ConfluenceWorkspaceAri).create({
                siteId: cloudId,
                activationId: activationId
            }).toString(),
            ownerAri: userId ? (0, $2khPJ.IdentityUserAri).create({
                userId: userId
            }).toString() : ''
        },
        skip: !userId || !activationId,
        __callerPackage__: "side-navigation"
    });
    const platformCustomizations = (0, $cozmU.useMemo)(()=>{
        if (data?.settings_navigationCustomisation?.sidebar?.nodes) return data.settings_navigationCustomisation.sidebar.nodes.filter((node)=>node != null).map((node_0)=>({
                menuId: node_0.menuId?.replace($7b79f828379224e7$export$311d3c02bd72bcc0, ''),
                visible: Boolean(node_0.visible)
            }));
        return [];
    }, [
        data
    ]);
    const { platformCustomizationsWithSimplifyNav: platformCustomizationsWithSimplifyNav } = (0, $12338c25dd8aaf48$export$2471979fb08e1cdf)(platformCustomizations);
    //only show customization and fetch data if we meet these conditions
    const showCustomization = !!activationId && $7b79f828379224e7$var$hasAccess(accessStatus);
    // only render global app shortcuts if we meet these conditions
    const showGlobalAppShortcuts = $7b79f828379224e7$var$hasGlobalAppShortcutsAccess(accessStatus);
    const isInvitedAppShortcutsEligible = showGlobalAppShortcuts && !!cloudId && !!userId;
    // `recommendedApps` drives whether the decorated nudge renders and whether the Jira shortcut is
    // handed over from the main GlobalAppShortcuts section. An empty result keeps Jira in
    // GlobalAppShortcuts instead of hiding it.
    const { recommendedApps: recommendedApps, resolverResult: resolverResult } = (0, $e42c1a422737c43c$export$6219d718450662c3)({
        cloudId: cloudId ?? '',
        userId: userId ?? '',
        enabled: isInvitedAppShortcutsEligible
    });
    const hasInvitedAppRecommendation = isInvitedAppShortcutsEligible && recommendedApps.length > 0;
    const { globalMenuItems: globalMenuItems, moreMenuItems: moreMenuItems, appShortcutMenuItems: appShortcutMenuItems, allMenuItems: allMenuItems } = (0, $5cb9965cd3125e0a$export$aad046bd9909db8f)(showCustomization, accessStatus, platformCustomizationsWithSimplifyNav, getFilteredProductLinks);
    const moreMenuOnClickCallback = (0, $cozmU.useCallback)((menuId)=>{
        setIsMoreMenuOpen(!isMoreMenuOpen);
        // TODO: it would be great if we could refactor the following menu-specific logic into the respective menu components
        if (menuId === 'customize') {
            setIsCustomizeSidebarDialogVisible(true);
            fireClickAnalytics('customiseSidebar');
        } else fireClickAnalytics(menuId);
        if (menuId === 'recent' || menuId === 'starred' || menuId === 'spaces') {
            openFlyout(menuId);
            setPeekingId(menuId);
        }
        if (menuId === 'apps') push('/wiki/marketplace/discover');
    }, [
        fireClickAnalytics,
        isMoreMenuOpen,
        openFlyout,
        push
    ]);
    // The invited-app nudge takes over each recommended shortcut independently. The normal
    // GlobalAppShortcuts section strips only products that are actively rendered above the fold, so
    // neither Jira nor Loom can disappear or render twice.
    const shouldHandOverJiraShortcut = hasInvitedAppRecommendation && recommendedApps.some(({ product: product })=>product === 'jira');
    const shouldHandOverLoomShortcut = hasInvitedAppRecommendation && recommendedApps.some(({ product: product_0 })=>product_0 === 'loom');
    const invitedAppShortcutsConfig = (0, $cozmU.useMemo)(()=>{
        // The container gates actual visibility on the GRS recommendations; the config only needs to
        // carry the shortcut so its product links resolve.
        if (!isInvitedAppShortcutsEligible) return {};
        return recommendedApps.reduce((config, { product: product_1 })=>{
            if (product_1 === 'jira') return {
                ...config,
                jira: jiraShortcut
            };
            if (product_1 === 'loom') return {
                ...config,
                loom: loomShortcut
            };
            return config;
        }, {});
    }, [
        isInvitedAppShortcutsEligible,
        jiraShortcut,
        loomShortcut,
        recommendedApps
    ]);
    // Resolve the invited-app shortcut's href from the BFF filter that GlobalAppShortcuts hands us.
    // `ShortcutsMenu` renders a shortcut with no resolved link as a URL-less (dead) item, so this has
    // to be a live read: until the filter reports COMPLETE we pass nothing and the menu renders the
    // shortcut unlinked, then re-renders with the href once the links land.
    const invitedAppProductLinks = (0, $cozmU.useMemo)(()=>{
        if (!getFilteredProductLinks) return {};
        return Object.values(invitedAppShortcutsConfig).reduce((acc, config_0)=>{
            if (config_0.type === 'link' && config_0.apsKey) {
                const { links: links, status: status } = getFilteredProductLinks(config_0.apsKey);
                if (status === (0, $cXPtd.RequestStatus).COMPLETE) acc[config_0.apsKey] = links;
            }
            return acc;
        }, {});
    }, [
        getFilteredProductLinks,
        invitedAppShortcutsConfig
    ]);
    // The item "Customize sidebar" when it's one of the visible global items and app shortcuts:
    let globalCustomizeMenuItem = null;
    const moreMenuItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6bf303f52478ae0b$export$e967513bbeba0537), {
        moreMenuItems: moreMenuItems,
        isOpen: isMoreMenuOpen,
        onClick: moreMenuOnClickCallback,
        toggleMenu: ()=>setIsMoreMenuOpen(!isMoreMenuOpen),
        peekingId: peekingId,
        isCollapsed: isCollapsed
    });
    // Leaf renderer for the invited-app-shortcuts menu: order the decorated shortcuts per the user's
    // customisation, then render them with the resolved product links.
    const renderInvitedAppShortcutsMenu = (referrableShortcuts)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ddfb598ef229bd1a$export$7bd12ce5959bde45), {
            shortcutsConfig: referrableShortcuts,
            customizationMenuConfig: platformCustomizationsWithSimplifyNav
        }, ({ shortcuts: shortcuts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e00e30008af53db7$export$4519a9392cf3004e), {
                shortcutItems: shortcuts,
                product: "confluence",
                invitedAppProductLinks: invitedAppProductLinks
            }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, !isOnAnySettingsScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
        name: "enhance-orientation-spotlight-tour-target-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": "nav4-globalItems"
    }, globalMenuItems.map(({ menuId: menuId_0 })=>{
        const Component = $7b79f828379224e7$var$GlobalItemComponents[menuId_0];
        let node_1 = null;
        if (Component) {
            const baseNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                key: menuId_0,
                setIsCustomizeSidebarDialogVisible: setIsCustomizeSidebarDialogVisible
            });
            node_1 = baseNode;
            if (menuId_0 === 'companyHub') // companyHub is always rendered via GlobalAppShortcutsSection —
            // suppress it here to prevent a double-render.
            return null;
            else if (menuId_0 === 'customize') {
                // The item "Customize sidebar" should be:
                // - after the app shortcuts if any;
                // - visually divided from the preceeding global items or app shortcuts.
                globalCustomizeMenuItem = node_1;
                return null;
            }
        }
        return node_1;
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dA1Sn.TwoStageHydration), {
        name: "invited-app-shortcuts-container"
    }, hasInvitedAppRecommendation && cloudId && userId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Mzej.InvitedAppShortcutsContainer), {
        cloudId: cloudId,
        userId: userId,
        recommendedApps: recommendedApps,
        sourceApp: "confluence",
        shortcutsConfig: invitedAppShortcutsConfig,
        resolverResult: resolverResult
    }, ({ referrableShortcuts: referrableShortcuts_0 })=>renderInvitedAppShortcutsMenu(referrableShortcuts_0))), moreMenuItems.map((result)=>{
        const Component_0 = $7b79f828379224e7$var$GlobalItemComponents[result.menuId];
        return Component_0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component_0, {
            key: result.menuId,
            isHidden: true,
            peekingId: peekingId,
            setPeekingId: setPeekingId,
            setIsCustomizeSidebarDialogVisible: setIsCustomizeSidebarDialogVisible
        });
    }), globalCustomizeMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PREo.TopLevelSpacer), null), globalCustomizeMenuItem), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), isCustomizeSidebarDialogVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b79f828379224e7$var$CustomizationModalLoader, {
        onClose: ()=>setIsCustomizeSidebarDialogVisible(false),
        productItemsData: allMenuItems,
        appItemsData: appShortcutMenuItems,
        navigationCustomisationId: data?.settings_navigationCustomisation?.id || ''
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $1uFsv.GLOBAL_NAVIGATION_METRIC)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PREo.TopLevelSpacer), null)), productSideNavigation, !isOnAnySettingsScreen && showGlobalAppShortcuts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PREo.TopLevelSpacer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c495d3eaf0ec763f$export$8a66e0b504449f1), {
        orderedMenuConfig: platformCustomizationsWithSimplifyNav,
        onUpdateGetFilteredProductLinks: (fn)=>{
            setGetFilteredProductLinks(()=>fn);
        },
        shouldHandOverJiraShortcut: shouldHandOverJiraShortcut,
        shouldHandOverLoomShortcut: shouldHandOverLoomShortcut
    }), moreMenuItem, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hrvfP.ConnectorPromoSidebarEntry), null)));
};
const $7b79f828379224e7$export$94a5e0cf2e657dff = (variables, nodes, id)=>{
    (0, $fEmGS.writeQueryInterop)({
        query: $7b79f828379224e7$var$GlobalNavigationComponentQuery,
        variables: variables,
        data: {
            settings_navigationCustomisation: {
                __typename: 'SettingsNavigationCustomisation',
                id: id,
                sidebar: {
                    __typename: 'SettingsMenuItemConnection',
                    nodes: nodes
                }
            }
        },
        __callerPackage__: "side-navigation"
    });
};
const $7b79f828379224e7$var$GlobalNavigationComponentQuery = (0, $hPkGG.default);
module.exports["PLATFORM_MENU_ID_PREFIX"] = $7b79f828379224e7$export$311d3c02bd72bcc0;
module.exports["GlobalNavigationComponent"] = $7b79f828379224e7$export$f83d6aa785dd4970;
module.exports["updateNavigationCustomization"] = $7b79f828379224e7$export$94a5e0cf2e657dff;

});

parcelRegister("hPkGG", function(module, exports) {
/**
 * @generated SignedSource<<5efd4a44b24bb87c092d4fc494599337>>
 * @relayHash ee5a91706bc8d2c36266138f1556fa8e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7f7a8c5a405e165722f55d2fb38fba615d09b5f4c08ede00a7a9fe5741f08c7a
const $62aeb16db236e807$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entityAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ownerAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAri"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                }
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SettingsMenuItemConnection",
                    "kind": "LinkedField",
                    "name": "sidebar",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsMenuItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "menuId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "visible"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GlobalNavigationComponentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GlobalNavigationComponentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ee5a91706bc8d2c36266138f1556fa8e",
            "id": "7f7a8c5a405e165722f55d2fb38fba615d09b5f4c08ede00a7a9fe5741f08c7a",
            "metadata": {},
            "name": "GlobalNavigationComponentQuery",
            "operationKind": "query",
            "text": "query GlobalNavigationComponentQuery($entityAri:ID!,$ownerAri:ID!){settings_navigationCustomisation(entityAri:$entityAri,ownerAri:$ownerAri){id,sidebar{nodes{menuId,visible}}}}"
        }
    };
}();
$62aeb16db236e807$var$node.hash = "0e74e77d53a00c9095e60ae7930a7cf3";
var $62aeb16db236e807$export$2e2bcd8739ae039 = $62aeb16db236e807$var$node;
module.exports["default"] = $62aeb16db236e807$export$2e2bcd8739ae039;

});

parcelRegister("iDdJP", function(module, exports) {

var $k27u5 = parcelRequire("k27u5");

const $c514d668c0af497d$export$d4c4e98c5044dc8 = (0, $k27u5.List);
module.exports["MenuList"] = $c514d668c0af497d$export$d4c4e98c5044dc8;

});

parcelRegister("k27u5", function(module, exports) {
/* list.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");

function $3028fcb6dba16eaa$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ $cozmU.createElement("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId
    }, children));
}
const $3028fcb6dba16eaa$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $cozmU.forwardRef)($3028fcb6dba16eaa$var$_List);
module.exports["List"] = $3028fcb6dba16eaa$export$54c2e3dc7acea9f5;

});

parcelRegister("2khPJ", function(module, exports) {

var $aQ0yV = parcelRequire("aQ0yV");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/identity/user/manifest.ts
var $1b1b4861ffbabf45$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $aQ0yV.IdentityUserAriResourceOwner),
    resourceType: (0, $aQ0yV.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $1b1b4861ffbabf45$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $9j37t.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $1b1b4861ffbabf45$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $1b1b4861ffbabf45$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $1b1b4861ffbabf45$export$1e9d09c2be53e55e;

});

parcelRegister("aQ0yV", function(module, exports) {
// src/identity/user/types.ts
var $7e3f325f95b56bab$export$b4c14c54282a779d = "identity", $7e3f325f95b56bab$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $7e3f325f95b56bab$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $7e3f325f95b56bab$export$e9b50e20f4fbfb71;

});

parcelRegister("6adZX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $059c9f3c8066ba5d$var$initialState = {
    openFlyoutId: null // Keeps track of the currently open flyout by its menuId
};
const $059c9f3c8066ba5d$export$3d79379112bcd772 = (0, $8s9DV.createStore)({
    name: 'FlyoutStore',
    initialState: $059c9f3c8066ba5d$var$initialState,
    actions: {
        openFlyout: (menuId)=>({ setState: setState })=>{
                setState({
                    openFlyoutId: menuId
                });
            },
        closeFlyout: (menuId = null)=>({ setState: setState, getState: getState })=>{
                if (!menuId || menuId === getState().openFlyoutId) setState({
                    openFlyoutId: null
                });
            }
    }
});
const $059c9f3c8066ba5d$export$377168f986312a4 = (0, $kBr4q.createHook)($059c9f3c8066ba5d$export$3d79379112bcd772, {
    selector: (state, menuId)=>state.openFlyoutId === menuId
});
const $059c9f3c8066ba5d$export$3f64b5809402b3ff = (menuId)=>{
    const [isFlyoutOpen, flyoutActions] = $059c9f3c8066ba5d$export$377168f986312a4(menuId);
    const openFlyout = (0, $cozmU.useCallback)(()=>flyoutActions.openFlyout(menuId), [
        flyoutActions,
        menuId
    ]);
    const closeFlyout = (0, $cozmU.useCallback)(()=>flyoutActions.closeFlyout(menuId), [
        flyoutActions,
        menuId
    ]);
    return {
        isFlyoutOpen: isFlyoutOpen,
        openFlyout: openFlyout,
        closeFlyout: closeFlyout
    };
};
const $059c9f3c8066ba5d$export$285f2f1642666795 = (0, $kBr4q.createActionsHook)($059c9f3c8066ba5d$export$3d79379112bcd772);
module.exports["useIsFlyoutOpen"] = $059c9f3c8066ba5d$export$377168f986312a4;
module.exports["useFlyout"] = $059c9f3c8066ba5d$export$3f64b5809402b3ff;
module.exports["useFlyoutActions"] = $059c9f3c8066ba5d$export$285f2f1642666795;

});

parcelRegister("dA1Sn", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $18ccf8477934fc9e$export$2a8604960d7d23d9 = 30000;
const $18ccf8477934fc9e$var$useTwoStageHydration = (name, enabled)=>{
    const fullCycleOutput = window.__FULLCYCLE__?.[name];
    const isNoFullCycleOutput = fullCycleOutput === undefined;
    const isNoSSR = !window.__SSR_RENDERED__;
    // Rely on a normal hydration/rendering flow when it's a transition or there's no full cycle output
    // or when experience is not hydratable
    const [hydrated, setHydrated] = (0, $cozmU.useState)(isNoSSR || isNoFullCycleOutput || !window.__HYDRATABLE__ || !enabled);
    (0, $cozmU.useEffect)(()=>{
        setHydrated(true);
        const cleanup = ()=>{
            delete window.__FULLCYCLE__?.[name];
        };
        // Arbitrary 30s CLEANUP_TIMEOUT to allow for the element to be rendered before removal
        // to not force an unecessary re-render or flash of blank content, even in slowest cases
        setTimeout(cleanup, $18ccf8477934fc9e$export$2a8604960d7d23d9);
        return cleanup;
    }, [
        name
    ]);
    return {
        hydrated: hydrated,
        fullCycleOutput: fullCycleOutput
    };
};
const $18ccf8477934fc9e$export$ca5d80b93e3e21b2 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals -- the saveFullCycleOutput() only runs in the browser
    const nodesForPartialHydration = document.querySelectorAll('[data-fullcycle-name]');
    if (nodesForPartialHydration.length > 0) window.__FULLCYCLE__ = Array.from(nodesForPartialHydration).reduce((acc, node)=>{
        acc[node.dataset.fullcycleName] = node.innerHTML;
        return acc;
    }, {});
};
const $18ccf8477934fc9e$export$137b13ff1789fa49 = (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { name: name, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? false : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    const { hydrated: hydrated, fullCycleOutput: fullCycleOutput } = $18ccf8477934fc9e$var$useTwoStageHydration(name, enabled);
    if (!enabled) return children;
    if (hydrated) {
        let t3;
        if ($[0] !== name || $[1] !== ssrPlaceholder) {
            t3 = ssrPlaceholder ? {
                "data-ssr-placeholder": name,
                "data-ssr-placeholder-replace": name
            } : {};
            $[0] = name;
            $[1] = ssrPlaceholder;
            $[2] = t3;
        } else t3 = $[2];
        let t4;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = {
                position: "relative",
                height: "100%",
                width: "100%"
            };
            $[3] = t4;
        } else t4 = $[3];
        let t5;
        if ($[4] !== children || $[5] !== name || $[6] !== t3) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "two-stage-hydration",
                "data-fullcycle-name": name,
                ...t3,
                style: t4
            }, children);
            $[4] = children;
            $[5] = name;
            $[6] = t3;
            $[7] = t5;
        } else t5 = $[7];
        return t5;
    }
    const innerHTML = fullCycleOutput;
    let t3;
    if ($[8] !== name || $[9] !== ssrPlaceholder) {
        t3 = ssrPlaceholder ? {
            "data-ssr-placeholder": name,
            "data-ssr-placeholder-replace": name
        } : {};
        $[8] = name;
        $[9] = ssrPlaceholder;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== innerHTML) {
        t4 = {
            __html: innerHTML
        };
        $[11] = innerHTML;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            position: "relative",
            height: "100%",
            width: "100%"
        };
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== name || $[15] !== t3 || $[16] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "two-stage-hydration",
            "data-fullcycle-name": name,
            ...t3,
            dangerouslySetInnerHTML: t4,
            style: t5
        });
        $[14] = name;
        $[15] = t3;
        $[16] = t4;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
};
const $18ccf8477934fc9e$export$b6db8e1e111c3550 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { name: name, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? true : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== children || $[1] !== enabled || $[2] !== name || $[3] !== ssrPlaceholder) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($18ccf8477934fc9e$export$137b13ff1789fa49, {
            name: name,
            enabled: enabled,
            ssrPlaceholder: ssrPlaceholder
        }, children);
        $[0] = children;
        $[1] = enabled;
        $[2] = name;
        $[3] = ssrPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
module.exports["saveFullCycleOutput"] = $18ccf8477934fc9e$export$ca5d80b93e3e21b2;
module.exports["TwoStageHydration"] = $18ccf8477934fc9e$export$b6db8e1e111c3550;

});

parcelRegister("u7mpJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");

const $f20decd2af09ad63$export$5ff0b879ab65d0b0 = 'd1';
const $f20decd2af09ad63$export$46c1c92549715335 = 'loading';
const $f20decd2af09ad63$export$61c0af74ec47d243 = 'd0';
const $f20decd2af09ad63$export$f883a24d5edde77c = 'none';
const $f20decd2af09ad63$var$CREATION_FOCUSED_NAV_DELAY_MINUTES = 1440; // 1440 minutes (24 hours)
const $f20decd2af09ad63$export$b23a5dfe95342477 = (updateState = false, skip = false)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const delayInMinutes = $f20decd2af09ad63$var$CREATION_FOCUSED_NAV_DELAY_MINUTES;
    const hasUpdatedState = (0, $cozmU.useRef)(false);
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS)
    ], skip);
    const spotlightShown = ()=>{
        setOnboardingState({
            key: (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
            value: 'false'
        });
    };
    if (onboardingStateLoading) // Simplify nav and hide banners while loading, to minimize flashing
    return {
        isSpotlightVisible: false,
        areBannersHidden: true,
        navCustomization: $f20decd2af09ad63$export$46c1c92549715335
    };
    if (onboardingStateError) // Fallback behavior if there are any errors
    return {
        isSpotlightVisible: false,
        areBannersHidden: false,
        navCustomization: $f20decd2af09ad63$export$f883a24d5edde77c
    };
    const { shouldShowSpotlight: shouldShowSpotlight, startTime: startTime } = (0, $ivb8S.deserializeState)(onboardingStateData);
    if ($f20decd2af09ad63$var$isSiteOlderThanDelay(delayInMinutes, startTime)) {
        if (shouldShowSpotlight) // Spotlight ready to show --> Show spotlight, bring nav features back, but don't bring banners back
        return {
            isSpotlightVisible: true,
            areBannersHidden: true,
            navCustomization: $f20decd2af09ad63$export$5ff0b879ab65d0b0,
            onSpotlightShown: spotlightShown
        };
        else if (shouldShowSpotlight === false) // Spotlight has already shown --> Don't show spotlight, bring nav features back, but don't bring banners back
        return {
            isSpotlightVisible: false,
            areBannersHidden: true,
            navCustomization: $f20decd2af09ad63$export$5ff0b879ab65d0b0
        };
        // This account was created before the feature was enabled, so we won't change anything
        return {
            isSpotlightVisible: false,
            areBannersHidden: false,
            navCustomization: $f20decd2af09ad63$export$f883a24d5edde77c
        };
    } else if (shouldShowSpotlight === undefined && updateState && !hasUpdatedState.current) {
        hasUpdatedState.current = true;
        setOnboardingState({
            key: (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
            value: 'true'
        });
    }
    return {
        isSpotlightVisible: false,
        areBannersHidden: true,
        navCustomization: $f20decd2af09ad63$export$61c0af74ec47d243
    };
};
const $f20decd2af09ad63$var$isSiteOlderThanDelay = (delayInMinutes, siteActivationDateString)=>{
    if (!siteActivationDateString) return true; // If site has no activation date, assume it is old
    const siteActivationDateNumber = Number(siteActivationDateString);
    const siteActivationDate = new Date(siteActivationDateNumber ?? '');
    if (isNaN(siteActivationDate.getTime())) return true; // If site has no activation date, assume it is old
    const createdAtTimestamp = siteActivationDate.getTime();
    const millisecondsSinceCreation = Date.now() - createdAtTimestamp;
    const secondsPerMinute = 60;
    const millisecondsPerSecond = 1000;
    const millisecondsInDelayTime = delayInMinutes * secondsPerMinute * millisecondsPerSecond;
    return millisecondsSinceCreation > millisecondsInDelayTime;
};
module.exports["d1"] = $f20decd2af09ad63$export$5ff0b879ab65d0b0;
module.exports["loading"] = $f20decd2af09ad63$export$46c1c92549715335;
module.exports["d0"] = $f20decd2af09ad63$export$61c0af74ec47d243;
module.exports["useCreationFocusedNavLand"] = $f20decd2af09ad63$export$b23a5dfe95342477;

});

parcelRegister("145zT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $KuePV = parcelRequire("KuePV");


var $h11I1 = parcelRequire("h11I1");

const $7d2b10ee608cb4d3$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(24);
    const { testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator } = t0;
    const t1 = isDisabled ? undefined : actions;
    const t2 = isDisabled ? undefined : actionsOnHover;
    let t3;
    if ($[0] !== ariaControls || $[1] !== ariaExpanded || $[2] !== ariaHasPopup || $[3] !== children || $[4] !== description || $[5] !== dropIndicator || $[6] !== elemAfter || $[7] !== elemBefore || $[8] !== forwardedRef || $[9] !== hasDragIndicator || $[10] !== interactionName || $[11] !== isContentTooltipDisabled || $[12] !== isDisabled || $[13] !== isDragging || $[14] !== isSelected || $[15] !== onClick || $[16] !== t1 || $[17] !== t2 || $[18] !== testId || $[19] !== visualContentRef) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KuePV.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            actions: t1,
            actionsOnHover: t2,
            onClick: onClick,
            ariaControls: ariaControls,
            ariaExpanded: ariaExpanded,
            ariaHasPopup: ariaHasPopup,
            isSelected: isSelected,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator
        }, children);
        $[0] = ariaControls;
        $[1] = ariaExpanded;
        $[2] = ariaHasPopup;
        $[3] = children;
        $[4] = description;
        $[5] = dropIndicator;
        $[6] = elemAfter;
        $[7] = elemBefore;
        $[8] = forwardedRef;
        $[9] = hasDragIndicator;
        $[10] = interactionName;
        $[11] = isContentTooltipDisabled;
        $[12] = isDisabled;
        $[13] = isDragging;
        $[14] = isSelected;
        $[15] = onClick;
        $[16] = t1;
        $[17] = t2;
        $[18] = testId;
        $[19] = visualContentRef;
        $[20] = t3;
    } else t3 = $[20];
    let t4;
    if ($[21] !== listItemRef || $[22] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h11I1.MenuListItem), {
            ref: listItemRef
        }, t3);
        $[21] = listItemRef;
        $[22] = t3;
        $[23] = t4;
    } else t4 = $[23];
    return t4;
} : ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h11I1.MenuListItem), {
        ref: listItemRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KuePV.MenuItemBase), {
        testId: testId,
        description: description,
        elemAfter: elemAfter,
        elemBefore: elemBefore,
        isDisabled: isDisabled,
        /**
     * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
     * so they aren't rendered in the disabled state.
     */ actions: isDisabled ? undefined : actions,
        actionsOnHover: isDisabled ? undefined : actionsOnHover,
        onClick: onClick,
        ariaControls: ariaControls,
        ariaExpanded: ariaExpanded,
        ariaHasPopup: ariaHasPopup,
        isSelected: isSelected,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
});
module.exports["ButtonMenuItem"] = $7d2b10ee608cb4d3$export$6dc09b7c0ec1dfcd;

});

parcelRegister("aZIBq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $79e7fe947cf57ced$var$styles = null; /**
                      * __Divider__
                      *
                      * A divider for use between menu sections.
                      */ 
const $79e7fe947cf57ced$export$2e0a83ec2e27ecbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("hr", {
            role: "none",
            className: (0, $hekY6.default)([
                "_18otpjYbGa _2R4pr3YbGa _1v3aPqOeNX _39xV02N91d"
            ])
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ $cozmU.createElement("hr" /**
                            * The existing usage of these dividers is presentational,
                            * so we are removing the separator semantics by default.
                            *
                            * In the future we may consider allowing opt-in separator semantics,
                            * but it probably isn't necessary.
                            */ , {
        role: "none",
        className: (0, $hekY6.default)([
            "_18otpjYbGa _2R4pr3YbGa _1v3aPqOeNX _39xV02N91d"
        ])
    });
module.exports["Divider"] = $79e7fe947cf57ced$export$2e0a83ec2e27ecbb;

});

parcelRegister("63PsI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1ytiN = parcelRequire("1ytiN");

function $acec4613ff860ea3$export$e7c489d818076f3d() {
    let { companyHubName: companyHubName } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const intl = (0, $kSwu1.useIntl)();
    if (!companyHubName) companyHubName = intl.formatMessage($acec4613ff860ea3$var$messages.defaultCompanyHubName);
    return companyHubName;
}
// eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages -- Moved from confluence/next/packages/app-navigation/src/Nav3/PrimaryItems/CompanyHubItem.tsx
const $acec4613ff860ea3$var$messages = (0, $kSwu1.defineMessages)({
    defaultCompanyHubName: {
        id: "app-navigation.company-hub.link",
        defaultMessage: "Company hub"
    }
});
module.exports["useCompanyHubName"] = $acec4613ff860ea3$export$e7c489d818076f3d;

});

parcelRegister("eHDih", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $841a22a6d07f9832$var$svg = `<svg height="100%" viewBox="0 0 32 32">
    <g clip-path="url(#clip0_95164_16219)">
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g clip-path="url(#clip1_95164_16219)">
            <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_16219">
            <path fill="var(--icon-color, white)" d="M0 0h32v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_16219">
            <path fill="var(--icon-color, white)" d="M2 2h28v28H2z"/>
        </clipPath>
    </defs>
</svg>
`;
const $841a22a6d07f9832$export$80b8b269d8b5014e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function HubIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Hub" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $841a22a6d07f9832$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function HubIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Hub', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $841a22a6d07f9832$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["HubIcon"] = $841a22a6d07f9832$export$80b8b269d8b5014e;

});

parcelRegister("kX2dA", function(module, exports) {

let $f40b09d50443ad04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f40b09d50443ad04$var$load("aGsq7").then(()=>parcelRequire('eXmLL'));

});

parcelRegister("1LksZ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $135393dc762a6338$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    customHome: {
        id: "side-navigation.global.home",
        defaultMessage: "Home"
    },
    forYou: {
        id: "side-navigation.global.for.you",
        defaultMessage: "For you"
    },
    yourWork: {
        id: "side-navigation.global.your.work",
        defaultMessage: "For you"
    },
    companyHub: {
        id: "side-navigation.global.company.hub",
        defaultMessage: "Company Hub"
    },
    recent: {
        id: "side-navigation.global.recent",
        defaultMessage: "Recent"
    },
    starred: {
        id: "side-navigation.global.starred",
        defaultMessage: "Starred"
    },
    spaces: {
        id: "side-navigation.global.spaces",
        defaultMessage: "Spaces"
    },
    apps: {
        id: "side-navigation.global.apps",
        defaultMessage: "Apps"
    },
    goals: {
        id: "side-navigation.global.goals",
        defaultMessage: "Goals"
    },
    topics: {
        id: "side-navigation.global.topics",
        defaultMessage: "Topics"
    },
    teams: {
        id: "side-navigation.global.teams",
        defaultMessage: "Teams"
    },
    drafts: {
        id: "side-navigation.global.drafts",
        defaultMessage: "Drafts"
    },
    tasks: {
        id: "side-navigation.global.tasks",
        defaultMessage: "Tasks"
    },
    more: {
        id: "side-navigation.global.more",
        defaultMessage: "More"
    },
    customize: {
        id: "side-navigation.global.customize.sidebar",
        defaultMessage: "Customize sidebar"
    },
    templates: {
        id: "side-navigation.global.customize.templates",
        defaultMessage: "Templates"
    },
    workflows: {
        id: "side-navigation.global.customize.workflows",
        defaultMessage: "Workflows"
    },
    separator: {
        id: "side-navigation.global.customize.separator",
        defaultMessage: "HIDE FROM SIDEBAR"
    },
    jiraShortcut: {
        id: "side-navigation.global.customize.jiraShortcut",
        defaultMessage: "Jira"
    },
    loomShortcut: {
        id: "side-navigation.global.customize.loomShortcut",
        defaultMessage: "Loom"
    },
    teamsShortcut: {
        id: "side-navigation.global.customize.teamsShortcut",
        defaultMessage: "Teams"
    },
    companyHubShortcut: {
        id: "side-navigation.global.customize.companyHubShortcut",
        // oxlint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{companyHubName}"
    },
    notes: {
        id: "side-navigation.global.customize.notesShortcut",
        defaultMessage: "Notes"
    }
});
module.exports["i18n"] = $135393dc762a6338$export$a7357cdd1f0b0168;

});

parcelRegister("cxU8R", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iITVA = parcelRequire("iITVA");


var $untPk = parcelRequire("untPk");


var $kpuvJ = parcelRequire("kpuvJ");


var $5ZtfK = parcelRequire("5ZtfK");


var $lbT4j = parcelRequire("lbT4j");


var $krxYo = parcelRequire("krxYo");


var $jmUhx = parcelRequire("jmUhx");


var $6CsCB = parcelRequire("6CsCB");


var $eIGK2 = parcelRequire("eIGK2");


var $dflgH = parcelRequire("dflgH");


var $gC2EJ = parcelRequire("gC2EJ");


var $iAaYd = parcelRequire("iAaYd");


var $6TaGl = parcelRequire("6TaGl");


var $8A5sV = parcelRequire("8A5sV");


var $dPtk6 = parcelRequire("dPtk6");


var $aOjGz = parcelRequire("aOjGz");


var $eHDih = parcelRequire("eHDih");

var $ldJ1U = parcelRequire("ldJ1U");

var $lb2PL = parcelRequire("lb2PL");

var $kKUMP = parcelRequire("kKUMP");


var $6mKj3 = parcelRequire("6mKj3");

const $b1654aa018846a1e$var$StyledIconComponent = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { icon: icon } = t0;
    const IconComponent = icon;
    let t1;
    if ($[0] !== IconComponent) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        });
        $[0] = IconComponent;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
});
const $b1654aa018846a1e$var$StyledLogoComponent = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { logo: logo, testId: testId } = t0;
    const LogoComponent = logo;
    let t1;
    if ($[0] !== LogoComponent || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LogoComponent, {
            label: "",
            size: "xsmall",
            testId: testId
        });
        $[0] = LogoComponent;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $b1654aa018846a1e$export$4370213f5e13a087 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($iITVA)))
});
const $b1654aa018846a1e$export$fcf3ce494c961537 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($untPk)))
});
const $b1654aa018846a1e$export$e25b0b35bcc6a6f4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kpuvJ)))
});
const $b1654aa018846a1e$export$22eb82a2d06386cd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK)))
});
const $b1654aa018846a1e$export$e354edba2d87a80b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($lbT4j)))
});
const $b1654aa018846a1e$export$815068847a2940cc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($krxYo)))
});
const $b1654aa018846a1e$export$1820ff183b9ac996 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($aOjGz)))
});
const $b1654aa018846a1e$export$2ad8d00357381dab = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($jmUhx)))
});
const $b1654aa018846a1e$export$b8743c92b35ba3d2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6CsCB)))
});
const $b1654aa018846a1e$export$ea1e8de44637bcc8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($eIGK2)))
});
const $b1654aa018846a1e$export$85b08d1fd6c3c91e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dflgH)))
});
const $b1654aa018846a1e$export$3ac9d636aeac90b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ)))
});
const $b1654aa018846a1e$export$44d9bde334d7e007 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd)))
});
const $b1654aa018846a1e$export$296eedab7746f8f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($8A5sV)))
});
const $b1654aa018846a1e$export$1f926db0b8c551ab = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl)))
});
const $b1654aa018846a1e$export$553a8f8e72a63c41 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dPtk6)))
});
const $b1654aa018846a1e$export$7ef71e75b22027b6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledLogoComponent, {
    logo: (0, $eHDih.HubIcon)
});
const $b1654aa018846a1e$export$b98c953fd1e726cc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledLogoComponent, {
    logo: (0, $kKUMP.TeamsIcon)
});
const $b1654aa018846a1e$export$7ac757a6aec752f4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledLogoComponent, {
    logo: (0, $ldJ1U.JiraIcon)
});
const $b1654aa018846a1e$export$6e55f825f45b7145 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1654aa018846a1e$var$StyledLogoComponent, {
    logo: (0, $lb2PL.LoomIcon)
});
const $b1654aa018846a1e$export$803815ff2adecad4 = {
    customHome: $b1654aa018846a1e$export$fcf3ce494c961537,
    yourWork: $b1654aa018846a1e$export$4370213f5e13a087,
    // Component has been updated to 'For you', key remains the same.
    companyHub: $b1654aa018846a1e$export$e25b0b35bcc6a6f4,
    recent: $b1654aa018846a1e$export$22eb82a2d06386cd,
    starred: $b1654aa018846a1e$export$e354edba2d87a80b,
    spaces: $b1654aa018846a1e$export$815068847a2940cc,
    apps: $b1654aa018846a1e$export$2ad8d00357381dab,
    goals: $b1654aa018846a1e$export$b8743c92b35ba3d2,
    topics: $b1654aa018846a1e$export$ea1e8de44637bcc8,
    teams: $b1654aa018846a1e$export$85b08d1fd6c3c91e,
    drafts: $b1654aa018846a1e$export$3ac9d636aeac90b,
    tasks: $b1654aa018846a1e$export$44d9bde334d7e007,
    templates: $b1654aa018846a1e$export$296eedab7746f8f0,
    customize: $b1654aa018846a1e$export$553a8f8e72a63c41,
    companyHubShortcut: $b1654aa018846a1e$export$7ef71e75b22027b6,
    teamsShortcut: $b1654aa018846a1e$export$b98c953fd1e726cc,
    jiraShortcut: $b1654aa018846a1e$export$7ac757a6aec752f4,
    loomShortcut: $b1654aa018846a1e$export$6e55f825f45b7145
};
const $b1654aa018846a1e$export$d7b6490d01f6dc6 = ()=>{
    if ((0, $6mKj3.expVal)('confluence_space_icon_update', 'isEnabled', false)) return {
        ...$b1654aa018846a1e$export$803815ff2adecad4,
        spaces: $b1654aa018846a1e$export$1820ff183b9ac996
    };
    return $b1654aa018846a1e$export$803815ff2adecad4;
};
module.exports["ForYouIconComponent"] = $b1654aa018846a1e$export$4370213f5e13a087;
module.exports["HomeIconComponent"] = $b1654aa018846a1e$export$fcf3ce494c961537;
module.exports["ClockIconComponent"] = $b1654aa018846a1e$export$22eb82a2d06386cd;
module.exports["StarIconComponent"] = $b1654aa018846a1e$export$e354edba2d87a80b;
module.exports["GlobeIconComponent"] = $b1654aa018846a1e$export$815068847a2940cc;
module.exports["SpacesIconComponent"] = $b1654aa018846a1e$export$1820ff183b9ac996;
module.exports["AppsIconComponent"] = $b1654aa018846a1e$export$2ad8d00357381dab;
module.exports["GoalIconComponent"] = $b1654aa018846a1e$export$b8743c92b35ba3d2;
module.exports["HashIconComponent"] = $b1654aa018846a1e$export$ea1e8de44637bcc8;
module.exports["TeamsIconComponent"] = $b1654aa018846a1e$export$85b08d1fd6c3c91e;
module.exports["EditIconComponent"] = $b1654aa018846a1e$export$3ac9d636aeac90b;
module.exports["TaskIconComponent"] = $b1654aa018846a1e$export$44d9bde334d7e007;
module.exports["TemplatesIconComponent"] = $b1654aa018846a1e$export$296eedab7746f8f0;
module.exports["MoreIconComponent"] = $b1654aa018846a1e$export$1f926db0b8c551ab;
module.exports["CustomizeIconComponent"] = $b1654aa018846a1e$export$553a8f8e72a63c41;
module.exports["useIconByMenuId"] = $b1654aa018846a1e$export$d7b6490d01f6dc6;

});

parcelRegister("kKUMP", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $1576217052e14df9$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63"/>
</svg>
`;
const $1576217052e14df9$export$1bcbc9c337da86da = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TeamsIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Teams" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $1576217052e14df9$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function TeamsIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Teams', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $1576217052e14df9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["TeamsIcon"] = $1576217052e14df9$export$1bcbc9c337da86da;

});

parcelRegister("bABP9", function(module, exports) {

let $87006596feb1bced$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $87006596feb1bced$var$load("7BaJE").then(()=>parcelRequire('1CCr3'));

});

parcelRegister("ecTjk", function(module, exports) {

let $a57d17400191ca52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a57d17400191ca52$var$load("60m6Z").then(()=>parcelRequire('3QuUN'));

});

parcelRegister("eOScq", function(module, exports) {

let $ac9fc715ddcd0b29$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ac9fc715ddcd0b29$var$load("j6Nec").then(()=>parcelRequire('lLYUy'));

});

parcelRegister("9cHD3", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");

const $c13134ff3760e72f$var$skeletonProps = {
    height: '9px',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    isShimmering: true,
    color: "var(--ds-skeleton, #0515240F)",
    ShimmeringEndColor: "var(--ds-skeleton-subtle, #17171708)"
};
const $c13134ff3760e72f$export$a2ec9fdcdf0bd301 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlock: "space.300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.300",
            alignBlock: "center",
            alignInline: "center",
            grow: "fill",
            testId: "content-menu-loading"
        }, [
            ...Array(10)
        ].map($c13134ff3760e72f$var$_temp)));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $c13134ff3760e72f$export$feed0f481420fd40 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            padding: "space.300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.300",
            grow: "fill",
            testId: "content-menu-load-more"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "180px",
            ...$c13134ff3760e72f$var$skeletonProps
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "140px",
            ...$c13134ff3760e72f$var$skeletonProps
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "180px",
            ...$c13134ff3760e72f$var$skeletonProps
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "140px",
            ...$c13134ff3760e72f$var$skeletonProps
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
function $c13134ff3760e72f$var$_temp(_, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        key: index,
        width: "250px",
        ...$c13134ff3760e72f$var$skeletonProps
    });
}
module.exports["ContentMenuLoadingState"] = $c13134ff3760e72f$export$a2ec9fdcdf0bd301;
module.exports["ContentMenuLoadMoreState"] = $c13134ff3760e72f$export$feed0f481420fd40;

});

parcelRegister("hjBFA", function(module, exports) {

let $c9b16e76fa85e286$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c9b16e76fa85e286$var$load("6wr18"),
    $c9b16e76fa85e286$var$load("arKPj"),
    $c9b16e76fa85e286$var$load("ffEVr"),
    $c9b16e76fa85e286$var$load("9TOep"),
    $c9b16e76fa85e286$var$load("2yM8Y")
]).then(()=>parcelRequire('kIWbA'));

});

parcelRegister("E8xvU", function(module, exports) {

let $078a5c51187f9376$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $078a5c51187f9376$var$load("arKPj"),
    $078a5c51187f9376$var$load("9TOep"),
    $078a5c51187f9376$var$load("1cMUZ")
]).then(()=>parcelRequire('1IQhI'));

});

parcelRegister("5WLjq", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $5IsL6 = parcelRequire("5IsL6");


var $gW6rh = parcelRequire("gW6rh");


var $4H4Pj = parcelRequire("4H4Pj");


var $4eIcx = parcelRequire("4eIcx");


var $5t9S7 = parcelRequire("5t9S7");

const $0075b8fcac3e7fa4$export$19b525d696aff959 = ({ isLicensed: isLicensed, selectedSpaceKey: selectedSpaceKey })=>{
    const preloadQueries = [];
    if (isLicensed) {
        preloadQueries.push((0, $dYU3e.query)({
            query: (0, $gW6rh.default),
            variables: {},
            __callerPackage__: "space-utils"
        }));
        if (selectedSpaceKey) preloadQueries.push((0, $dYU3e.query)({
            query: (0, $4eIcx.default),
            variables: {
                selectedSpaceKey: selectedSpaceKey
            },
            __callerPackage__: "space-utils"
        }));
        else preloadQueries.push((0, $dYU3e.query)({
            query: (0, $4H4Pj.default),
            variables: {},
            __callerPackage__: "space-utils"
        }));
    } else preloadQueries.push((0, $dYU3e.query)({
        query: (0, $5t9S7.default),
        variables: {},
        __callerPackage__: "space-utils"
    }));
    preloadQueries.push((0, $5IsL6.preloadCreateSpace)({
        isLicensed: isLicensed
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(preloadQueries);
};
module.exports["preloadSpacesList"] = $0075b8fcac3e7fa4$export$19b525d696aff959;

});

parcelRegister("5IsL6", function(module, exports) {

var $fEhQK = parcelRequire("fEhQK");


var $dYU3e = parcelRequire("dYU3e");

/**
 * see next/packages/create-space/src/useCanCreateSpace.tsx for the query usage
 */ const $c4ac54148814de4b$var$PreloadCreateSpaceQuery = (0, $fEhQK.default);
const $c4ac54148814de4b$export$25bcc47d8ed557d4 = ({ isLicensed: isLicensed })=>{
    if (!isLicensed) return Promise.resolve({
        data: null
    });
    return (0, $dYU3e.query)({
        query: $c4ac54148814de4b$var$PreloadCreateSpaceQuery,
        __callerPackage__: "create-space-preload"
    });
};
module.exports["preloadCreateSpace"] = $c4ac54148814de4b$export$25bcc47d8ed557d4;

});

parcelRegister("a0CEX", function(module, exports) {
$parcel$export(module.exports, "SpacesDropdownLoader", () => (parcelRequire("7peCC")).SpacesDropdownLoader);

var $jmjWc = parcelRequire("jmjWc");


var $7peCC = parcelRequire("7peCC");


const $cfadde74afe3d902$export$68470bf7ec67edb4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "KNvxq",
    name: "SpacesDropdown",
    loader: async ()=>(await (parcelRequire("jK5pP"))).SpacesDropdown
});

});

parcelRegister("jK5pP", function(module, exports) {

let $e5f6839ed7ce41b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e5f6839ed7ce41b1$var$load("dZulV"),
    $e5f6839ed7ce41b1$var$load("9LDVS"),
    $e5f6839ed7ce41b1$var$load("kiMHu"),
    $e5f6839ed7ce41b1$var$load("6wr18"),
    $e5f6839ed7ce41b1$var$load("7QQL7"),
    $e5f6839ed7ce41b1$var$load("4fYzp"),
    $e5f6839ed7ce41b1$var$load("llcQo"),
    $e5f6839ed7ce41b1$var$load("7EorR"),
    $e5f6839ed7ce41b1$var$load("9TOep"),
    $e5f6839ed7ce41b1$var$load("aLbuU"),
    $e5f6839ed7ce41b1$var$load("ffEVr"),
    $e5f6839ed7ce41b1$var$load("20wSi"),
    $e5f6839ed7ce41b1$var$load("hhss7"),
    $e5f6839ed7ce41b1$var$load("7JfxY")
]).then(()=>parcelRequire('lOSbK'));

});

parcelRegister("7peCC", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $2cHVn = parcelRequire("2cHVn");


const $0b4731ff810ef3f0$export$91338486f2063670 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uBzS4",
    name: "SpacesDropdownLoader",
    loader: async ()=>(await (parcelRequire("jK5pP"))).SpacesDropdown,
    loading: (0, $2cHVn.LoadingState)
});
module.exports["SpacesDropdownLoader"] = $0b4731ff810ef3f0$export$91338486f2063670;

});

parcelRegister("2cHVn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");

const $82e933f8daca37a2$export$62aa48085237e36f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlock: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.300",
        alignBlock: "center",
        alignInline: "center",
        grow: "fill",
        testId: "content-menu-loading"
    }, [
        ...Array(10)
    ].map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            key: index,
            width: "250px",
            height: "9px"
        }))));
module.exports["LoadingState"] = $82e933f8daca37a2$export$62aa48085237e36f;

});

parcelRegister("d5um7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $5Dlqn = parcelRequire("5Dlqn");


var $h11I1 = parcelRequire("h11I1");


var $8AWCX = parcelRequire("8AWCX");

const $6b9c8550570135b2$var$relativeStyles = {
    root: "_1mT5xdRAKS"
}; /**
    * __ExpandableMenuItem__
    *
    * A composable component for nested menu items that can be revealed and hidden by interacting witih the parent menu item.
    *
    * Follows the [disclosure pattern](https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/).
    *
    * Should be used with `ExpandableMenuItemTrigger` as the parent menu item, and children menu items should be wrapped in a `ExpandableMenuItemContent`.
    *
    * Usage example:
    * ```jsx
    * <ExpandableMenuItem>
    *   <ExpandableMenuItemTrigger>Parent menu item</ExpandableMenuItemTrigger>
    *   <ExpandableMenuItemContent>
    *     <ButtonMenuItem>Item 1</ButtonMenuItem>
    *     <ButtonMenuItem>Item 2</ButtonMenuItem>
    *   </ExpandableMenuItemContent>
    * </ExpandableMenuItem>
    * ```
    */ 
const $6b9c8550570135b2$export$341dea48c30b36ff = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(21);
    const { isExpanded: isExpandedControlled, isDefaultExpanded: t1, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId } = t0;
    const isDefaultExpanded = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== isDefaultExpanded) {
        t2 = ()=>isDefaultExpanded;
        $[0] = isDefaultExpanded;
        $[1] = t2;
    } else t2 = $[1];
    const [isExpanded, setIsExpanded] = (0, $5Dlqn.default)(isExpandedControlled, t2);
    const t3 = onExpansionToggle ?? null;
    const t4 = dropIndicator && $6b9c8550570135b2$var$relativeStyles.root;
    let t5;
    if ($[2] !== t4) {
        t5 = (0, $hekY6.default)([
            t4
        ]);
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== children || $[5] !== dropIndicator || $[6] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t5
        }, children, dropIndicator);
        $[4] = children;
        $[5] = dropIndicator;
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== forwardedRef || $[9] !== t6 || $[10] !== testId) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $h11I1.MenuListItem), {
            ref: forwardedRef,
            testId: testId
        }, t6);
        $[8] = forwardedRef;
        $[9] = t6;
        $[10] = testId;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== t3 || $[13] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.OnExpansionToggleContext).Provider, {
            value: t3
        }, t7);
        $[12] = t3;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== setIsExpanded || $[16] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.SetIsExpandedContext).Provider, {
            value: setIsExpanded
        }, t8);
        $[15] = setIsExpanded;
        $[16] = t8;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== isExpanded || $[19] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.IsExpandedContext).Provider, {
            value: isExpanded
        }, t9);
        $[18] = isExpanded;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    return t10;
} : ({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $5Dlqn.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.IsExpandedContext).Provider, {
        value: isExpanded
    }, /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.SetIsExpandedContext).Provider, {
        value: setIsExpanded
    }, /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.OnExpansionToggleContext).Provider, {
        value: onExpansionToggle ?? null
    }, /*#__PURE__*/ $cozmU.createElement((0, $h11I1.MenuListItem), {
        ref: forwardedRef,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            dropIndicator && $6b9c8550570135b2$var$relativeStyles.root
        ])
    }, children, dropIndicator)))));
});
module.exports["ExpandableMenuItem"] = $6b9c8550570135b2$export$341dea48c30b36ff;

});

parcelRegister("jZuGB", function(module, exports) {
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $k27u5 = parcelRequire("k27u5");


var $8AWCX = parcelRequire("8AWCX");

const $9c28a97efb757560$var$expandableMenuItemIndentation = '12px';
const $9c28a97efb757560$var$styles = {
    content: "_0LQT5ExpxF",
    collapsedContent: "_3iDTPbYbGa"
};
const $9c28a97efb757560$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $8AWCX.useIsExpanded)();
    const level = (0, $8AWCX.useLevel)();
    const hasExpanded = (0, $cozmU.useRef)(false);
    const areAllAncestorsExpanded = (0, $8AWCX.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.LevelContext).Provider, {
        value: level + 1
    }, /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.AreAllAncestorsExpandedContext).Provider, {
        value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded
    }, /*#__PURE__*/ $cozmU.createElement((0, $k27u5.List), {
        ref: forwardedRef,
        xcss: (0, $k12R1.cx)($9c28a97efb757560$var$styles.content, !isExpanded && $9c28a97efb757560$var$styles.collapsedContent)
    }, children)));
});
module.exports["ExpandableMenuItemContent"] = $9c28a97efb757560$export$bd680a81504a92e9;

});

parcelRegister("gMhPZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $4Qc44 = parcelRequire("4Qc44");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $KuePV = parcelRequire("KuePV");


var $4o9cR = parcelRequire("4o9cR");


var $8AWCX = parcelRequire("8AWCX");

const $17b37eab23d553a8$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $17b37eab23d553a8$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $17b37eab23d553a8$var$wrapperStyles = {
    root: "_3RTSTAQ4SZ _2MvGBxYbGa",
    showProvidedElemBefore: "_3RTSTAYbGa _2MvGBxcK7c _3g4o8sQ4SZ _1H0K9XYbGa _0Jml7pQ4SZ _4sQNN8Q4SZ _2zl65PYbGa _1FfrqxYbGa"
}; // Merge back into the `wrapperStyles` after cleanup
const $17b37eab23d553a8$var$nestedOpenPopupStyles = {
    showProvidedElemBefore: "_3g4o8sQ4SZ _1H0K9XYbGa"
};
const $17b37eab23d553a8$var$iconStyles = {
    chevron: "_3iDTPbismd _4lYzgRyz1h",
    providedElemBefore: "_3iDTPbC5M9",
    providedElemBeforeSelected: "_1UtDYzrFwf"
};
const $17b37eab23d553a8$var$ExpandableMenuItemIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore } = t0;
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const t1 = isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined;
    let t2;
    if ($[0] !== ChevronIcon || $[1] !== iconProps || $[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ChevronIcon, {
            ...iconProps,
            label: "",
            color: t1,
            size: "small"
        });
        $[0] = ChevronIcon;
        $[1] = iconProps;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const chevronElem = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $17b37eab23d553a8$var$iconStyles.chevron
        ]);
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== chevronElem) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t3
        }, chevronElem);
        $[5] = chevronElem;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isSelected || $[8] !== providedElemBefore) {
        t5 = providedElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $17b37eab23d553a8$var$iconStyles.providedElemBefore,
                isSelected && $17b37eab23d553a8$var$iconStyles.providedElemBeforeSelected
            ])
        }, providedElemBefore);
        $[7] = isSelected;
        $[8] = providedElemBefore;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t5);
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const chevronElem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $17b37eab23d553a8$var$iconStyles.chevron
        ])
    }, chevronElem), providedElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $17b37eab23d553a8$var$iconStyles.providedElemBefore,
            isSelected && $17b37eab23d553a8$var$iconStyles.providedElemBeforeSelected
        ])
    }, providedElemBefore));
};
const $17b37eab23d553a8$export$fe6fe51056867f4d = (0, $4Qc44.default)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const id = (0, $cozmU.useId)();
    const onExpansionToggle = (0, $8AWCX.useOnExpansionToggle)();
    const isExpanded = (0, $8AWCX.useIsExpanded)();
    const setIsExpanded = (0, $8AWCX.useSetIsExpanded)();
    const itemRef = (0, $cozmU.useRef)(null);
    const handleIconClick = (0, $cozmU.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $4o9cR.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    }); // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($17b37eab23d553a8$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        // screen readers on what will actually be expanded or collapsed. Screen readers will also use the
        // `aria-expanded` attribute to indicate the expanded state of the menu item.
        // We are not using the `aria-label` attribute here as it is not supported by the `IconButton` component.
        "aria-labelledby": id,
        // `aria-labelledby`, which will be used instead.
        label: "",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName,
        testId: testId ? `${testId}--elem-before-button` : undefined
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($17b37eab23d553a8$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    }); // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: itemRef,
        className: (0, $hekY6.default)([
            $17b37eab23d553a8$var$wrapperStyles.root,
            providedElemBefore && $17b37eab23d553a8$var$wrapperStyles.showProvidedElemBefore,
            $17b37eab23d553a8$var$nestedOpenPopupStyles.showProvidedElemBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KuePV.MenuItemBase), {
        id: id,
        actions: actions,
        actionsOnHover: actionsOnHover,
        elemBefore: elemBefore,
        ariaExpanded: isExpanded,
        elemAfter: elemAfter,
        href: href,
        isSelected: isSelected,
        onClick: handleMenuContentClick,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        testId: testId,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
});
module.exports["ExpandableMenuItemTrigger"] = $17b37eab23d553a8$export$fe6fe51056867f4d;

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kSwu1 = parcelRequire("kSwu1");


var $cozmU = parcelRequire("cozmU");


var $isuYJ = parcelRequire("isuYJ");


var $hzmpb = parcelRequire("hzmpb");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $7Ndnw = parcelRequire("7Ndnw");


var $6qkXi = parcelRequire("6qkXi");

/**
 * Discovery is filtered by space/page, visibility and context mode, so SSR data
 * (including an empty list) is reusable only for an equivalent request. Space-only
 * requests intentionally ignore contentId. Callers check module eligibility,
 * errors and snapshot lifetime separately.
 */ const $8eb9026be26e0c85$var$matchesExtensionListContext = (preloadedContext, currentContext)=>preloadedContext !== undefined && preloadedContext.spaceKey === currentContext.spaceKey && preloadedContext.includeHidden === currentContext.includeHidden && preloadedContext.spaceContextOnly === currentContext.spaceContextOnly && (currentContext.spaceContextOnly || preloadedContext.contentId === currentContext.contentId);
const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly, skipSpaceDetail: t3, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const skipSpaceDetail = t3 === undefined ? false : t3;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = attachmentId && (0, $9wGTI.fg)("forge_attachment_display_conditions") ? attachmentId : undefined;
    let t4;
    if ($[0] !== skipSpaceDetail) {
        t4 = {
            skip: skipSpaceDetail
        };
        $[0] = skipSpaceDetail;
        $[1] = t4;
    } else t4 = $[1];
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey, t4);
    let t5;
    if ($[2] !== moduleType) {
        t5 = ()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType];
        $[2] = moduleType;
        $[3] = t5;
    } else t5 = $[3];
    const [ssrExtensionResult] = (0, $cozmU.useState)(t5);
    const currentContext = {
        spaceKey: spaceKey,
        contentId: contentId,
        includeHidden: returnBlockedExtensions,
        spaceContextOnly: Boolean(spaceContextOnly)
    };
    let t6;
    if ($[4] !== isTransition || $[5] !== moduleType || $[6] !== resolvedAttachmentId || $[7] !== skipQuery || $[8] !== ssrExtensionResult) {
        t6 = !skipQuery && !resolvedAttachmentId && moduleType === (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER) && !isTransition && (0, $6mKj3.expValEquals)("confluence_ssr_forge_page_banner", "isEnabled", true) ? ssrExtensionResult : undefined;
        $[4] = isTransition;
        $[5] = moduleType;
        $[6] = resolvedAttachmentId;
        $[7] = skipQuery;
        $[8] = ssrExtensionResult;
        $[9] = t6;
    } else t6 = $[9];
    const pageBannerSSRResult = t6;
    const preloadedPageBanners = pageBannerSSRResult !== undefined && !pageBannerSSRResult.error && $8eb9026be26e0c85$var$matchesExtensionListContext(pageBannerSSRResult.context, currentContext) ? pageBannerSSRResult : undefined;
    const t7 = skipQuery || preloadedPageBanners !== undefined;
    let t8;
    if ($[10] !== cloudId || $[11] !== contentId || $[12] !== locale || $[13] !== moduleType || $[14] !== queryOptions || $[15] !== resolvedAttachmentId || $[16] !== returnBlockedExtensions || $[17] !== spaceContextOnly || $[18] !== spaceKey || $[19] !== t7) {
        t8 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: t7
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        });
        $[10] = cloudId;
        $[11] = contentId;
        $[12] = locale;
        $[13] = moduleType;
        $[14] = queryOptions;
        $[15] = resolvedAttachmentId;
        $[16] = returnBlockedExtensions;
        $[17] = spaceContextOnly;
        $[18] = spaceKey;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    const options = t8;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t10;
    let t9;
    if ($[21] !== extsError || $[22] !== spaceError) {
        t9 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t10 = [
            extsError,
            spaceError
        ];
        $[21] = extsError;
        $[22] = spaceError;
        $[23] = t10;
        $[24] = t9;
    } else {
        t10 = $[23];
        t9 = $[24];
    }
    (0, $cozmU.useEffect)(t9, t10);
    if (preloadedPageBanners) {
        let t11;
        if ($[25] !== preloadedPageBanners.extensions) {
            t11 = {
                extensions: preloadedPageBanners.extensions,
                loading: false,
                error: undefined,
                isSSRResult: true
            };
            $[25] = preloadedPageBanners.extensions;
            $[26] = t11;
        } else t11 = $[26];
        return t11;
    }
    if (!skipQuery && extsLoading && ssrExtensionResult !== undefined && $8eb9026be26e0c85$var$matchesExtensionListContext(ssrExtensionResult.context, currentContext) && (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) || moduleType === (0, $7Ndnw.FORGE_MODULE_BYLINE) && (0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true))) {
        let t11;
        if ($[27] !== ssrExtensionResult.error || $[28] !== ssrExtensionResult.extensions) {
            t11 = {
                extensions: ssrExtensionResult.extensions,
                loading: false,
                error: ssrExtensionResult.error
            };
            $[27] = ssrExtensionResult.error;
            $[28] = ssrExtensionResult.extensions;
            $[29] = t11;
        } else t11 = $[29];
        return t11;
    }
    let t11;
    if ($[30] !== extsData || $[31] !== extsError || $[32] !== extsLoading) {
        t11 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[30] = extsData;
        $[31] = extsError;
        $[32] = extsLoading;
        $[33] = t11;
    } else t11 = $[33];
    return t11;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly, skipSpaceDetail: skipSpaceDetail = false, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey })=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey, {
        skip: skipSpaceDetail
    });
    const [ssrExtensionResult] = (0, $cozmU.useState)(()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType]);
    const currentContext = {
        spaceKey: spaceKey,
        contentId: contentId,
        includeHidden: returnBlockedExtensions,
        spaceContextOnly: Boolean(spaceContextOnly)
    };
    // The boot payload belongs to the initial route. Never reuse it after navigation,
    // including when the user returns to the page that originally produced it.
    // Evaluate eligibility before inspecting the payload so control loads are exposed too.
    const pageBannerSSRResult = !skipQuery && !resolvedAttachmentId && moduleType === (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER) && !isTransition && (0, $6mKj3.expValEquals)('confluence_ssr_forge_page_banner', 'isEnabled', true) ? ssrExtensionResult : undefined;
    const preloadedPageBanners = pageBannerSSRResult !== undefined && !pageBannerSSRResult.error && $8eb9026be26e0c85$var$matchesExtensionListContext(pageBannerSSRResult.context, currentContext) ? pageBannerSSRResult : undefined;
    const options = (0, $cozmU.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery || preloadedPageBanners !== undefined
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        preloadedPageBanners,
        spaceKey,
        contentId,
        resolvedAttachmentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $cozmU.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    if (preloadedPageBanners) return {
        extensions: preloadedPageBanners.extensions,
        loading: false,
        error: undefined,
        isSSRResult: true
    };
    if (!skipQuery && extsLoading && ssrExtensionResult !== undefined && $8eb9026be26e0c85$var$matchesExtensionListContext(ssrExtensionResult.context, currentContext) && (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) || moduleType === (0, $7Ndnw.FORGE_MODULE_BYLINE) && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true))) return {
        extensions: ssrExtensionResult.extensions,
        loading: false,
        error: ssrExtensionResult.error
    };
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $isuYJ.conditionalHooksFactory)(// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $hzmpb.usePrefilteredExtensionListRelay), (0, $hzmpb.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("isuYJ", function(module, exports) {

var $d5Ozc = parcelRequire("d5Ozc");

function $a1048cda8104f400$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[0, $d5Ozc.CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}
module.exports["conditionalHooksFactory"] = $a1048cda8104f400$export$691e93bad45e6f07;

});

parcelRegister("d5Ozc", function(module, exports) {
const $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] = globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] || new WeakMap();
module.exports["CACHE_MAP_KEY"] = $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a;

});

parcelRegister("kqIWy", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $4ZxLt = parcelRequire("4ZxLt");


var $cozmU = parcelRequire("cozmU");


var $jtuBN = parcelRequire("jtuBN");


var $89u2G = parcelRequire("89u2G");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey, t0)=>{
    const $ = (0, $bDgLe.c)(23);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { includeSpaceTypeSettings: t2, skip: t3 } = t1;
    const includeSpaceTypeSettings = t2 === undefined ? false : t2;
    const skip = t3 === undefined ? false : t3;
    const sharedDetail = (0, $cozmU.useContext)((0, $89u2G.SpaceDetailContext));
    const canUseSharedDetail = Boolean(spaceKey) && sharedDetail?.spaceKey === spaceKey && (!includeSpaceTypeSettings || sharedDetail?.space?.spaceTypeSettings !== undefined);
    let t4;
    if ($[2] !== includeSpaceTypeSettings || $[3] !== spaceKey) {
        t4 = {
            spaceKey: spaceKey,
            includeSpaceTypeSettings: includeSpaceTypeSettings
        };
        $[2] = includeSpaceTypeSettings;
        $[3] = spaceKey;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== canUseSharedDetail || $[6] !== skip) {
        t5 = skip || canUseSharedDetail ? {
            skip: true
        } : {};
        $[5] = canUseSharedDetail;
        $[6] = skip;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t4 || $[9] !== t5) {
        t6 = {
            variables: t4,
            ...t5
        };
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const options = t6;
    const legacyResult = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), {
        ...options,
        __callerPackage__: "space-utils"
    });
    if (skip) {
        let t7;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                loading: false
            };
            $[11] = t7;
        } else t7 = $[11];
        return t7;
    }
    let t7;
    if ($[12] !== canUseSharedDetail || $[13] !== legacyResult || $[14] !== sharedDetail) {
        t7 = canUseSharedDetail && sharedDetail ? {
            loading: sharedDetail.loading,
            data: sharedDetail.space ? {
                space: sharedDetail.space
            } : undefined,
            error: undefined
        } : legacyResult;
        $[12] = canUseSharedDetail;
        $[13] = legacyResult;
        $[14] = sharedDetail;
        $[15] = t7;
    } else t7 = $[15];
    const { loading: loading, data: data, error: error } = t7;
    let t8;
    if ($[16] !== data || $[17] !== includeSpaceTypeSettings) {
        t8 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path,
            typeSettings: includeSpaceTypeSettings && data.space?.spaceTypeSettings ? {
                enabledContentTypes: {
                    ...data.space.spaceTypeSettings.enabledContentTypes
                }
            } : undefined
        } : undefined;
        $[16] = data;
        $[17] = includeSpaceTypeSettings;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== error || $[20] !== loading || $[21] !== t8) {
        t9 = {
            loading: loading,
            data: t8,
            error: error
        };
        $[19] = error;
        $[20] = loading;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<76836bee9d3181bb32ece1357a68e03f>>
 * @relayHash 8503b5ca122c8b61cd10af1b1c2004c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSpaceTypeSettings"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "condition": "includeSpaceTypeSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceTypeSettings",
                            "kind": "LinkedField",
                            "name": "spaceTypeSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EnabledContentTypes",
                                    "kind": "LinkedField",
                                    "name": "enabledContentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLivePagesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isWhiteboardsEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDatabasesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSlidesEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8503b5ca122c8b61cd10af1b1c2004c9",
            "id": "3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String,$includeSpaceTypeSettings:Boolean!){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings@include(if:$includeSpaceTypeSettings){enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled,isSlidesEnabled}}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "591d4790bc30ed0352bb44ad552d45cb";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("89u2G", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $452d11e5a10e2733$export$4ae6180efef498fb = (0, $cozmU.createContext)(undefined);
module.exports["SpaceDetailContext"] = $452d11e5a10e2733$export$4ae6180efef498fb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$3d2f468c166bad70 = 'confluence:attachmentAction';
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$3d2f468c166bad70,
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_ATTACHMENT_ACTION"] = $af2b0e533822f413$export$3d2f468c166bad70;
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("6qkXi", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, attachmentId: attachmentId, spaceContextOnly: spaceContextOnly = false })=>{
    const context = spaceContextOnly ? {
        spaceKey: spaceKey
    } : {
        spaceKey: spaceKey,
        contentId: contentId,
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        ...attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? {
            attachmentId: attachmentId
        } : {}
    };
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: context,
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("gKr8t", function(module, exports) {

var $9B4fQ = parcelRequire("9B4fQ");


var $10d5H = parcelRequire("10d5H");


var $7G1r9 = parcelRequire("7G1r9");


var $2bfWW = parcelRequire("2bfWW");


var $cC0P5 = parcelRequire("cC0P5");


var $adWn1 = parcelRequire("adWn1");


var $9jPdT = parcelRequire("9jPdT");




var $iMHGI = parcelRequire("iMHGI");


var $8xqRi = parcelRequire("8xqRi");


var $3cnNA = parcelRequire("3cnNA");



var $11MAl = parcelRequire("11MAl");


var $5c4nm = parcelRequire("5c4nm");

let $6d0c6b833ab477dd$var$apolloClient = null;
const $6d0c6b833ab477dd$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)();
const $6d0c6b833ab477dd$export$ed315e0c0d70f648 = 'agg';
const $6d0c6b833ab477dd$var$fragmentMatcher = new (0, $cC0P5.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($adWn1)))
        }
    }
});
const $6d0c6b833ab477dd$export$8ddb56c88a6a3feb = new (0, $5c4nm.BroadcastConfigurableInMemoryCache)({
    fragmentMatcher: $6d0c6b833ab477dd$var$fragmentMatcher
});
const $6d0c6b833ab477dd$export$73fc90876f9d2053 = ()=>{
    $6d0c6b833ab477dd$var$apolloClient = null;
};
const $6d0c6b833ab477dd$export$13fdb03e350a572c = ()=>{
    // Use mock gateway Apollo client in tests
    if (window.MOCK_GATEWAY_APOLLO_CLIENT) return window.MOCK_GATEWAY_APOLLO_CLIENT;
    if (!$6d0c6b833ab477dd$var$apolloClient) {
        $6d0c6b833ab477dd$var$apolloClient = $6d0c6b833ab477dd$var$createApolloClient();
        window.GLOBAL_APOLLO_AGG_CLIENT = $6d0c6b833ab477dd$var$apolloClient;
    }
    return $6d0c6b833ab477dd$var$apolloClient;
};
const $6d0c6b833ab477dd$var$createLinks = ()=>{
    const links = [
        (0, $9jPdT.createOnErrorLink)()
    ];
    const subscriptionLinks = [];
    links.push((0, $11MAl.SSRClientLink)($6d0c6b833ab477dd$export$ed315e0c0d70f648, $6d0c6b833ab477dd$export$8ddb56c88a6a3feb));
    subscriptionLinks.push((0, $3cnNA.AttachExtensionsLink));
    subscriptionLinks.push((0, $8xqRi.getAGGWebSocketLinkInstance)());
    links.push(new (0, $2bfWW.HttpLink)({
        credentials: 'include',
        uri: '/gateway/api/graphql',
        fetch: $6d0c6b833ab477dd$var$wrappedFetch
    }));
    return (0, $10d5H.split)(// Condition for handling subscriptions
    // we don't want to use subscriptions in SSR mode
    ({ query: query })=>{
        const definition = (0, $7G1r9.getMainDefinition)(query);
        return definition?.kind === 'OperationDefinition' && definition?.operation === 'subscription' && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        true;
    }, // WebSocket link for subscriptions
    (0, $10d5H.from)(subscriptionLinks), // HTTP link for non-subscription operations
    (0, $10d5H.from)(links));
};
const $6d0c6b833ab477dd$var$createApolloClient = ()=>{
    if (typeof window['__APOLLO_AGG_STATE__'] === 'object') $6d0c6b833ab477dd$export$8ddb56c88a6a3feb.restore(window['__APOLLO_AGG_STATE__']);
    const client = new (0, $9B4fQ.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        connectToDevTools: false,
        link: (0, $10d5H.from)([
            $6d0c6b833ab477dd$var$createLinks()
        ]),
        cache: $6d0c6b833ab477dd$export$8ddb56c88a6a3feb
    });
    // This is not actual API from Apollo. This field is read in next/packages/ssr-app/src/module-replacements/apollo-client.js
    client.__isAGGClient = true;
    return client;
};
module.exports["apolloAGGCache"] = $6d0c6b833ab477dd$export$8ddb56c88a6a3feb;
module.exports["getAGGClient"] = $6d0c6b833ab477dd$export$13fdb03e350a572c;

});

parcelRegister("8xqRi", function(module, exports) {

var $4cvLo = parcelRequire("4cvLo");

function $aa9065bb91596100$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}
let $aa9065bb91596100$var$wsLink;
function $aa9065bb91596100$export$4b71fe053d09625a() {
    const WEBSOCKET_URL = $aa9065bb91596100$export$91893b414ff080f2();
    if (!$aa9065bb91596100$var$wsLink) $aa9065bb91596100$var$wsLink = new (0, $4cvLo.GraphQLWSLink)({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        keepAlive: (0, $4cvLo.KEEP_ALIVE),
        retryAttempts: 5
    });
    return $aa9065bb91596100$var$wsLink;
}
module.exports["getAGGWebSocketLinkInstance"] = $aa9065bb91596100$export$4b71fe053d09625a;

});

parcelRegister("4cvLo", function(module, exports) {

var $bKqeQ = parcelRequire("bKqeQ");


var $10d5H = parcelRequire("10d5H");


var $bPh6H = parcelRequire("bPh6H");


var $7m1pr = parcelRequire("7m1pr");


var $04e9M = parcelRequire("04e9M");


var $dbZMH = parcelRequire("dbZMH");


var $ac4MN = parcelRequire("ac4MN");


var $bBofs = parcelRequire("bBofs");

const $fca9c472df15863c$export$e9ff5bb5c39478ed = 600000;
class $fca9c472df15863c$export$b26b2f8eae2af9a extends (0, $10d5H.ApolloLink) {
    request(operation) {
        // Add null check for operation.getContext to prevent "Cannot read properties of undefined" errors
        const context = operation.getContext?.() || {};
        // context is coming from a previous link since we are using apollo v2
        // subscriptions does not have context or extensions in some cases
        return new (0, $10d5H.Observable)((observer)=>{
            const subscription = this.client.subscribe({
                ...operation,
                query: (0, $bPh6H.print)(operation.query),
                extensions: context?.extensions
            }, {
                next: (result)=>{
                    // Transform null data to empty object
                    const transformedResult = {
                        ...result,
                        data: result.data === null ? {} : result.data
                    };
                    observer.next(transformedResult);
                },
                complete: observer.complete.bind(observer),
                error: (err)=>{
                    if (this.closedInfo && !this.closedInfo?.wasClean && !err?.message) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                        client.sendOperationalEvent({
                            source: 'confluence-AGGWebSocketLink',
                            actionSubject: 'webSocket',
                            action: 'closed-socket-error',
                            attributes: {
                                reason: this.closedInfo?.reason,
                                code: this.closedInfo?.code,
                                wasClean: this.closedInfo?.wasClean
                            }
                        });
                    });
                    if (err instanceof Error) return observer.error(err);
                    return observer.error(new (0, $7m1pr.RelayError)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
            // keep track of the subscription so we can unsubscribe later
            this.replayQueries[operation.operationName] = {
                unsubscribe: subscription,
                query: (0, $bPh6H.print)(operation.query)
            };
            return subscription;
        });
    }
    constructor(options){
        super();
        this.client = void 0;
        this.internetConnectionState = 'healthy';
        this.timedOut = null;
        this.closedInfo = null;
        this.replayQueries = {};
        this.currentGetInternetConnectionStatePromise = null;
        this.onConnected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected'
                });
            });
        };
        this.verifyAndUpdateInternetHealth = async ()=>{
            this.currentGetInternetConnectionStatePromise = this.currentGetInternetConnectionStatePromise || (0, $dbZMH.getInternetConnectionState)();
            const internetHealthState = await this.currentGetInternetConnectionStatePromise;
            this.internetConnectionState = internetHealthState;
            this.currentGetInternetConnectionStatePromise = null;
        };
        this.verifyAndUpdateInternetHealthUntilHealthy = async ()=>{
            await this.verifyAndUpdateInternetHealth();
            if (this.internetConnectionState === 'healthy') return;
            else this.client?.terminate();
            await new Promise((resolve)=>{
                setTimeout(resolve, 500);
            });
            return this.verifyAndUpdateInternetHealthUntilHealthy();
        };
        this.retryWait = async (retries)=>{
            const retryDelayRange = await (0, $ac4MN.getDelayRangeFromGraphqlWebsocketState)(retries);
            // This is the logic reused from legacy WebSocket with a check verifyAndUpdateInternetHealthUntilHealthy
            // If the internet connection is healthy then we can retry, otherwise we do not need to retry
            // We subtract the time spent waiting to reconnect from the exponential backoff
            const startedAt = Date.now();
            await this.verifyAndUpdateInternetHealthUntilHealthy();
            // since we took some time to verify internet health, reduce the exponential backoff
            const msCheckingInternetHealth = Date.now() - startedAt;
            const retryDelay = (0, $ac4MN.getBackOffDelay)({
                range: retryDelayRange,
                timeSpent: msCheckingInternetHealth
            });
            // monitor status looks at if a user is idle or hidden to determine the retry delay
            await new Promise((resolve)=>{
                let timeoutId = setTimeout(resolve, retryDelay);
                const newRetryDelayRange = (0, $bBofs.calculateBackOffRange)({
                    status: 'active',
                    attemptsCount: retries
                });
                const msAlreadyWaited = Date.now() - startedAt;
                const newRetryDelay = (0, $ac4MN.getBackOffDelay)({
                    range: newRetryDelayRange,
                    timeSpent: msAlreadyWaited
                });
                const actualReconnectionDelay = Math.max(newRetryDelay - msAlreadyWaited, 0);
                // Clear old timeout and set a new one with the updated delay
                clearTimeout(timeoutId);
                timeoutId = setTimeout(resolve, actualReconnectionDelay);
            });
        };
        this.client = (0, $bKqeQ.createClient)({
            ...options,
            retryWait: this.retryWait,
            on: {
                connected: this.onConnected,
                closed: (info)=>{
                    this.closedInfo = info;
                },
                ping: (received)=>{
                    if (!received /* sent */ ) this.timedOut = setTimeout(()=>{
                        // unsubscribe so that we can reconnect with new arguments
                        for(const key in this.replayQueries)// unsubscribes queries so that we can reconnect with new arguments
                        if (this.replayQueries[key]) {
                            this.replayQueries[key].unsubscribe();
                            delete this.replayQueries[key];
                        }
                        this.client.terminate();
                    }, $fca9c472df15863c$export$e9ff5bb5c39478ed / 2);
                },
                pong: (received)=>{
                    if (received && this.timedOut !== null) clearTimeout(this.timedOut);
                }
            }
        });
    }
}
module.exports["KEEP_ALIVE"] = $fca9c472df15863c$export$e9ff5bb5c39478ed;
module.exports["GraphQLWSLink"] = $fca9c472df15863c$export$b26b2f8eae2af9a;

});

parcelRegister("dbZMH", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getInternetConnectionState.ts when we move to Relay.
 */ // partially copied from Trello modified to use confluences network check
const $3d23f6bbdf409903$export$ddfffe3f5c167fa6 = async ()=>{
    // we can early return unhealthy if offline for navigator, but we cant if onLine.
    // That's because you can be online, but be waiting for VPN connection or something
    // else that blocks actually allowing internet.
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!navigator.onLine) return 'unhealthy';
    for(let i = 0; i < 3; i++){
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (!navigator.onLine) return 'unhealthy';
        // stagger it a little because of flakey VPN's and firewalls
        await new Promise((res)=>setTimeout(res, 1000));
    }
    // we got 3 good attempts, safe to say healthy
    return 'healthy';
};
module.exports["getInternetConnectionState"] = $3d23f6bbdf409903$export$ddfffe3f5c167fa6;

});

parcelRegister("ac4MN", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getBackOffDelay.ts when we move to Relay.
 */ // copied from Trello

var $bBofs = parcelRequire("bBofs");

function $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(start, end) {
    const spread = end - start;
    return Math.floor(start + Math.random() * spread);
}
const $5a87cb4548ea235b$export$73e02b3a26ecb0d7 = ({ range: range, timeSpent: timeSpent = 0 })=>{
    const [lowerBound, upperBound] = range;
    const delay = $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(lowerBound, upperBound);
    return Math.max(delay - timeSpent, 0);
};
const $5a87cb4548ea235b$export$ac8ba6656a385f56 = async (retries)=>{
    /**
	 * We're overriding the status multipliers here to make the reconnection
	 * back-off less aggressive. To reduce client
	 * reconnect load on graphql-subscriptions.
	 * The default status multipliers are: { active: 1, idle: 10 }.
	 */ const activeMultiplier = 1;
    let status = 'idle';
    if (typeof window !== 'undefined') // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    status = document.visibilityState === 'visible' ? 'active' : 'idle';
    else status = 'idle';
    return (0, $bBofs.calculateBackOffRange)({
        status: status,
        attemptsCount: retries,
        statusMultipliersOverride: {
            active: activeMultiplier,
            idle: 10
        }
    });
};
module.exports["getBackOffDelay"] = $5a87cb4548ea235b$export$73e02b3a26ecb0d7;
module.exports["getDelayRangeFromGraphqlWebsocketState"] = $5a87cb4548ea235b$export$ac8ba6656a385f56;

});

parcelRegister("bBofs", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/calculateBackOffRange.ts when we move to Relay.
 */ // copied from Trello

var $11y02 = parcelRequire("11y02");

function $35212ac5bc2e900f$export$de85ae9dfb4a57bc({ status: status, attemptsCount: attemptsCount, statusMultipliersOverride: statusMultipliersOverride, jitterStatusMultipliersOverride: jitterStatusMultipliersOverride, connectionHealth: connectionHealth = 'base', baseLowerBoundOverride: baseLowerBoundOverride, baseUpperBoundOverride: baseUpperBoundOverride, maxDelayOverride: maxDelayOverride }) {
    const [baseLowerBound, baseUpperBound] = (0, $11y02.getReconnectDelayBounds)(connectionHealth);
    const maxDelay = maxDelayOverride ?? (0, $11y02.getMaxDelay)({
        status: status,
        connectionHealth: connectionHealth
    });
    const statusMultipliers = statusMultipliersOverride ?? (0, $11y02.getDefaultStatusMultipliers)();
    const jitterStatusMultipliers = jitterStatusMultipliersOverride ?? (0, $11y02.jitterStatusMultipliers);
    const attemptsMultiplier = Math.pow(2, attemptsCount);
    const totalMultiplier = statusMultipliers[status] * attemptsMultiplier;
    const jitterMultiplier = jitterStatusMultipliers[status];
    const maxFirstActiveDelay = 2000;
    const maxFirstIdleDelay = 60000;
    let tempUpperOverride;
    if (attemptsCount > 0) tempUpperOverride = undefined;
    else if (status === 'active') tempUpperOverride = maxFirstActiveDelay;
    else tempUpperOverride = maxFirstIdleDelay;
    const lowerBound = (baseLowerBoundOverride ?? baseLowerBound) * totalMultiplier;
    const upperBound = tempUpperOverride ?? (baseUpperBoundOverride ?? baseUpperBound) * totalMultiplier * jitterMultiplier;
    return [
        Math.min(lowerBound, maxDelay),
        Math.min(upperBound, maxDelay)
    ];
}
module.exports["calculateBackOffRange"] = $35212ac5bc2e900f$export$de85ae9dfb4a57bc;

});

parcelRegister("11y02", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/backOffConfig.ts when we move to Relay.
 */ // copied from Trello
const $0b8d464841156fc9$var$TEN_MINUTES_IN_MS = 600000;
const $0b8d464841156fc9$export$d89658363be37383 = ({ status: status, connectionHealth: connectionHealth })=>{
    const maxDelays = {
        active: {
            base: 64000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        },
        idle: {
            base: 450000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        }
    };
    return maxDelays[status][connectionHealth];
};
const $0b8d464841156fc9$export$1b131e77a0e75a0a = ()=>({
        active: 1,
        idle: 15
    });
const $0b8d464841156fc9$export$a1d6d3ff41cd93e9 = {
    active: 1,
    idle: 2
};
const $0b8d464841156fc9$export$e5680a2329370bd3 = (connectionHealth)=>{
    const bounds = {
        base: [
            800,
            2000
        ],
        serverIncident: [
            800,
            4000
        ]
    };
    return bounds[connectionHealth];
};
module.exports["getMaxDelay"] = $0b8d464841156fc9$export$d89658363be37383;
module.exports["getDefaultStatusMultipliers"] = $0b8d464841156fc9$export$1b131e77a0e75a0a;
module.exports["jitterStatusMultipliers"] = $0b8d464841156fc9$export$a1d6d3ff41cd93e9;
module.exports["getReconnectDelayBounds"] = $0b8d464841156fc9$export$e5680a2329370bd3;

});

parcelRegister("3cnNA", function(module, exports) {

var $10d5H = parcelRequire("10d5H");

const $eb414ef0fc36a486$export$51a2bb897a605125 = new (0, $10d5H.ApolloLink)((operation, forward)=>{
    if (operation.variables && operation.variables.__extensions) {
        operation.setContext({
            extensions: operation.variables.__extensions
        });
        // remove the property since it's not an actual valid variable
        delete operation.variables.__extensions;
    }
    return forward(operation);
});
module.exports["AttachExtensionsLink"] = $eb414ef0fc36a486$export$51a2bb897a605125;

});

parcelRegister("9fBoq", function(module, exports) {

var $hBxDy = parcelRequire("hBxDy");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $hBxDy.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $hBxDy.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("hBxDy", function(module, exports) {
var $77348f0599087222$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $77348f0599087222$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $77348f0599087222$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $77348f0599087222$export$beaef1891b3e7ca3;

});

parcelRegister("5tgcI", function(module, exports) {
const $696759caf06ef68c$export$af39e4edc5e74 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-spaces-link';
const $696759caf06ef68c$export$97c436ccc42cbac9 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-people-link';
const $696759caf06ef68c$export$3a7ae658938afc39 = 'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.confluence.emcee__enduser-discover';
const $696759caf06ef68c$export$ee99bc1ad01a63ae = 'com.atlassian.confluence.plugins.confluence-space-ia:header-automation-link';
const $696759caf06ef68c$export$8a23ae6ca6b0c9ee = 'com.atlassian.confluence.extra.team-calendars:header-mycalendar-link';
const $696759caf06ef68c$export$38788381122702f5 = 'com.atlassian.plugins.atlassian-connect-plugin:com.addonengine.analytics__analytics-instance-settings-menu-item-adg3';
const $696759caf06ef68c$export$6c3d789a4f56bea2 = 'com.atlassian.plugins.atlassian-connect-plugin:com.addonengine.analytics.moderate__analytics-instance-settings-menu-item-adg3';
module.exports["SPACES_KEY"] = $696759caf06ef68c$export$af39e4edc5e74;
module.exports["PEOPLE_KEY"] = $696759caf06ef68c$export$97c436ccc42cbac9;
module.exports["DISCOVER_KEY"] = $696759caf06ef68c$export$3a7ae658938afc39;
module.exports["AUTOMATION_KEY"] = $696759caf06ef68c$export$ee99bc1ad01a63ae;
module.exports["CALENDAR_KEY"] = $696759caf06ef68c$export$8a23ae6ca6b0c9ee;
module.exports["ANALYTICS_KEY"] = $696759caf06ef68c$export$38788381122702f5;
module.exports["ANALYTICS_KEY_MODERATE"] = $696759caf06ef68c$export$6c3d789a4f56bea2;

});

parcelRegister("g0ob9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6Ec6w = parcelRequire("6Ec6w");


var $hMcNB = parcelRequire("hMcNB");


var $824lD = parcelRequire("824lD");


var $1TvTa = parcelRequire("1TvTa");


var $5tgcI = parcelRequire("5tgcI");

const $e8563bcd391eebd4$var$iconOverrides = {
    [(0, $5tgcI.AUTOMATION_KEY)]: (0, (/*@__PURE__*/$parcel$interopDefault($hMcNB))),
    [(0, $5tgcI.CALENDAR_KEY)]: (0, (/*@__PURE__*/$parcel$interopDefault($824lD))),
    [(0, $5tgcI.ANALYTICS_KEY)]: (0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))),
    [(0, $5tgcI.ANALYTICS_KEY_MODERATE)]: (0, (/*@__PURE__*/$parcel$interopDefault($1TvTa)))
};
const $e8563bcd391eebd4$export$5153830bdfb71453 = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { url: url, completeKey: completeKey } = t0;
    if (completeKey) {
        const IconOverride = $e8563bcd391eebd4$var$iconOverrides[completeKey];
        if (IconOverride) {
            let t1;
            if ($[0] !== IconOverride) {
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconOverride, null);
                $[0] = IconOverride;
                $[1] = t1;
            } else t1 = $[1];
            return t1;
        }
    }
    if (!url) {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
                label: "",
                color: "currentColor"
            });
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
            id: "changeFillColor"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0.02, 0, 0, 0, 0, 0, 0.04, 0, 0, 0, 0, 0, 0.07, 0, 0, 0, 0, 0, 1, 0"
        })));
        $[3] = t1;
    } else t1 = $[3];
    const t2 = $e8563bcd391eebd4$var$isSvg(url) ? "url(#changeFillColor)" : "";
    let t3;
    if ($[4] !== t2 || $[5] !== url) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            viewBox: "0 0 16 16",
            width: "16",
            height: "16",
            "aria-hidden": "true",
            "data-testid": "app-icon"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("image", {
            xmlnsXlink: "http://www.w3.org/1999/xlink",
            xlinkHref: url,
            width: "16",
            height: "16",
            x: "0",
            y: "0",
            filter: t2
        }));
        $[4] = t2;
        $[5] = url;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
const $e8563bcd391eebd4$var$isSvg = (url)=>{
    const fileType = url.split(/\#|\?/)[0].split('.').pop();
    return !!fileType && fileType.trim() === 'svg';
};
module.exports["AppIcon"] = $e8563bcd391eebd4$export$5153830bdfb71453;

});

parcelRegister("3JnRC", function(module, exports) {

let $2b7815ebcc615b7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2b7815ebcc615b7a$var$load("9jGiN").then(()=>parcelRequire('kvRiJ'));

});

parcelRegister("euip2", function(module, exports) {

let $a8c22471e291981e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a8c22471e291981e$var$load("kIpK2").then(()=>parcelRequire('hRfD7'));

});

parcelRegister("eVSUv", function(module, exports) {

let $adf0fb9d2035d751$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $adf0fb9d2035d751$var$load("60m6Z").then(()=>parcelRequire('7vGOX'));

});

parcelRegister("8dUjs", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");


var $eSLr0 = parcelRequire("eSLr0");


var $7Ndnw = parcelRequire("7Ndnw");


var $5tgcI = parcelRequire("5tgcI");

const $84cd59e06a85be4f$export$a9c446837cd59ef8 = [
    (0, $5tgcI.SPACES_KEY),
    (0, $5tgcI.PEOPLE_KEY),
    (0, $5tgcI.DISCOVER_KEY)
];
const $84cd59e06a85be4f$export$a56df56fab66279e = ({ edition: edition, accessStatus: accessStatus })=>{
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const hideAutomation = edition !== 'PREMIUM' || !isAdmin;
    const notAllowedWebItems = [
        ...$84cd59e06a85be4f$export$a9c446837cd59ef8,
        hideAutomation ? (0, $5tgcI.AUTOMATION_KEY) : ''
    ];
    return {
        webItemParams: {
            location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
            notAllowedWebItems: notAllowedWebItems
        },
        forgeExtensionParams: {
            moduleType: (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
            spaceKey: ''
        }
    };
};
module.exports["getGlobalAppsParams"] = $84cd59e06a85be4f$export$a56df56fab66279e;

});

parcelRegister("cwUrm", function(module, exports) {
const $47cf4dda49ee363d$export$ed52cc3670515af7 = (cloudId)=>({
        tenantId: cloudId,
        product: 'confluence'
    });
module.exports["buildInvitedAppShortcutsRecommendationsVariables"] = $47cf4dda49ee363d$export$ed52cc3670515af7;

});

parcelRegister("6S8lk", function(module, exports) {

let $500e41f85373e4ed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $500e41f85373e4ed$var$load("6wr18"),
    $500e41f85373e4ed$var$load("da5h0"),
    $500e41f85373e4ed$var$load("7EorR"),
    $500e41f85373e4ed$var$load("kHXvF"),
    $500e41f85373e4ed$var$load("ffEVr"),
    $500e41f85373e4ed$var$load("borwc")
]).then(()=>parcelRequire('jhdHU'));

});

parcelRegister("4YUBg", function(module, exports) {
/**
 * @generated SignedSource<<c911df138434165e1df56a149c5ed87d>>
 * @relayHash 3c5abea4712e217d7b3561b0c6d826bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15d301edc65d7aefa1614dec08095e50e15a8fc962561db8174cca939aad4ec8
const $a43ff53f7d2c5ff0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "product"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v2 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "product",
                    "variableName": "product"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "tenantId"
                },
                {
                    "kind": "Literal",
                    "name": "useCase",
                    "value": "invitedAppShortcuts"
                }
            ],
            "kind": "ObjectValue",
            "name": "context"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "entityId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "reasons"
    }, v6 = {
        "kind": "ScalarField",
        "name": "score"
    }, v7 = {
        "concreteType": "GrowthRecContextResult",
        "kind": "LinkedField",
        "name": "context",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "tenantId"
            },
            {
                "kind": "ScalarField",
                "name": "product"
            },
            {
                "kind": "ScalarField",
                "name": "useCase"
            },
            {
                "kind": "ScalarField",
                "name": "sessionId"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v9 = {
        "kind": "ScalarField",
        "name": "message"
    }, v10 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v11 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "InvitedAppShortcutsRecommendationsQuery",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "type": "GrowthRecRecommendations"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "InvitedAppShortcutsRecommendationsQuery",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "type": "GrowthRecRecommendations"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3c5abea4712e217d7b3561b0c6d826bb",
            "id": "15d301edc65d7aefa1614dec08095e50e15a8fc962561db8174cca939aad4ec8",
            "metadata": {},
            "name": "InvitedAppShortcutsRecommendationsQuery",
            "operationKind": "query",
            "text": "query InvitedAppShortcutsRecommendationsQuery($tenantId:ID,$product:String!){growthRecommendations{recommendations(context:{tenantId:$tenantId,product:$product,useCase:\"invitedAppShortcuts\"}){__typename,...on GrowthRecRecommendations{data{__typename,entityId,reasons,score},context{tenantId,product,useCase,sessionId}},...on QueryError{identifier,message,extensions{__typename,statusCode,errorType}}}}}"
        }
    };
}();
$a43ff53f7d2c5ff0$var$node.hash = "186413c3c978a3bb94c6bc4b5f252e32";
var $a43ff53f7d2c5ff0$export$2e2bcd8739ae039 = $a43ff53f7d2c5ff0$var$node;
module.exports["default"] = $a43ff53f7d2c5ff0$export$2e2bcd8739ae039;

});

parcelRegister("aQN68", function(module, exports) {
/**
 * @generated SignedSource<<4397834310e821608aae72d6cd602b23>>
 * @relayHash efbccdac5bb753d6ce419c019fa1aaca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2c716a297065a0b32d13d0ef655d0af2eb808e17bfd7325a7ecbc232e2971439
const $ede2af096215976f$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "efbccdac5bb753d6ce419c019fa1aaca",
            "id": "2c716a297065a0b32d13d0ef655d0af2eb808e17bfd7325a7ecbc232e2971439",
            "metadata": {},
            "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
            "operationKind": "query",
            "text": "query useLicensedProductsQueryForGlobalAppShortcutsQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$ede2af096215976f$var$node.hash = "4173fb2f98b7988a84dc02df0399a348";
var $ede2af096215976f$export$2e2bcd8739ae039 = $ede2af096215976f$var$node;
module.exports["default"] = $ede2af096215976f$export$2e2bcd8739ae039;

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("6Q8Dd", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");

"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $4fae4b715d22864c$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $4fae4b715d22864c$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $4fae4b715d22864c$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $4fae4b715d22864c$var$getValidCacheKeyFn(options);
        this._cacheMap = $4fae4b715d22864c$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $4fae4b715d22864c$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $4fae4b715d22864c$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey; // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            cacheKey = this._cacheKeyFn(key);
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    };
    _proto.loadMany = function loadMany(keys) {
        if (!$4fae4b715d22864c$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    };
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    };
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    };
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $4fae4b715d22864c$var$enqueuePostPromiseJob = typeof $1P2f3 === 'object' && typeof $1P2f3.nextTick === 'function' ? function(fn) {
    if (!$4fae4b715d22864c$var$resolvedPromise) $4fae4b715d22864c$var$resolvedPromise = Promise.resolve();
    $4fae4b715d22864c$var$resolvedPromise.then(function() {
        $1P2f3.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $4fae4b715d22864c$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $4fae4b715d22864c$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $4fae4b715d22864c$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $4fae4b715d22864c$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $4fae4b715d22864c$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $4fae4b715d22864c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $4fae4b715d22864c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$4fae4b715d22864c$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $4fae4b715d22864c$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var _value = values[i];
            if (_value instanceof Error) batch.callbacks[i].reject(_value);
            else batch.callbacks[i].resolve(_value);
        }
    })["catch"](function(error) {
        $4fae4b715d22864c$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $4fae4b715d22864c$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $4fae4b715d22864c$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $4fae4b715d22864c$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $4fae4b715d22864c$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $4fae4b715d22864c$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $4fae4b715d22864c$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $4fae4b715d22864c$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $4fae4b715d22864c$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $4fae4b715d22864c$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $4fae4b715d22864c$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $4fae4b715d22864c$var$DataLoader;

});

parcelRegister("lPEt0", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
}); //# sourceMappingURL=lru.js.map

});

parcelRegister("drRzc", function(module, exports) {

var $4iudd = parcelRequire("4iudd");

class $27efd3461a9c6d27$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        this.updateCache(ssrData, {
            strategy: 'replace',
            source: 'ssr'
        });
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $4iudd.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) // Replace promise with the resolved data in the cache
                this.updateCache({
                    [dataKey]: data
                }, {
                    strategy: 'merge',
                    source: 'network'
                });
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $27efd3461a9c6d27$export$1185db7a00c13eed;

});

parcelRegister("fh15z", function(module, exports) {

var $3Ww6H = parcelRequire("3Ww6H");


var $cNAch = parcelRequire("cNAch");

class $235e9e63ec7037ae$export$ac1cddfee07ba6ac {
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $cNAch.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $3Ww6H.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
    constructor(experienceId, config){
        this.experienceId = void 0;
        this.config = void 0;
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
}
module.exports["ConcurrentExperience"] = $235e9e63ec7037ae$export$ac1cddfee07ba6ac;

});

parcelRegister("2pQiO", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $1295d9cf79f622cc$export$da472ee01c19d92e(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, false);
}
module.exports["UNSAFE_expValNoExposure"] = $1295d9cf79f622cc$export$da472ee01c19d92e;

});

parcelRegister("32x2E", function(module, exports) {

var $1UWNP = parcelRequire("1UWNP");


var $bwAnG = parcelRequire("bwAnG");


var $6mKj3 = parcelRequire("6mKj3");


var $7W8i8 = parcelRequire("7W8i8");


var $51W2Z = parcelRequire("51W2Z");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    // For signed-in users, allowAnonymousAccess does not change the provider config. Sharing the
    // resource lets uploads propagate immediately between editor, title, and reaction pickers.
    const allowAnonymousAccessCacheKey = userId ? false : allowAnonymousAccess;
    return `${cloudId}_${userId}_${allowAnonymousAccessCacheKey}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    if (cloudId && userId && (0, $6mKj3.expValEquals)('confluence_on_demand_emoji_repository', 'isEnabled', true)) return new (0, $51W2Z.OnDemandEmojiResource)({
        ...emojiConfig,
        options: {
            onlyFetchOnDemand: true
        },
        singleEmojiApi: {
            getUrl: ({ id: id, shortName: shortName })=>`${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/${encodeURIComponent(id ?? shortName)}`
        }
    });
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $bwAnG.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("bwAnG", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $l4yrE = parcelRequire("l4yrE");


var $drRzc = parcelRequire("drRzc");

class $dfb1108de4ce4e19$export$67106c51beb59865 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $4iudd.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $4iudd.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $l4yrE.defaultEmojiHeight),
                    width: (0, $l4yrE.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $dfb1108de4ce4e19$export$67106c51beb59865;

});

parcelRegister("51W2Z", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");

const $20b5b351e69bef6e$var$isMediaRepresentation = (representation)=>!!representation && 'mediaPath' in representation;
class $20b5b351e69bef6e$export$cfbb91621ad16c67 extends (0, $kwzZh.default) {
    // filter() reports "not ready" without waiting, so it has to start the fetch itself. The fetch
    // re-runs the last filter when it completes.
    filter(query, options) {
        this.startRepositoryFetch();
        super.filter(query, options);
    }
    async fetchByEmojiId(emojiId, optimistic, emojiProviderLookupOrder) {
        if (!this.emojiProviderConfig.singleEmojiApi || !emojiId.id || this.isRepositoryLoaded()) return super.fetchByEmojiId(emojiId, optimistic, emojiProviderLookupOrder);
        // Emoji ids never contain a slash, but page icons can be URLs, such as a favicon. No emoji list
        // has them, and the single-emoji endpoint rejects them, which would download the repository.
        if (emojiId.id.includes('/')) return undefined;
        // With `optimistic` true, the base class requests just this emoji from singleEmojiApi instead of
        // waiting for the repository. ResourcedEmoji passes its `optimistic` prop, which
        // @atlaskit/reactions leaves off, so force it on until the repository has loaded.
        const emoji = await super.fetchByEmojiId(emojiId, true, emojiProviderLookupOrder);
        // The single-emoji request falls back to the repository when it fails, but not when it finds
        // nothing. With `optimistic` false, the base class waits for the repository, and
        // retryIfLoading starts downloading it.
        return emoji ?? super.fetchByEmojiId(emojiId, false, emojiProviderLookupOrder);
    }
    findById(id) {
        if (!this.emojiProviderConfig.singleEmojiApi || this.isRepositoryLoaded()) return super.findById(id);
        return this.fetchByEmojiId({
            id: id,
            shortName: ''
        }, true);
    }
    retryIfLoading(retry, defaultResponse) {
        this.startRepositoryFetch();
        return super.retryIfLoading(retry, defaultResponse);
    }
    // The single-emoji response can be the first to carry a media token. SiteEmojiResource keeps the
    // URL it is created with for uploads, deletes and token refreshes, so it must get the site provider
    // rather than the single-emoji URL. The base class primes the resource with the first emoji, which
    // throws for a standard or Atlassian emoji and makes the lookup fall back to the repository, so only
    // media emoji are passed on.
    initSiteEmojiResource(emojiResponse, provider) {
        const siteProvider = this.emojiProviderConfig.providers.find(({ url: url })=>url.endsWith('/site'));
        return super.initSiteEmojiResource({
            ...emojiResponse,
            emojis: emojiResponse.emojis.filter(({ representation: representation })=>$20b5b351e69bef6e$var$isMediaRepresentation(representation))
        }, siteProvider ?? provider);
    }
    isRepositoryLoaded() {
        return !!this.emojiRepository && this.initialLoaders !== 0 && this.activeLoaders === 0;
    }
    startRepositoryFetch() {
        if (!this.isInitialised) // Failures are reported through notifyError and the pending retries.
        this.fetchEmojiProvider().catch(()=>{});
    }
}
module.exports["OnDemandEmojiResource"] = $20b5b351e69bef6e$export$cfbb91621ad16c67;

});

parcelRegister("5BvyC", function(module, exports) {

var $eQkRH = parcelRequire("eQkRH");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/blogpost/manifest.ts
var $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $eQkRH.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $eQkRH.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $4148e3160e6a23b4$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $4148e3160e6a23b4$export$8602a2c2f6ac09bc;

});

parcelRegister("eQkRH", function(module, exports) {
// src/confluence/blogpost/types.ts
var $ace61b64202bfb2d$export$9389f06bd1d0765c = "confluence", $ace61b64202bfb2d$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $ace61b64202bfb2d$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $ace61b64202bfb2d$export$fb777a2d645a4129;

});

parcelRegister("8jDil", function(module, exports) {

var $jyUkr = parcelRequire("jyUkr");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/page/manifest.ts
var $60de943ef043ed79$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jyUkr.ConfluencePageAriResourceOwner),
    resourceType: (0, $jyUkr.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $60de943ef043ed79$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $60de943ef043ed79$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $60de943ef043ed79$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $60de943ef043ed79$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $60de943ef043ed79$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $60de943ef043ed79$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $60de943ef043ed79$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $60de943ef043ed79$export$3f931dd15d96caff;

});

parcelRegister("jyUkr", function(module, exports) {
// src/confluence/page/types.ts
var $e3dce2fc5add42f7$export$da53e4f7db4c6a71 = "confluence", $e3dce2fc5add42f7$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $e3dce2fc5add42f7$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $e3dce2fc5add42f7$export$636fc622562a2c5b;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$var$VERSION_HISTORY_CONTENT_TYPE_SET = {
    whiteboard: true,
    database: true,
    slide: true
};
const $2aa2bdb281c6889a$export$4c89eeb173e3fb0e = (contentType)=>!!contentType && Object.prototype.hasOwnProperty.call($2aa2bdb281c6889a$var$VERSION_HISTORY_CONTENT_TYPE_SET, contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["isVersionHistoryContentType"] = $2aa2bdb281c6889a$export$4c89eeb173e3fb0e;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    FeedbackSource["TABS"] = "Tabs";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("b4VFP", function(module, exports) {
const $390e454b1ae488b2$export$1d1c13df264a094 = {
    hasSeenHomeNudge: 'home-onboarding-takeover-v2:hasSeenHomeNudge',
    isHomeNudgeScheduledAt: 'home-onboarding-takeover-v2:isHomeNudgeScheduledAt',
    takeoverSeenAt: 'home-onboarding-takeover-v2:takeoverSeenAt',
    onboardingActionStates: 'home-onboarding-takeover-v2:onboardingActionStates',
    isCollapsed: 'home-onboarding-takeover-v2:isCollapsed',
    hasSeenConfetti: 'home-onboarding-takeover-v2:hasSeenConfetti',
    hasDismissedCarousel: 'home-onboarding-takeover-v2:hasDismissedCarousel',
    hasDismissedLearningResources: 'home-onboarding-takeover-v2:hasDismissedLearningResources',
    hasDismissedTakeover: 'home-onboarding-takeover-v2:hasDismissedTakeover'
};
const $390e454b1ae488b2$export$3392b5b28b589b00 = Object.values($390e454b1ae488b2$export$1d1c13df264a094);
module.exports["HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS"] = $390e454b1ae488b2$export$1d1c13df264a094;
module.exports["HomeTakeoverOnboardingKeys"] = $390e454b1ae488b2$export$3392b5b28b589b00;

});

parcelRegister("l1uFv", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $jclGA = parcelRequire("jclGA");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $7M67g = parcelRequire("7M67g");

function $65c7b8940c778902$export$627cb922211284f(params) {
    const operationName = (0, $7M67g.getRelayOperationName)(params.query);
    return (0, $iffSy.isRelayEnabled)(params.__callerPackage__, {
        operationName: operationName,
        phase: 'cache'
    }) ? $65c7b8940c778902$var$readQueryInteropRelay(params) : $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropRelay(params) {
    const relayEnv = typeof window !== 'undefined' ? window.GLOBAL_RELAY_ENV : undefined;
    if (!relayEnv) throw new Error(`[Relay migration] Missing GLOBAL_RELAY_ENV for readQueryInterop; ${params.__callerPackage__}.`);
    const queryNode = params.query;
    if (!queryNode?.fragment || !queryNode?.operation) return null;
    const variables = params.variables ?? {};
    const operation = (0, $eqEJl.createOperationDescriptor)(queryNode, variables);
    const snapshot = relayEnv.lookup(operation.fragment);
    return snapshot.isMissingData ? null : (0, $jclGA.cloneRelayQueryResult)(snapshot.data);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("8rneB", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["DefaultTitleEmojiValues"] = $61659933fe71a4ee$export$66d7571a7d7aad65;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("c7GB4", function(module, exports) {

var $5BvyC = parcelRequire("5BvyC");

var $lT7Mv = parcelRequire("lT7Mv");

var $k0a0F = parcelRequire("k0a0F");

var $bAV6O = parcelRequire("bAV6O");

var $8jDil = parcelRequire("8jDil");

var $dLbqW = parcelRequire("dLbqW");

var $7GbwS = parcelRequire("7GbwS");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $8jDil.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $5BvyC.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $7GbwS.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $lT7Mv.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $k0a0F.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $bAV6O.ConfluenceFolderAri).parse(ari).folderId;
        case (0, $1ggpj.ContentType).SLIDE:
            return (0, $dLbqW.ConfluenceSlideAri).parse(ari).slideId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("lT7Mv", function(module, exports) {

var $jp6rV = parcelRequire("jp6rV");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/database/manifest.ts
var $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jp6rV.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $jp6rV.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $fef4c53c0d169c78$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $fef4c53c0d169c78$export$317cd32472deea7e;

});

parcelRegister("jp6rV", function(module, exports) {
// src/confluence/database/types.ts
var $e2055ad385da7e5a$export$e83bc7b627335f1d = "confluence", $e2055ad385da7e5a$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $e2055ad385da7e5a$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $e2055ad385da7e5a$export$d26db9a1a0b750aa;

});

parcelRegister("k0a0F", function(module, exports) {

var $1pgGd = parcelRequire("1pgGd");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/embed/manifest.ts
var $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1pgGd.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $1pgGd.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $e8fb927b13f87211$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $e8fb927b13f87211$export$47d4b4205d0ac61a;

});

parcelRegister("1pgGd", function(module, exports) {
// src/confluence/embed/types.ts
var $10651083a44828c2$export$7a02af293cacddd2 = "confluence", $10651083a44828c2$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $10651083a44828c2$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $10651083a44828c2$export$f817d48842ea0d4a;

});

parcelRegister("dLbqW", function(module, exports) {

var $1AG0i = parcelRequire("1AG0i");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/slide/manifest.ts
var $a04888a2b5576260$var$confluenceSlideAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1AG0i.ConfluenceSlideAriResourceOwner),
    resourceType: (0, $1AG0i.ConfluenceSlideAriResourceType),
    resourceIdSlug: "activation/{activationId}/{slideId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        slideId: /[0-9]+/
    }
};
// src/confluence/slide/index.ts
var $a04888a2b5576260$export$86048ac46024146a = class _ConfluenceSlideAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get slideId() {
        return this._slideId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.qualifier,
            platformQualifier: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.resourceOwner,
            resourceType: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.slideId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                slideId: opts.slideId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $a04888a2b5576260$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $a04888a2b5576260$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            slideId: this.slideId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._slideId = opts.resourceIdSegmentValues.slideId;
    }
};
module.exports["ConfluenceSlideAri"] = $a04888a2b5576260$export$86048ac46024146a;

});

parcelRegister("1AG0i", function(module, exports) {
// src/confluence/slide/types.ts
var $1289bc4ba87a8942$export$204fa7edd529d4b3 = "confluence", $1289bc4ba87a8942$export$3de52c55a164daa4 = "slide";
module.exports["ConfluenceSlideAriResourceOwner"] = $1289bc4ba87a8942$export$204fa7edd529d4b3;
module.exports["ConfluenceSlideAriResourceType"] = $1289bc4ba87a8942$export$3de52c55a164daa4;

});

parcelRegister("7GbwS", function(module, exports) {

var $9z7xR = parcelRequire("9z7xR");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/whiteboard/manifest.ts
var $597566211494b449$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $9z7xR.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $9z7xR.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $597566211494b449$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $597566211494b449$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $597566211494b449$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $597566211494b449$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $597566211494b449$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $597566211494b449$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $597566211494b449$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $597566211494b449$export$ba3d25b6768ddb10;

});

parcelRegister("9z7xR", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $6f6d3c41ba97755c$export$6130ea1abbb885ef = "confluence", $6f6d3c41ba97755c$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $6f6d3c41ba97755c$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $6f6d3c41ba97755c$export$d3070d1568a10e2d;

});

parcelRegister("4MnFz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $iXRmn = parcelRequire("iXRmn");

const $878d7a55fd1744f7$export$2879604e6aec4ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
} : function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
};
module.exports["useFlags"] = $878d7a55fd1744f7$export$2879604e6aec4ab;

});

parcelRegister("vZEJe", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $cVoAa = parcelRequire("cVoAa");


var $hHzd2 = parcelRequire("hHzd2");

const $b399db01e99f7201$export$62ed72bc21f6b8a6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DropIndicator(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { appearance: t1, edge: edge, gap: gap, indent: indent, type: type } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const t2 = (0, $hHzd2.presetStrokeColors)[appearance];
    let t3;
    if ($[0] !== edge || $[1] !== gap || $[2] !== indent || $[3] !== t2 || $[4] !== type) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cVoAa.Line), {
            edge: edge,
            gap: gap,
            strokeColor: t2,
            type: type,
            indent: indent
        });
        $[0] = edge;
        $[1] = gap;
        $[2] = indent;
        $[3] = t2;
        $[4] = type;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function DropIndicator({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cVoAa.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $hHzd2.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
};
var // This default export is intended for usage with React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b399db01e99f7201$export$2e2bcd8739ae039 = $b399db01e99f7201$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $b399db01e99f7201$export$62ed72bc21f6b8a6;
module.exports["default"] = $b399db01e99f7201$export$2e2bcd8739ae039;

});

parcelRegister("cVoAa", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $hHzd2 = parcelRequire("hHzd2");

const $06f7f86bfd55e0d2$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $06f7f86bfd55e0d2$var$baseStyles = {
    root: "_3iDTPbvLZJ _1mT5xdWVPG _42Yu6B7dHp _1pp6NdYbGa _0KLXrul0Q1 _1Oimfu715P _0eGJOxOn88 _1nRsHk6wH8 _2KinTkl0Q1 _0OU75rKWn1 _3Ku51Iogpp _3dCYwDWVPG _2DsrY12Njc _3ScelF3U6W _1lBcDc3U6W"
};
const $06f7f86bfd55e0d2$var$orientationStyles = {
    horizontal: "_0jFU0VOn88 _3iC0zdfRAD _1OKFqYdnbC _2jTvwtWjDq",
    vertical: "_39xV02On88 _2IhTonfRAD _0Bm75GdnbC _35I30BWjDq"
};
const $06f7f86bfd55e0d2$var$edgeStyles = {
    top: "_2IhTon5Cwg _35I30BHqe5",
    right: "_4ApkO25Cwg _1D2b5MHqe5",
    bottom: "_0Bm75G5Cwg _31ReDyHqe5",
    left: "_3OE6xY5Cwg _1L3m71Hqe5"
};
const $06f7f86bfd55e0d2$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
const $06f7f86bfd55e0d2$export$17d680238e50603e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Line(t0) {
    const $ = (0, $bDgLe.c)(15);
    const { edge: edge, gap: t1, indent: t2, strokeColor: t3, strokeWidth: t4, type: t5 } = t0;
    const gap = t1 === undefined ? "0px" : t1;
    const indent = t2 === undefined ? "0px" : t2;
    const strokeColor = t3 === undefined ? (0, $hHzd2.presetStrokeColors).default : t3;
    const strokeWidth = t4 === undefined ? (0, $hHzd2.presetStrokeWidth) : t4;
    const type = t5 === undefined ? "terminal" : t5;
    const orientation = $06f7f86bfd55e0d2$var$edgeToOrientationMap[edge];
    const t6 = `calc(-0.5 * (${gap} + var(--stroke-width)))`;
    let t7;
    if ($[0] !== indent || $[1] !== type) {
        t7 = $06f7f86bfd55e0d2$var$lineStartFrom[type]({
            indent: indent
        });
        $[0] = indent;
        $[1] = type;
        $[2] = t7;
    } else t7 = $[2];
    const t8 = type === "no-terminal" ? "none" : "block";
    let t9;
    if ($[3] !== strokeColor || $[4] !== strokeWidth || $[5] !== t6 || $[6] !== t7 || $[7] !== t8) {
        t9 = {
            "--stroke-color": strokeColor,
            "--stroke-width": strokeWidth,
            "--main-axis-offset": t6,
            "--line-main-axis-start": t7,
            "--terminal-display": t8,
            "--terminal-diameter": "calc(var(--stroke-width) * 4)",
            "--terminal-radius": "calc(var(--terminal-diameter) / 2)",
            "--terminal-main-axis-start": "calc(-1 * var(--terminal-diameter))",
            "--terminal-cross-axis-offset": "calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)"
        };
        $[3] = strokeColor;
        $[4] = strokeWidth;
        $[5] = t6;
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
    } else t9 = $[8];
    const t10 = t9;
    const t11 = $06f7f86bfd55e0d2$var$orientationStyles[orientation];
    const t12 = $06f7f86bfd55e0d2$var$edgeStyles[edge];
    let t13;
    if ($[9] !== t11 || $[10] !== t12) {
        t13 = (0, $hekY6.default)([
            $06f7f86bfd55e0d2$var$baseStyles.root,
            t11,
            t12
        ]);
        $[9] = t11;
        $[10] = t12;
        $[11] = t13;
    } else t13 = $[11];
    let t14;
    if ($[12] !== t10 || $[13] !== t13) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t10,
            className: t13
        });
        $[12] = t10;
        $[13] = t13;
        $[14] = t14;
    } else t14 = $[14];
    return t14;
} : function Line({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $hHzd2.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $hHzd2.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $06f7f86bfd55e0d2$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $06f7f86bfd55e0d2$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $hekY6.default)([
            $06f7f86bfd55e0d2$var$baseStyles.root,
            $06f7f86bfd55e0d2$var$orientationStyles[orientation],
            $06f7f86bfd55e0d2$var$edgeStyles[edge]
        ])
    });
}; // For React.lazy
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$06f7f86bfd55e0d2$export$2e2bcd8739ae039 = $06f7f86bfd55e0d2$export$17d680238e50603e;
module.exports["Line"] = $06f7f86bfd55e0d2$export$17d680238e50603e;

});

parcelRegister("hHzd2", function(module, exports) {
const $4ee2c7f82a7b207c$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $4ee2c7f82a7b207c$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";
module.exports["presetStrokeColors"] = $4ee2c7f82a7b207c$export$477fafec326bfca0;
module.exports["presetStrokeWidth"] = $4ee2c7f82a7b207c$export$45db03aa04b685e3;

});

parcelRegister("lUcpS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $k78uC = parcelRequire("k78uC");


var $8IfK6 = parcelRequire("8IfK6");

const $91b0a64470223be6$export$5bf35293e545f20c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (...t1)=>{
            const params = t1;
            const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
            event.fire((0, $k78uC.EVENT_CHANNEL));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireEvent = t0;
    let t1;
    if ($[2] !== fireEvent) {
        t1 = {
            fireEvent: fireEvent
        };
        $[2] = fireEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEvent = (0, $cozmU.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
        event.fire((0, $k78uC.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $91b0a64470223be6$export$5bf35293e545f20c;

});

parcelRegister("k78uC", function(module, exports) {
const $0de3cce3bcdfa361$export$3f072f06b90c3985 = 'peopleTeams';
module.exports["EVENT_CHANNEL"] = $0de3cce3bcdfa361$export$3f072f06b90c3985;

});

parcelRegister("8IfK6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::378c0a04d2cca8641793d5a92fac3d1a>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen teams-app-internal-analytics
 */ const $fcb00cbaaafbad36$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $fcb00cbaaafbad36$export$2e2bcd8739ae039 = $fcb00cbaaafbad36$var$createEventPayload;
module.exports["default"] = $fcb00cbaaafbad36$export$2e2bcd8739ae039;

});

parcelRegister("2UMCh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hp074 = parcelRequire("hp074");

const $21f685ebe54e3804$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    getArtifact: null
});
function $21f685ebe54e3804$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return new (0, $hp074.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            },
            expiryMS: config === null || config === void 0 ? void 0 : config.artifactExpiryMS
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21f685ebe54e3804$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $21f685ebe54e3804$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($21f685ebe54e3804$export$ca1b33377afa620);
function $21f685ebe54e3804$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState();
    const { getArtifact: getArtifact } = $21f685ebe54e3804$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}
module.exports["FlightDeckProvider"] = $21f685ebe54e3804$export$56da85ac9d40dbcd;
module.exports["useFlightDeckContext"] = $21f685ebe54e3804$export$73c96350a5e69ec;
module.exports["useFlightDeckArtifact"] = $21f685ebe54e3804$export$3b241cde208d2c5e;

});

parcelRegister("c9Rq0", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $c3b64ab3db691a18$var$styles = {
    'above.xs': "_2rTNeWYbGa",
    'above.sm': "_2UeR8bYbGa",
    'above.md': "_0THHewYbGa",
    'above.lg': "_1hlSbsYbGa",
    'above.xl': "_4pVFIkYbGa",
    'below.xs': "_3PnjIVYbGa",
    'below.sm': "_1U2uuEYbGa",
    'below.md': "_3RxhahYbGa",
    'below.lg': "_1q55U0YbGa",
    'below.xl': "_2HqVMBYbGa"
};
const $c3b64ab3db691a18$export$bed28288a051538 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { above: above, below: below, children: children, as: t1, xcss: xcss } = t0;
    const AsElement = t1 === undefined ? "div" : t1;
    const t2 = above && $c3b64ab3db691a18$var$styles[`above.${above}`];
    const t3 = below && $c3b64ab3db691a18$var$styles[`below.${below}`];
    let t4;
    if ($[0] !== t2 || $[1] !== t3 || $[2] !== xcss) {
        t4 = (0, $hekY6.default)([
            t2,
            t3,
            xcss
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = xcss;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== AsElement || $[5] !== children || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)(AsElement, {
            className: t4,
            children: children
        });
        $[4] = AsElement;
        $[5] = children;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)(AsElement, {
        className: (0, $hekY6.default)([
            above && $c3b64ab3db691a18$var$styles[`above.${above}`],
            below && $c3b64ab3db691a18$var$styles[`below.${below}`],
            xcss
        ]),
        children: children
    });
};
module.exports["Hide"] = $c3b64ab3db691a18$export$bed28288a051538;

});

parcelRegister("3qdJ0", function(module, exports) {
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $8c8615b3f214c36e$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom',
    ROVO: 'rovo.ondemand',
    TEAMWORK_COLLECTION: 'teamwork-collection'
};
module.exports["Targets"] = $8c8615b3f214c36e$export$59a8eb9cff113544;

});

parcelRegister("kgHuu", function(module, exports) {
$parcel$export(module.exports, "Targets", () => (parcelRequire("3qdJ0")).Targets);

var $6ROIE = parcelRequire("6ROIE");


var $3qdJ0 = parcelRequire("3qdJ0");


});

parcelRegister("6ROIE", function(module, exports) {
class $f31eace768ed80b8$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}
module.exports["CrossFlowExtensions"] = $f31eace768ed80b8$export$a5e53d1dcbd6eb61;

});

parcelRegister("9AuSX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $guH5C = parcelRequire("guH5C");


var $hHzd2 = parcelRequire("hHzd2");

const $471650b8def160c1$export$62ed72bc21f6b8a6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DropIndicator(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { appearance: t1, indent: indent } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const t2 = (0, $hHzd2.presetStrokeColors)[appearance];
    let t3;
    if ($[0] !== indent || $[1] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $guH5C.Border), {
            strokeColor: t2,
            indent: indent
        });
        $[0] = indent;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    return t3;
} : function DropIndicator({ appearance: appearance = 'default', indent: indent }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $guH5C.Border), {
        strokeColor: (0, $hHzd2.presetStrokeColors)[appearance],
        indent: indent
    });
};
var // For React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$471650b8def160c1$export$2e2bcd8739ae039 = $471650b8def160c1$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $471650b8def160c1$export$62ed72bc21f6b8a6;

});

parcelRegister("guH5C", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $hHzd2 = parcelRequire("hHzd2");

const $ff42c94e2588d608$var$styles = null;
const $ff42c94e2588d608$export$d8e9c9d63e86d41e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Border(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { strokeColor: t1, strokeWidth: t2, borderRadius: t3, indent: t4 } = t0;
    const strokeColor = t1 === undefined ? (0, $hHzd2.presetStrokeColors).default : t1;
    const strokeWidth = t2 === undefined ? (0, $hHzd2.presetStrokeWidth) : t2;
    const borderRadius = t3 === undefined ? "3px" : t3;
    const indent = t4 === undefined ? "0px" : t4;
    let t5;
    if ($[0] !== borderRadius || $[1] !== indent || $[2] !== strokeColor || $[3] !== strokeWidth) {
        t5 = {
            "--stroke-color": strokeColor,
            "--stroke-width": strokeWidth,
            "--border-radius": borderRadius,
            "--indent": indent
        };
        $[0] = borderRadius;
        $[1] = indent;
        $[2] = strokeColor;
        $[3] = strokeWidth;
        $[4] = t5;
    } else t5 = $[4];
    const t6 = t5;
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            "_30huDKTp3k _0bjKvDY715 _1mT5xdWVPG _2I62gzdnbC _1ZB6UydnbC _1OKFqYdnbC _3iC0zd3NlV _1pp6NdYbGa"
        ]);
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== t6) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t6,
            className: t7
        });
        $[6] = t6;
        $[7] = t8;
    } else t8 = $[7];
    return t8;
} : function Border({ strokeColor: strokeColor = (0, $hHzd2.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $hHzd2.presetStrokeWidth), borderRadius: borderRadius = '3px', indent: // TODO: update to radius.small (4px) token
indent = '0px' }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            '--border-radius': borderRadius,
            '--indent': indent
        },
        className: (0, $hekY6.default)([
            "_30huDKTp3k _0bjKvDY715 _1mT5xdWVPG _2I62gzdnbC _1ZB6UydnbC _1OKFqYdnbC _3iC0zd3NlV _1pp6NdYbGa"
        ])
    });
}; // For React.lazy
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ff42c94e2588d608$export$2e2bcd8739ae039 = $ff42c94e2588d608$export$d8e9c9d63e86d41e;
module.exports["Border"] = $ff42c94e2588d608$export$d8e9c9d63e86d41e;

});

parcelRegister("8SiaH", function(module, exports) {

var $4qoOj = parcelRequire("4qoOj");

function $9b6a08e7b6b87fbc$export$3f55479a3469259f(isEqual = (0, $4qoOj.isShallowEqual)) {
    let cache = null;
    return (value)=>{
        if (cache && isEqual(cache.value, value)) return cache.value;
        cache = {
            value: value
        };
        return cache.value;
    };
}
module.exports["stable"] = $9b6a08e7b6b87fbc$export$3f55479a3469259f;

});

parcelRegister("4qoOj", function(module, exports) {
function $cfd4043bf39448ea$export$2225b4c39d37f8b3(a, b) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key)=>Object.is(a[key], b[key]));
}
module.exports["isShallowEqual"] = $cfd4043bf39448ea$export$2225b4c39d37f8b3;

});

parcelRegister("agOrO", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $RfroO = parcelRequire("RfroO");


var $cJ0FD = parcelRequire("cJ0FD");


var $6Pqow = parcelRequire("6Pqow");


var $lMahj = parcelRequire("lMahj");


var $66kDq = parcelRequire("66kDq");

const $6c2c248576a939b5$var$styles = {
    textWrapper: "_2YLqiKIZbP _1EqgXldoBh _3iDTPbvbI6"
};
function $6c2c248576a939b5$export$df7d386b8cf1e3c({ testId: testId = 'global-side-navigation--no-content', renderImage: renderImage = ()=>/*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
        testId: "global-side-navigation--no-content-default-image",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($66kDq))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($lMahj))),
        width: 96,
        alt: ""
    }), heading: heading, description: description, elemAfter: elemAfter }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $RfroO.default), {
        testId: testId,
        renderImage: renderImage,
        header: heading,
        headingLevel: 3,
        headingSize: "xsmall",
        description: /*#__PURE__*/ $cozmU.createElement("span", null, /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                $6c2c248576a939b5$var$styles.textWrapper
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.default), {
            size: "small",
            color: "color.text.subtle"
        }, description)), /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                $6c2c248576a939b5$var$styles.textWrapper
            ])
        }, elemAfter))
    });
}
module.exports["GlobalSideNavigationNoContent"] = $6c2c248576a939b5$export$df7d386b8cf1e3c;

});

parcelRegister("lMahj", function(module, exports) {
module.exports = new URL("no-results-dark.90199792.svg", import.meta.url).toString();

});

parcelRegister("66kDq", function(module, exports) {
module.exports = new URL("no-results-light.5ffcf568.svg", import.meta.url).toString();

});

parcelRegister("aA2ps", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cJ0FD = parcelRequire("cJ0FD");


var $agOrO = parcelRequire("agOrO");


var $bLKcL = parcelRequire("bLKcL");


var $euCzB = parcelRequire("euCzB");

const $06237c3f2efd0df2$export$e3acd504d9f9ab4c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ObjectListFlyoutEmptyState() {
    const $ = (0, $bDgLe.c)(7);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $euCzB.default).emptyStateHeader);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== formatMessage) {
        t1 = formatMessage((0, $euCzB.default).emptyStateDescription);
        $[2] = formatMessage;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $agOrO.GlobalSideNavigationNoContent), {
            testId: "object-list-flyout--empty-state",
            renderImage: $06237c3f2efd0df2$var$_temp,
            heading: t0,
            description: t1
        });
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : function ObjectListFlyoutEmptyState() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $agOrO.GlobalSideNavigationNoContent), {
        testId: "object-list-flyout--empty-state",
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($bLKcL))),
                width: 96,
                alt: ""
            }),
        heading: formatMessage((0, $euCzB.default).emptyStateHeader),
        description: formatMessage((0, $euCzB.default).emptyStateDescription)
    });
};
function $06237c3f2efd0df2$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bLKcL))),
        width: 96,
        alt: ""
    });
}
module.exports["ObjectListFlyoutEmptyState"] = $06237c3f2efd0df2$export$e3acd504d9f9ab4c;

});

parcelRegister("bLKcL", function(module, exports) {
module.exports = new URL("empty.72f8b026.svg", import.meta.url).toString();

});

parcelRegister("euCzB", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $051de7f82ea216ea$var$messages = (0, $kSwu1.defineMessages)({
    emptyStateHeader: {
        id: "navigation-global-side-navigation.object-list-flyout.empty-state.header",
        defaultMessage: "Nothing to see here!"
    },
    emptyStateDescription: {
        id: "navigation-global-side-navigation.object-list-flyout.empty-state.description",
        defaultMessage: "Once you visit, edit, or create projects, issues, boards, filters, and dashboards, they\u2019ll show up here."
    },
    starredEmptyStateHeader: {
        id: "navigation-global-side-navigation.object-list-flyout.starred-empty-state.header",
        defaultMessage: "You haven't starred anything yet."
    },
    starredEmptyStateDescription: {
        id: "navigation-global-side-navigation.object-list-flyout.starred-empty-state.description",
        defaultMessage: "Mark items that are important to you with a star to quickly access them. You\u2019ll see those items here."
    }
});
var $051de7f82ea216ea$export$2e2bcd8739ae039 = $051de7f82ea216ea$var$messages;
module.exports["default"] = $051de7f82ea216ea$export$2e2bcd8739ae039;

});

parcelRegister("iecTK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cJ0FD = parcelRequire("cJ0FD");


var $agOrO = parcelRequire("agOrO");


var $gNFxA = parcelRequire("gNFxA");


var $euCzB = parcelRequire("euCzB");

const $af1c80e1365d6fab$export$daa1321d10fd301d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ObjectListStarredEmptyState(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { errorDescription: errorDescription } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $euCzB.default).starredEmptyStateHeader);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== errorDescription || $[3] !== formatMessage) {
        t2 = errorDescription ?? formatMessage((0, $euCzB.default).starredEmptyStateDescription);
        $[2] = errorDescription;
        $[3] = formatMessage;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $agOrO.GlobalSideNavigationNoContent), {
            testId: "object-list-flyout--starred-empty-state",
            renderImage: $af1c80e1365d6fab$var$_temp,
            heading: t1,
            description: t2
        });
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : function ObjectListStarredEmptyState({ errorDescription: errorDescription }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $agOrO.GlobalSideNavigationNoContent), {
        testId: "object-list-flyout--starred-empty-state",
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($gNFxA))),
                width: 96,
                alt: ""
            }),
        heading: formatMessage((0, $euCzB.default).starredEmptyStateHeader),
        description: errorDescription ?? formatMessage((0, $euCzB.default).starredEmptyStateDescription)
    });
};
function $af1c80e1365d6fab$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gNFxA))),
        width: 96,
        alt: ""
    });
}
module.exports["ObjectListStarredEmptyState"] = $af1c80e1365d6fab$export$daa1321d10fd301d;

});

parcelRegister("gNFxA", function(module, exports) {
module.exports = new URL("starred-empty.227ae17e.svg", import.meta.url).toString();

});

parcelRegister("f95Dj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0f2c84f88927a58d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //
var $0f2c84f88927a58d$export$2e2bcd8739ae039 = {
    "navigation.error.description.default": "Refresh the page and try again",
    "navigation.error.header.default": "We couldn\u2019t load this content",
    "navigation.global-shortcuts.apps.align": "Align",
    "navigation.global-shortcuts.apps.analytics": "Analytics",
    "navigation.global-shortcuts.apps.assets": "Assets",
    "navigation.global-shortcuts.apps.bitbucket": "Bitbucket",
    "navigation.global-shortcuts.apps.company-hub": "Company Hub",
    "navigation.global-shortcuts.apps.compass": "Compass",
    "navigation.global-shortcuts.apps.confluence": "Confluence",
    "navigation.global-shortcuts.apps.customer-service-management": "Customer Service Management",
    "navigation.global-shortcuts.apps.feedback": "Feedback",
    "navigation.global-shortcuts.apps.focus": "Focus",
    "navigation.global-shortcuts.apps.goals": "Goals",
    "navigation.global-shortcuts.apps.home": "Home",
    "navigation.global-shortcuts.apps.jira": "Jira",
    "navigation.global-shortcuts.apps.jira-product-discovery": "Jira Product Discovery",
    "navigation.global-shortcuts.apps.jira-service-management": "Jira Service Management",
    "navigation.global-shortcuts.apps.loom": "Loom",
    "navigation.global-shortcuts.apps.opsgenie": "Opsgenie",
    "navigation.global-shortcuts.apps.projects": "Projects",
    "navigation.global-shortcuts.apps.projects-galaxia": "Spaces",
    "navigation.global-shortcuts.apps.studio": "Studio",
    "navigation.global-shortcuts.apps.talent": "Talent",
    "navigation.global-shortcuts.apps.teams": "Teams",
    "navigation.global-shortcuts.apps.trello": "Trello",
    "navigation.global-shortcuts.error.description": "Refresh the page and try again",
    "navigation.global-shortcuts.error.header": "We couldn\u2019t load the shortcut for {menuId}",
    "navigation.global-shortcuts.shortcut-action.open-menu-label": "open menu",
    "navigation.global-shortcuts.shortcut-link-item.aria-label": "{appName}{siteName}",
    "navigation.global-shortcuts.view-all-apps.label": "View all apps"
};

});

parcelRegister("hSHWm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $cozmU.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("koZ31", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $6a2b9fa9e63188b2$export$1ba03842b7d3a654 = /*#__PURE__*/ function(CoreInvitesSource) {
    CoreInvitesSource["UNKNOWN"] = "unknown";
    CoreInvitesSource["MENTION"] = "mention";
    CoreInvitesSource["PEOPLE_MENU"] = "peopleMenu";
    CoreInvitesSource["ONBOARDING_INVITE_FLAG"] = "onboarding-invite-flag";
    CoreInvitesSource["PERSISTENT_INVITE_PAGETREE"] = "pageTree";
    CoreInvitesSource["PERSISTENT_INVITE_HOMESCREEN"] = "homeScreen";
    CoreInvitesSource["CONTEXTUAL_INVITE_NUDGE"] = "onboarding-contextual-invite-nudge";
    CoreInvitesSource["LIVE_PAGES_NUDGE"] = "onboarding-contextual-invite-live-pages-nudge";
    CoreInvitesSource["SHARE_DIALOG"] = "share-dialog";
    CoreInvitesSource["SHARE_AND_RESTRICT_DIALOG"] = "share-and-restrict-dialog";
    CoreInvitesSource["IBO_TAKEOVER_INVITE"] = "onboarding-takeover-invite-people";
    CoreInvitesSource["EA_DROPDOWN"] = "ea-dropdown";
    CoreInvitesSource["HOME_ONBOARDING_TAKEOVER_V2"] = "home-onboarding-takeover-v2";
    CoreInvitesSource["CROSS_JOIN"] = "virality-cross-join";
    CoreInvitesSource["OPEN_MODAL_QUERY_PARAM"] = "open-modal-query-param";
    return CoreInvitesSource;
}({});
module.exports["CoreInvitesSource"] = $6a2b9fa9e63188b2$export$1ba03842b7d3a654;

});

parcelRegister("hjygH", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $1aeb691895c5954d$export$85823f26dca064c3(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>{
            if (error) experienceTracker.stopOnError({
                name: name,
                error: error,
                attributes: attributes
            });
            else experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        };
        t2 = [
            experienceTracker,
            name,
            attributes,
            error
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceStop"] = $1aeb691895c5954d$export$85823f26dca064c3;

});

parcelRegister("1YXTQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $clUfR = parcelRequire("clUfR");


var $7GLtr = parcelRequire("7GLtr");


var $awd1Q = parcelRequire("awd1Q");


var $bQm3c = parcelRequire("bQm3c");

'use no memo';
const $6f4eb0725770e50a$var$i18n = (0, $kSwu1.defineMessages)({
    now: {
        id: "time-ago.time.now",
        defaultMessage: "now"
    },
    lessThanAMinute: {
        id: "time-ago.time.lessThanAMinute",
        defaultMessage: "less than a minute ago"
    },
    onPreposition: {
        id: "time-ago.prepositions.on",
        defaultMessage: "on {datetime}"
    }
});
const $6f4eb0725770e50a$var$gradation = [
    // Less than 5 seconds -> "now"
    {
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.now)
    },
    // Between 5-45 seconds -> "less than a minute ago"
    {
        threshold: 5,
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.lessThanAMinute)
    },
    // Between 45 seconds-2.5 minutes -> "X minutes ago"
    {
        threshold: 45,
        factor: 60,
        unit: 'minute'
    },
    // Between 2.5-45 minutes -> "X minutes ago" (rounded to 5)
    {
        threshold: 150,
        factor: 60,
        granularity: 5,
        unit: 'minute'
    },
    // Between 45 minutes-24 hours -> "X hours ago"
    {
        threshold: 2700,
        factor: 3600,
        unit: 'hour'
    },
    // After 24 hours -> "full date"
    {
        threshold: 86400,
        format: ({ intl: intl, date: date, locale: locale, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions, timeZone: timeZone, tenantTimeZone: tenantTimeZone })=>{
            const datetime = date.toLocaleDateString(locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                timeZone: (()=>{
                    // Prefer timeZone if provided, otherwise use tenantTimeZone, otherwise use browser timezone
                    const tz = timeZone || tenantTimeZone || (0, $clUfR.guessTimeZone)();
                    // Validate the timezone, use UTC as fallback for invalid values
                    return (0, $7GLtr.isValidTimeZone)(tz) ? tz : 'Etc/UTC';
                })(),
                ...dateFormatOptions
            });
            if (usePrepositions) return intl.formatMessage($6f4eb0725770e50a$var$i18n.onPreposition, {
                datetime: datetime
            });
            return datetime;
        }
    }
];
const $6f4eb0725770e50a$var$getGradationIndex = (seconds)=>{
    let i = $6f4eb0725770e50a$var$gradation.length - 1;
    while(i > 0 && seconds < ($6f4eb0725770e50a$var$gradation[i].threshold || seconds))i--;
    return i;
};
const $6f4eb0725770e50a$var$getSecondsSince = (date)=>(Date.now() - date.getTime()) / 1000;
const $6f4eb0725770e50a$export$78ae3e68d8c394bc = (intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone)=>{
    const locale = (0, $awd1Q.getTranslation)().locale;
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    const customFormat = $6f4eb0725770e50a$var$gradation[i].format;
    if (customFormat) return customFormat({
        intl: intl,
        date: dateObject,
        locale: locale,
        usePrepositions: usePrepositions,
        dateFormatOptions: dateFormatOptions,
        timeZone: timeZone,
        tenantTimeZone: tenantTimeZone
    });
    // oxlint-disable-next-line compat/compat
    const localeLanguage = new Intl.Locale(locale).language;
    // oxlint-disable-next-line compat/compat
    const formatter = new Intl.RelativeTimeFormat(localeLanguage, {
        style: 'long',
        numeric: 'auto'
    });
    const granularity = $6f4eb0725770e50a$var$gradation[i].granularity || 1;
    const factor = $6f4eb0725770e50a$var$gradation[i].factor || 1;
    const value = -Math.round(seconds / factor / granularity) * granularity;
    const unit = $6f4eb0725770e50a$var$gradation[i].unit || 'second';
    return formatter.format(value, unit);
};
const $6f4eb0725770e50a$export$fc791eb9f9c39e49 = ({ date: date, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { timeZone: timeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        suppressHydrationWarning: true
    }, $6f4eb0725770e50a$export$78ae3e68d8c394bc(intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone));
};
const $6f4eb0725770e50a$export$9e4a631e7281406a = ({ date: date, ...otherProps })=>{
    const [, setRenders] = (0, $cozmU.useState)(0);
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    (0, $cozmU.useEffect)(()=>{
        if (i != $6f4eb0725770e50a$var$gradation.length - 1) {
            const timeToNextGradation = ($6f4eb0725770e50a$var$gradation[i + 1].threshold || seconds) - seconds;
            const timeout = setTimeout(()=>{
                setRenders((x)=>x + 1);
            }, timeToNextGradation * 1000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        i,
        seconds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f4eb0725770e50a$export$fc791eb9f9c39e49, {
        date: date,
        ...otherProps
    });
};
module.exports["formatTimeAgo"] = $6f4eb0725770e50a$export$78ae3e68d8c394bc;
module.exports["StaticTimeAgo"] = $6f4eb0725770e50a$export$fc791eb9f9c39e49;
module.exports["TimeAgo"] = $6f4eb0725770e50a$export$9e4a631e7281406a;

});

parcelRegister("clUfR", function(module, exports) {
const $dad8374cf8f904e8$export$c333b33f2586074c = ()=>{
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch  {
        return 'Etc/UTC';
    }
};
module.exports["guessTimeZone"] = $dad8374cf8f904e8$export$c333b33f2586074c;

});

parcelRegister("7GLtr", function(module, exports) {
const $0e3ee782c26ab488$export$c793e14020d7c7b = (timeZone)=>{
    try {
        Intl.DateTimeFormat(undefined, {
            timeZone: timeZone
        });
        return true;
    } catch  {
        return false;
    }
};
module.exports["isValidTimeZone"] = $0e3ee782c26ab488$export$c793e14020d7c7b;

});

parcelRegister("di8q4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("7CNwI"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $57p4j = parcelRequire("57p4j");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _39Ohv4YbGa _1SdfoHYbGa"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $hekY6.default)([
                    "_2uo31fGsB2 _0bjKvDzXzM _2XghbEPgdg _3iDTPbvbI6 _0Of8r2Pgdg"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("7CNwI", function(module, exports) {

let $58d27ff903855c90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $58d27ff903855c90$var$load("gFeoL"),
    $58d27ff903855c90$var$load("6wr18"),
    $58d27ff903855c90$var$load("kwZ86"),
    $58d27ff903855c90$var$load("ffEVr"),
    $58d27ff903855c90$var$load("4Ldt2"),
    $58d27ff903855c90$var$load("3LYaV"),
    $58d27ff903855c90$var$load("20wSi"),
    $58d27ff903855c90$var$load("9LDVS"),
    $58d27ff903855c90$var$load("kiMHu"),
    $58d27ff903855c90$var$load("8OeKT"),
    $58d27ff903855c90$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("3gdp3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e8b2cdb4a7b2569268a3fe6ec068354>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25fd434ab2c22b25$var$_react = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("cozmU")));

var $25fd434ab2c22b25$var$_iconNew = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $25fd434ab2c22b25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/notepad
 * Usage guidance:
 * Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25fd434ab2c22b25$var$NotepadIcon = (props)=>/*#__PURE__*/ $25fd434ab2c22b25$var$_react.default.createElement($25fd434ab2c22b25$var$_iconNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$25fd434ab2c22b25$var$NotepadIcon.displayName = 'NotepadIcon';
var $25fd434ab2c22b25$var$_default = module.exports.default = $25fd434ab2c22b25$var$NotepadIcon;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kLlYX = parcelRequire("kLlYX");


var $3gdp3 = parcelRequire("3gdp3");


var $hMaHH = parcelRequire("hMaHH");


var $d4GYd = parcelRequire("d4GYd");


var $bDjVc = parcelRequire("bDjVc");


var $lBKFk = parcelRequire("lBKFk");


var $kWSTb = parcelRequire("kWSTb");


var $2hJf7 = parcelRequire("2hJf7");


var $9zxkL = parcelRequire("9zxkL");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");


var $5tsXU = parcelRequire("5tsXU");


var $hT3jf = parcelRequire("hT3jf");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t2 = emoji || "";
        let t3;
        if ($[0] !== height || $[1] !== t2 || $[2] !== type) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t2,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t2;
            $[2] = type;
            $[3] = t3;
        } else t3 = $[3];
        return t3;
    }
    if ((0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    })) {
        let t2;
        if ($[4] !== color) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tsXU.ManagedFolderClosedIcon), {
                label: "",
                size: "small",
                color: color,
                testId: "icons.content-icon.label.managed-folder"
            });
            $[4] = color;
            $[5] = t2;
        } else t2 = $[5];
        return t2;
    }
    const actualType = isLivePage ? "liveDoc" : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t2;
    if ($[6] !== Icon || $[7] !== color || $[8] !== label.id) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[6] = Icon;
        $[7] = color;
        $[8] = label.id;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16 })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    if ((0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tsXU.ManagedFolderClosedIcon), {
        label: "",
        size: "small",
        color: color,
        testId: "icons.content-icon.label.managed-folder"
    });
    const actualType = isLivePage ? 'liveDoc' : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $kSwu1.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9zxkL))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3gdp3))),
        label: $b2e0c504f331f5cc$var$i18n.note
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("5tsXU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * Custom icon for a managed (synced) closed folder.
 * Renders a folder with a circle badge in the bottom-right corner.
 * Uses currentColor so the icon responds to theming and dark mode.
 */ const $3216f3fcd316d4ef$export$75f34eec99819e9c = ({ label: label, size: size = 'medium', color: color, testId: testId })=>{
    const dimensions = size === 'small' ? 16 : 24;
    const fillColor = color || 'currentColor';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        "data-testid": testId,
        width: dimensions,
        height: dimensions,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": !label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.31055 2.75H13C14.1046 2.75 15 3.64543 15 4.75V10H13.5V7.5H2.5V13C2.5 13.2761 2.72386 13.5 3 13.5H10V15H3C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1H6.56055L8.31055 2.75ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V6H13.5V4.75C13.5 4.47386 13.2761 4.25 13 4.25H7.68945L5.93945 2.5H3Z",
        fill: fillColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.75 13.75C15.75 14.8546 14.8546 15.75 13.75 15.75C12.6454 15.75 11.75 14.8546 11.75 13.75C11.75 12.6454 12.6454 11.75 13.75 11.75C14.8546 11.75 15.75 12.6454 15.75 13.75Z",
        fill: fillColor
    }));
};
module.exports["ManagedFolderClosedIcon"] = $3216f3fcd316d4ef$export$75f34eec99819e9c;

});

parcelRegister("hT3jf", function(module, exports) {
/**
 * Returns true if the given content item is a smart (MANAGED) folder.
 *
 * A smart folder is a folder whose `subType` is `"managed"` (the AGG schema
 * returns this value lowercased). Regular folders do not have a subType
 * (it is null or absent).
 *
 * The comparison is case-insensitive to defensively handle any future schema
 * casing changes from the backend.
 *
 * @param content - Any object that may have a `type` and/or `subType` field.
 */ const $13b7c969ce4fb521$export$9aceb9df64593567 = (content)=>{
    return content.type === 'folder' && content.subType?.toLowerCase() === 'managed';
};
module.exports["isSmartFolder"] = $13b7c969ce4fb521$export$9aceb9df64593567;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("aTE5s", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lUcpS = parcelRequire("lUcpS");


var $dwu5p = parcelRequire("dwu5p");

const $aa04f59c0543157c$export$b24dcbe1ec677a8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (scope, t0)=>{
    const $ = (0, $bDgLe.c)(16);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {
            enabled: false,
            attributes: {}
        } : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { enabled: enabled, attributes: attributes } = t1;
    let t2;
    if ($[2] !== scope) {
        t2 = typeof scope === "string" || !scope ? {
            orgId: scope,
            cloudId: undefined
        } : scope;
        $[2] = scope;
        $[3] = t2;
    } else t2 = $[3];
    const { orgId: orgId, cloudId: cloudId } = t2;
    const [state, t3] = (0, $dwu5p.useTeamsPermissionsStore)();
    const { getPermissions: getPermissions } = t3;
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    let t4;
    if ($[4] !== attributes?.userId || $[5] !== cloudId || $[6] !== enabled || $[7] !== fireEvent || $[8] !== getPermissions || $[9] !== orgId) {
        t4 = async ()=>{
            getPermissions({
                orgId: orgId,
                cloudId: cloudId,
                enabled: enabled
            }, {
                onFetch: ()=>{
                    fireEvent("operational.use-team-permissions.fetched", {
                        userId: attributes?.userId,
                        orgId: orgId,
                        cloudId: cloudId
                    });
                }
            });
        };
        $[4] = attributes?.userId;
        $[5] = cloudId;
        $[6] = enabled;
        $[7] = fireEvent;
        $[8] = getPermissions;
        $[9] = orgId;
        $[10] = t4;
    } else t4 = $[10];
    attributes?.userId;
    const fetchData = t4;
    let t5;
    let t6;
    if ($[11] !== fetchData) {
        t5 = ()=>{
            fetchData();
        };
        t6 = [
            fetchData
        ];
        $[11] = fetchData;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[14] !== state) {
        t7 = {
            loading: state.isLoading,
            data: state.permissionsResponse,
            error: state.error,
            ...state
        };
        $[14] = state;
        $[15] = t7;
    } else t7 = $[15];
    return t7;
} : (scope, { enabled: enabled, attributes: attributes } = {
    enabled: false,
    attributes: {}
})=>{
    // backwards compatibility allow orgId to be passed as a string
    const { orgId: orgId, cloudId: cloudId } = typeof scope === 'string' || !scope ? {
        orgId: scope,
        cloudId: undefined
    } : scope;
    const [state, { getPermissions: getPermissions }] = (0, $dwu5p.useTeamsPermissionsStore)();
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        getPermissions({
            orgId: orgId,
            cloudId: cloudId,
            enabled: enabled
        }, {
            onFetch: ()=>{
                // @ts-expect-error - hyphenated event names are not supported in the analytics spec
                fireEvent('operational.use-team-permissions.fetched', {
                    userId: attributes?.userId,
                    orgId: orgId,
                    cloudId: cloudId
                });
            }
        });
    }, [
        orgId,
        cloudId,
        enabled,
        getPermissions,
        attributes?.userId,
        fireEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissionsResponse,
        error: state.error,
        ...state
    };
};
module.exports["useTeamsPermissionsService"] = $aa04f59c0543157c$export$b24dcbe1ec677a8;

});

parcelRegister("dwu5p", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $dZPDC = parcelRequire("dZPDC");


var $1epkm = parcelRequire("1epkm");


var $eABmG = parcelRequire("eABmG");

const $f234886299b3de7a$var$actions = {
    getPermissions: ({ orgId: orgId, cloudId: cloudId, enabled: enabled }, { onFetch: onFetch })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading } = getState();
            if (hasLoaded || isLoading || !enabled || !orgId || !cloudId) return;
            try {
                setState({
                    isLoading: true
                });
                (0, $dZPDC.teamsClient).setContext({
                    orgId: orgId,
                    cloudId: cloudId
                });
                const response = await (0, $dZPDC.teamsClient).getPermissions();
                dispatch($f234886299b3de7a$var$actions.setPermissions(response.permissions));
                onFetch?.();
            } catch (error) {
                dispatch($f234886299b3de7a$var$actions.setError(error instanceof (0, $1epkm.HttpError) ? error : new Error('Failed to fetch permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: (0, $eABmG.transformPermissions)(permissions),
                permissionsResponse: {
                    permissions: permissions
                }
            });
        }
};
const $f234886299b3de7a$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {
            canCreateTeams: true,
            canViewTeams: true,
            canAdminTeams: false
        }
    },
    actions: $f234886299b3de7a$var$actions,
    name: 'teams-permissions'
});
const $f234886299b3de7a$export$4e7a1c55cba5a168 = (0, $kBr4q.createHook)($f234886299b3de7a$var$Store);
module.exports["useTeamsPermissionsStore"] = $f234886299b3de7a$export$4e7a1c55cba5a168;

});

parcelRegister("eABmG", function(module, exports) {
const $fe384c1f2df30e3c$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        switch(permission){
            case 'CAN_CREATE_TEAMS':
                return {
                    ...acc,
                    canCreateTeams: true
                };
            case 'CAN_VIEW_TEAMS':
                return {
                    ...acc,
                    canViewTeams: true
                };
            case 'CAN_ADMIN_TEAMS':
                return {
                    ...acc,
                    canAdminTeams: true
                };
            default:
                return acc;
        }
    }, {
        canCreateTeams: false,
        canViewTeams: false,
        canAdminTeams: false
    });
};
module.exports["transformPermissions"] = $fe384c1f2df30e3c$export$7fe0bfa353103198;

});

parcelRegister("gE9bl", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2UMCh = parcelRequire("2UMCh");


var $a4991 = parcelRequire("a4991");


var $g1sk9 = parcelRequire("g1sk9");


var $hvqau = parcelRequire("hvqau");

const $01b62d0be74b9747$export$8a37839ac1e08b25 = /*#__PURE__*/ (0, $cozmU.createContext)((0, $g1sk9.DEFAULT_CONTEXT));
const $01b62d0be74b9747$export$3bf19eb896b777b8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, locale: locale, product: product, teamPermissions: teamPermissions, orgId: orgId, teamPermissionCheckEnabled: t1 } = t0;
    const teamPermissionCheckEnabled = t1 === undefined ? false : t1;
    const overrides = (0, $hvqau.usePeopleAndTeamsConfigurationOverrides)(teamPermissionCheckEnabled, orgId, teamPermissions);
    const artifact = (0, $a4991.usePeopleAndTeamsRemoteArtifact)(product, locale, overrides);
    const t2 = artifact || (0, $g1sk9.DEFAULT_CONTEXT);
    let t3;
    if ($[0] !== children || $[1] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)($01b62d0be74b9747$export$8a37839ac1e08b25.Provider, {
            value: t2,
            children: children
        });
        $[0] = children;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    return t3;
} : ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, orgId: orgId, teamPermissionCheckEnabled: teamPermissionCheckEnabled = false })=>{
    const overrides = (0, $hvqau.usePeopleAndTeamsConfigurationOverrides)(teamPermissionCheckEnabled, orgId, teamPermissions);
    const artifact = (0, $a4991.usePeopleAndTeamsRemoteArtifact)(product, locale, overrides);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($01b62d0be74b9747$export$8a37839ac1e08b25.Provider, {
        value: artifact || (0, $g1sk9.DEFAULT_CONTEXT),
        children: children
    });
};
const $01b62d0be74b9747$export$d3f5bd36d1c6597e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    let children;
    let flightDeckProps;
    let locale;
    let orgId;
    let product;
    let teamPermissionCheckEnabled;
    let teamPermissions;
    if ($[0] !== t0) {
        ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, teamPermissionCheckEnabled: teamPermissionCheckEnabled, orgId: orgId, ...flightDeckProps } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = flightDeckProps;
        $[3] = locale;
        $[4] = orgId;
        $[5] = product;
        $[6] = teamPermissionCheckEnabled;
        $[7] = teamPermissions;
    } else {
        children = $[1];
        flightDeckProps = $[2];
        locale = $[3];
        orgId = $[4];
        product = $[5];
        teamPermissionCheckEnabled = $[6];
        teamPermissions = $[7];
    }
    let t1;
    if ($[8] !== children || $[9] !== locale || $[10] !== orgId || $[11] !== product || $[12] !== teamPermissionCheckEnabled || $[13] !== teamPermissions) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($01b62d0be74b9747$export$3bf19eb896b777b8, {
            locale: locale,
            product: product,
            teamPermissions: teamPermissions,
            teamPermissionCheckEnabled: teamPermissionCheckEnabled,
            orgId: orgId,
            children: children
        });
        $[8] = children;
        $[9] = locale;
        $[10] = orgId;
        $[11] = product;
        $[12] = teamPermissionCheckEnabled;
        $[13] = teamPermissions;
        $[14] = t1;
    } else t1 = $[14];
    let t2;
    if ($[15] !== flightDeckProps || $[16] !== product || $[17] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2UMCh.FlightDeckProvider), {
            product: product,
            ...flightDeckProps,
            children: t1
        });
        $[15] = flightDeckProps;
        $[16] = product;
        $[17] = t1;
        $[18] = t2;
    } else t2 = $[18];
    return t2;
} : ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, teamPermissionCheckEnabled: teamPermissionCheckEnabled, orgId: orgId, ...flightDeckProps })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2UMCh.FlightDeckProvider), {
        product: product,
        ...flightDeckProps,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($01b62d0be74b9747$export$3bf19eb896b777b8, {
            locale: locale,
            product: product,
            teamPermissions: teamPermissions,
            teamPermissionCheckEnabled: teamPermissionCheckEnabled,
            orgId: orgId,
            children: children
        })
    });
};
const $01b62d0be74b9747$export$130340d16a670190 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($01b62d0be74b9747$export$8a37839ac1e08b25);
} : ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($01b62d0be74b9747$export$8a37839ac1e08b25);
module.exports["PeopleAndTeamsConfigurationProvider"] = $01b62d0be74b9747$export$d3f5bd36d1c6597e;
module.exports["usePeopleAndTeamsConfigurationContext"] = $01b62d0be74b9747$export$130340d16a670190;

});

parcelRegister("a4991", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2UMCh = parcelRequire("2UMCh");


var $73ViN = parcelRequire("73ViN");

const $1f12623911274c7e$var$transformArtifactsWithOverrides = (artifact, overrideKeys)=>{
    if (!artifact?.overrides?.length || overrideKeys.length === 0) return artifact;
    return overrideKeys.reduce((acc, overrideKey)=>{
        return {
            ...acc,
            ...artifact.overrides && artifact.overrides.find((override)=>override.key === overrideKey)?.item || null
        };
    }, artifact);
};
const $1f12623911274c7e$export$233293b7afb7b362 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (product, locale, overridesKeys)=>{
    const $ = (0, $bDgLe.c)(9);
    let t0;
    if ($[0] !== locale) {
        t0 = {
            ...(0, $73ViN.FD_CLIENT_FETCH_PROPS).dimensions,
            locale: locale
        };
        $[0] = locale;
        $[1] = t0;
    } else t0 = $[1];
    const dimensions = t0;
    const artifact = (0, $2UMCh.useFlightDeckArtifact)((0, $73ViN.FD_CLIENT_FETCH_PROPS).name, dimensions);
    const productArtifact = artifact ? product in artifact["people-menu"] ? artifact["people-menu"][product] : artifact["people-menu"].default : null;
    let t1;
    if ($[2] !== overridesKeys) {
        t1 = overridesKeys ? overridesKeys["people-menu"] : [];
        $[2] = overridesKeys;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== productArtifact || $[5] !== t1) {
        t2 = $1f12623911274c7e$var$transformArtifactsWithOverrides(productArtifact, t1);
        $[4] = productArtifact;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t2) {
        t3 = {
            "people-menu": t2
        };
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : (product, locale, overridesKeys)=>{
    const dimensions = (0, $cozmU.useMemo)(()=>({
            ...(0, $73ViN.FD_CLIENT_FETCH_PROPS).dimensions,
            locale: locale
        }), [
        locale
    ]);
    const artifact = (0, $2UMCh.useFlightDeckArtifact)((0, $73ViN.FD_CLIENT_FETCH_PROPS).name, dimensions);
    /**
   * FlightDeck doesn't allow custom, a 'product', dimension so we must handle this ourselves.
   * We can probably remove this memo once that functionality is available
   */ return (0, $cozmU.useMemo)(()=>{
        const productArtifact = artifact ? product in artifact['people-menu'] ? artifact['people-menu'][product] : artifact['people-menu'].default : null;
        return {
            ['people-menu']: $1f12623911274c7e$var$transformArtifactsWithOverrides(productArtifact, overridesKeys ? overridesKeys['people-menu'] : [])
        };
    }, [
        artifact,
        product,
        overridesKeys
    ]);
};
module.exports["usePeopleAndTeamsRemoteArtifact"] = $1f12623911274c7e$export$233293b7afb7b362;

});

parcelRegister("73ViN", function(module, exports) {

var $jH9cM = parcelRequire("jH9cM");

const $e8b55bfa825f1add$export$953923d576277fd6 = 'people-and-teams-configuration-service';
const $e8b55bfa825f1add$export$71f196808ce40e60 = 'prod';
const $e8b55bfa825f1add$export$6392ca3738ed1e9 = 'fedramp-moderate';
const $e8b55bfa825f1add$export$e836203c1e95eac3 = 'commercial';
const $e8b55bfa825f1add$export$c270c412a04ff3e6 = {
    name: $e8b55bfa825f1add$export$953923d576277fd6,
    dimensions: {
        environmentType: $e8b55bfa825f1add$export$71f196808ce40e60,
        perimeter: (0, $jH9cM.isFedRamp)() ? $e8b55bfa825f1add$export$6392ca3738ed1e9 : $e8b55bfa825f1add$export$e836203c1e95eac3
    }
};
module.exports["FD_CLIENT_FETCH_PROPS"] = $e8b55bfa825f1add$export$c270c412a04ff3e6;

});

parcelRegister("g1sk9", function(module, exports) {
const $c170df15c6ae2aa7$export$9c542858adf7dcd0 = {
    ['people-menu']: null
};
module.exports["DEFAULT_CONTEXT"] = $c170df15c6ae2aa7$export$9c542858adf7dcd0;

});

parcelRegister("hvqau", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $aTE5s = parcelRequire("aTE5s");


var $37kMy = parcelRequire("37kMy");

const $d279cbeea898046b$export$66d7d96ce076bcd6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (teamPermissionCheckEnabled, orgId, teamPermissionsProps)=>{
    const $ = (0, $bDgLe.c)(9);
    const t0 = teamPermissionCheckEnabled && !teamPermissionsProps;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            enabled: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { permissions: teamPermissionsFromHook } = (0, $aTE5s.useTeamsPermissionsService)(orgId, t1);
    const teamPermissions = teamPermissionsProps || teamPermissionsFromHook;
    let t2;
    if ($[2] !== teamPermissions?.canCreateTeams) {
        t2 = !teamPermissions?.canCreateTeams ? [
            (0, $37kMy.PeopleMenuOverrides).createTeamsDisabled
        ] : [];
        $[2] = teamPermissions?.canCreateTeams;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== teamPermissions?.canViewTeams) {
        t3 = !teamPermissions?.canViewTeams ? [
            (0, $37kMy.PeopleMenuOverrides).viewTeamsDisabled
        ] : [];
        $[4] = teamPermissions?.canViewTeams;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t2 || $[7] !== t3) {
        t4 = {
            "people-menu": [
                ...t2,
                ...t3
            ]
        };
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : (teamPermissionCheckEnabled, orgId, teamPermissionsProps)=>{
    const { permissions: teamPermissionsFromHook } = (0, $aTE5s.useTeamsPermissionsService)(orgId, {
        enabled: teamPermissionCheckEnabled && !teamPermissionsProps
    });
    const teamPermissions = teamPermissionsProps || teamPermissionsFromHook;
    return {
        'people-menu': [
            ...!teamPermissions?.canCreateTeams ? [
                (0, $37kMy.PeopleMenuOverrides).createTeamsDisabled
            ] : [],
            ...!teamPermissions?.canViewTeams ? [
                (0, $37kMy.PeopleMenuOverrides).viewTeamsDisabled
            ] : []
        ]
    };
};
module.exports["usePeopleAndTeamsConfigurationOverrides"] = $d279cbeea898046b$export$66d7d96ce076bcd6;

});

parcelRegister("37kMy", function(module, exports) {
var $21bd398bd429ff6c$export$c6e6fe52d34907dc = /*#__PURE__*/ function(PeopleMenuOverrides) {
    PeopleMenuOverrides["createTeamsDisabled"] = "create-teams-disabled";
    PeopleMenuOverrides["viewTeamsDisabled"] = "view-teams-disabled";
    return PeopleMenuOverrides;
}({});
module.exports["PeopleMenuOverrides"] = $21bd398bd429ff6c$export$c6e6fe52d34907dc;

});

parcelRegister("48ubT", function(module, exports) {

var $05h0Q = parcelRequire("05h0Q");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $w033M = parcelRequire("w033M");


var $jMyy4 = parcelRequire("jMyy4");

const $cfdb58fabb92c022$export$f9f8a5cdb0c565ef = ()=>{
    const { data: data, error: error, loading: isAdminCheckLoading } = (0, $jMyy4.useQueryInterop)((0, $05h0Q.default), {
        __callerPackage__: "current-user"
    });
    if (error) {
        if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(data);
    return {
        isSiteAdmin: isSiteAdmin,
        isAdminCheckLoading: isAdminCheckLoading,
        isError: Boolean(error)
    };
};
module.exports["useIsSiteAdmin"] = $cfdb58fabb92c022$export$f9f8a5cdb0c565ef;

});

parcelRegister("05h0Q", function(module, exports) {
/**
 * @generated SignedSource<<53a82c4d5f6d4a903b628178ddbe9e81>>
 * @relayHash 4434db08f18656b277e4683bc4dcaf5d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 049c6ec4db12d273730e8108ab3e3697ea427432281cceb660f908b10068087b
const $ea94449346330325$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "isSiteAdmin"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsSiteAdminUseIsSiteAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsSiteAdminUseIsSiteAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "4434db08f18656b277e4683bc4dcaf5d",
            "id": "049c6ec4db12d273730e8108ab3e3697ea427432281cceb660f908b10068087b",
            "metadata": {},
            "name": "useIsSiteAdminUseIsSiteAdminQuery",
            "operationKind": "query",
            "text": "query useIsSiteAdminUseIsSiteAdminQuery{isSiteAdmin}"
        }
    };
}();
$ea94449346330325$var$node.hash = "ce32420547b7702bc996599bbe635142";
var $ea94449346330325$export$2e2bcd8739ae039 = $ea94449346330325$var$node;
module.exports["default"] = $ea94449346330325$export$2e2bcd8739ae039;

});

parcelRegister("w033M", function(module, exports) {
const $ea2c8f52a33264f1$export$4782acb2cb5b7c11 = (queryData)=>Boolean(queryData?.isSiteAdmin);
module.exports["getIsSiteAdminFromQuery"] = $ea2c8f52a33264f1$export$4782acb2cb5b7c11;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("7c4rV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $5a7a73b748300e1f$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $5a7a73b748300e1f$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $5a7a73b748300e1f$export$9bcfef244f363dbe = (0, $8s9DV.createStore)({
    initialState: $5a7a73b748300e1f$var$initialState,
    actions: $5a7a73b748300e1f$var$actions,
    name: 'atlassianAccountTraitsStore'
});
const $5a7a73b748300e1f$export$c35c4239c4894215 = (0, $kBr4q.createHook)($5a7a73b748300e1f$export$9bcfef244f363dbe);
const $5a7a73b748300e1f$export$aa4cdf7390fbf455 = (0, $kBr4q.createActionsHook)($5a7a73b748300e1f$export$9bcfef244f363dbe);
async function $5a7a73b748300e1f$var$fetchAtlassianAccountTraitsData(userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $5a7a73b748300e1f$var$hasFetched = false;
function $5a7a73b748300e1f$export$f1fbc6ad89f91b89() {
    $5a7a73b748300e1f$var$hasFetched = false;
}
function $5a7a73b748300e1f$var$getAtlassianAccountTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.user);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.user);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $5a7a73b748300e1f$export$88411c3a679154ab({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $cozmU.useMemo)(()=>$5a7a73b748300e1f$var$getAtlassianAccountTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $5a7a73b748300e1f$export$c35c4239c4894215();
    const { accessStatus: accessStatus, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $cozmU.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($5a7a73b748300e1f$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !userId) return;
        $5a7a73b748300e1f$var$hasFetched = true;
        storeActions.start();
        $5a7a73b748300e1f$var$fetchAtlassianAccountTraitsData(userId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        userId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useAtlassianAccountTraits"] = $5a7a73b748300e1f$export$88411c3a679154ab;

});

parcelRegister("30D0J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $CIjCq = parcelRequire("CIjCq");


var $7c4rV = parcelRequire("7c4rV");

const $0f856dd8e4045e89$var$mapPersonalizationResponse = (response)=>({
        experimentalUserPersonalization: {
            attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(response.attributes)
        }
    });
const $0f856dd8e4045e89$export$241fc4ad38d78de1 = ({ skip: skip, onError: onError, variables: variables })=>{
    const lastHandledTraitErrorRef = (0, $cozmU.useRef)(null);
    const atlassianAccountTraitsResult = (0, $7c4rV.useAtlassianAccountTraits)({
        skipBootstrap: skip || !variables.userId
    });
    (0, $cozmU.useEffect)(()=>{
        const traitError = atlassianAccountTraitsResult.error;
        if (skip || !variables.userId || !traitError || lastHandledTraitErrorRef.current === traitError) return;
        lastHandledTraitErrorRef.current = traitError;
        onError?.(traitError);
    }, [
        atlassianAccountTraitsResult.error,
        onError,
        skip,
        variables.userId
    ]);
    if (skip || !variables.userId) return {
        data: undefined,
        loading: false,
        error: undefined
    };
    return {
        data: atlassianAccountTraitsResult.data ? $0f856dd8e4045e89$var$mapPersonalizationResponse(atlassianAccountTraitsResult.data) : undefined,
        loading: atlassianAccountTraitsResult.loading,
        error: atlassianAccountTraitsResult.error ?? undefined
    };
};
module.exports["useExperimentalUserPersonalizationQuery"] = $0f856dd8e4045e89$export$241fc4ad38d78de1;

});

parcelRegister("2FNNv", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");

// Production trait: https://data-portal.internal.atlassian.com/targeting/traits/f0c5d949-91be-46e0-b440-7d7a953c9159
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME = 'confluence_is_established_user';
// Staging trait: https://data-portal-stg.internal.atlassian.com/targeting/traits/4015e85e-221b-4d95-a945-c68548e21a8b
// NOTE: DO NOT USE Staging trait named as `confluence_is_established_user` - this is a legacy trait created with wrong evaluation type and won't work for staging
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING = 'confluence_is_established_user_stg';
const $f30477d177bb95bd$export$a284916a4d5ed017 = ()=>{
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    if (environment !== 'PRODUCTION') return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING;
    return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME;
};
module.exports["useIsEstablishedUserTraitName"] = $f30477d177bb95bd$export$a284916a4d5ed017;

});

parcelRegister("eFm27", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");


var $9DHhW = parcelRequire("9DHhW");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $euozR = parcelRequire("euozR");


var $clKWq = parcelRequire("clKWq");


var $cf6nm = parcelRequire("cf6nm");


var $77a1U = parcelRequire("77a1U");

const $75a2d6647cc04503$export$369212709d95b58d = ({ size: size, outlineAppearance: outlineAppearance, tooltipPosition: tooltipPosition, shortcut: shortcut, label: label, labelledBy: labelledBy, id: id, ...props })=>{
    const intl = (0, $kSwu1.useIntl)();
    const isEditorOpen = (0, $euozR.useIsEditorOpen)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const spacing = size === 'small' ? 'compact' : 'default';
    const tooltipLabel = props.isStarred ? intl.formatMessage($75a2d6647cc04503$var$i18n.unstarContent) : intl.formatMessage($75a2d6647cc04503$var$i18n.starContent);
    const shortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: shortcut
    });
    const buttonLabel = props.isStarred ? intl.formatMessage($75a2d6647cc04503$var$i18n.unstarContent) : intl.formatMessage($75a2d6647cc04503$var$i18n.starContent);
    const handleClick = (0, $cozmU.useCallback)((starHandler, triggeredByKeyboardShortcut)=>(e)=>{
            starHandler(e);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'pageStar',
                    attributes: {
                        triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                        action: props.isStarred ? 'unstar' : 'star'
                    },
                    source: 'PageStarButton'
                }
            }).fire();
        }, [
        createAnalyticsEvent,
        props.isStarred
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $77a1U.PageStar), props, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: tooltipLabel,
            shortcut: shortcutStrings,
            position: tooltipPosition || 'top',
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $clKWq.ConditionalHiddenAction), {
            isHidden: !props.isStarred
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $clKWq.ConditionalSubtleHoverButton), {
            id: id,
            isSubtle: outlineAppearance === 'subtle',
            "data-id": props.isStarred ? 'page-unstar-button' : 'page-star-button',
            testId: props.isStarred ? 'page-unstar-button' : 'page-star-button',
            spacing: spacing,
            appearance: "subtle",
            onClick: handleClick(toggleStar, false),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf6nm.StarIcon), {
                isStarred: props.isStarred,
                spacing: props.spacing
            }),
            "aria-label": buttonLabel,
            "aria-labelledby": labelledBy,
            "aria-pressed": props.isStarred,
            isDisabled: props.isDisabled
        }))), shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: !isEditorOpen ? (0, $gnkil.STAR_BUTTON_SHORTCUT) : undefined,
            accelerator: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT),
            listener: handleClick(toggleStar, true)
        })));
};
const $75a2d6647cc04503$var$i18n = (0, $kSwu1.defineMessages)({
    starContent: {
        id: "action-buttons.content.starContent.label",
        defaultMessage: "Star this content"
    },
    unstarContent: {
        id: "action-buttons.content.unstarContent.label",
        defaultMessage: "Unstar this content"
    }
});
module.exports["PageStarButton"] = $75a2d6647cc04503$export$369212709d95b58d;

});

parcelRegister("clKWq", function(module, exports) {
/* PresentationalComponents.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $7ZB0A = parcelRequire("7ZB0A");

const $c778e820ae925f4a$var$buttonStyle = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css -- Ignored via go/DSP-18766
const $c778e820ae925f4a$export$51d63fc44de8b04c = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_30huDKYbGa _0bjKvDzXzM _2uo31f66of _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VUofl _39xV02Uofl _0wOv4Q7zJH _30zrXRo126",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c778e820ae925f4a$export$d4589334c0881f2b = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_30huDKYbGa _0bjKvDzXzM _2uo31f66of _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VUofl _39xV02Uofl _0wOv4Q7zJH _1UtDYzmV7M _30zrXRo126 _3oDoUi8ujp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c778e820ae925f4a$export$7099540c149f2cd6 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4iwgQuagZ4 _1qlBI88ujp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c778e820ae925f4a$export$4fba02bb1c3a731d = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0KUV0FqGUA _2gUJkQ7dHp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c778e820ae925f4a$export$e74173003a1ed83f = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1dgtmw9": (0, $9aYkv.default)(__cmplp.isHidden ? 'var(--show-action)' : '1')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0KUV0FjgF2 _2gUJkQ7dHp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c778e820ae925f4a$export$bba53dc78bc0e0ef = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $7ZB0A.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "",
            __cmplp.isSubtle && "_4f0cj2agZ4 _0Z0OO38ujp",
            __cmplp.className
        ])
    });
});
module.exports["FilledIconButton"] = $c778e820ae925f4a$export$51d63fc44de8b04c;
module.exports["UnfilledIconButton"] = $c778e820ae925f4a$export$d4589334c0881f2b;
module.exports["HoverButton"] = $c778e820ae925f4a$export$7099540c149f2cd6;
module.exports["HiddenAction"] = $c778e820ae925f4a$export$4fba02bb1c3a731d;
module.exports["ConditionalHiddenAction"] = $c778e820ae925f4a$export$e74173003a1ed83f;
module.exports["ConditionalSubtleHoverButton"] = $c778e820ae925f4a$export$bba53dc78bc0e0ef;

});

parcelRegister("7CeAz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cEgMD = parcelRequire("cEgMD");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");


var $8NC5Z = parcelRequire("8NC5Z");

const $16ea73778f65e8da$export$1d4394ae12760637 = ()=>{
    const { frontCoverState: frontCoverState, isSiteAdmin: isSiteAdmin, loading: loading } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const canPublish = isSiteAdmin || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const isAdminDiscoverable = // 1. If entitled (e.g. Premium), both site admin and product admin have the
    //    entry point in the top nav, because it leads to COMPANY_HUB.
    // 2. If not entitled (e.g. Free or Standard):
    //   a. only site admin has the entry point in the top nav, because it
    //      renders an upsell;
    //   b. product admin doesn't have the entry point in the top nav, because
    //      it automatically redirects to HOME.
    shouldShowPremiumUpsell ? isSiteAdmin : canPublish;
    const isCompanyHubFeatureAvailable = !shouldShowPremiumUpsell;
    const isCompanyHubPublished = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).SHOWN);
    const isCompanyHubShownToEditors = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).EDITORS_ONLY || isCompanyHubPublished);
    const isCompanyHubEntryPointEnabled = Boolean(isCompanyHubFeatureAvailable && (isCompanyHubPublished || isCompanyHubShownToEditors) || isAdminDiscoverable);
    return {
        canPublish: isCompanyHubFeatureAvailable && canPublish,
        isCompanyHubPublished: isCompanyHubPublished,
        isCompanyHubShownToEditors: isCompanyHubShownToEditors,
        isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled,
        loading: Boolean(loading)
    };
};
module.exports["useIsCompanyHubEnabled"] = $16ea73778f65e8da$export$1d4394ae12760637;

});

parcelRegister("8NC5Z", function(module, exports) {

var $896gY = parcelRequire("896gY");


var $7Sm4c = parcelRequire("7Sm4c");


var $euL71 = parcelRequire("euL71");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");

const $1de3a5511529eed3$export$f032b5e8b485da1d = ({ skip: skip = false } = {})=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const shouldSkip = skip || edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $896gY.default), {
        skip: shouldSkip,
        __callerPackage__: "company-hub-utils"
    });
    if (error) {
        if (!((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error))) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return !shouldSkip && !data?.entitlements?.companyHub?.isEntitled;
};
module.exports["useCompanyHubPremiumGate"] = $1de3a5511529eed3$export$f032b5e8b485da1d;

});

parcelRegister("896gY", function(module, exports) {
/**
 * @generated SignedSource<<0bf45832ece12ce1024ca4a87950d3ec>>
 * @relayHash c31aa70a9a01e2207eb48c0b9be8b493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6
const $983e77d68212dc57$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "CompanyHubFeature",
                    "kind": "LinkedField",
                    "name": "companyHub",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c31aa70a9a01e2207eb48c0b9be8b493",
            "id": "46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6",
            "metadata": {},
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "operationKind": "query",
            "text": "query useCompanyHubPremiumGateCompanyHubPremiumGateQuery{entitlements{companyHub{isEntitled}}}"
        }
    };
}();
$983e77d68212dc57$var$node.hash = "a5508e7e7123c5675909c4f9214a5be2";
var $983e77d68212dc57$export$2e2bcd8739ae039 = $983e77d68212dc57$var$node;
module.exports["default"] = $983e77d68212dc57$export$2e2bcd8739ae039;

});

parcelRegister("3Awqk", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $90247d71b6534bef$export$ce22f6f6b0034afd = (0, $kSwu1.defineMessages)({
    next: {
        id: "experiment-nth-user-orientation.spotlight.next",
        defaultMessage: "Next"
    },
    back: {
        id: "experiment-nth-user-orientation.spotlight.back",
        defaultMessage: "Back"
    },
    done: {
        id: "experiment-nth-user-orientation.spotlight.done",
        defaultMessage: "Done"
    },
    dismiss: {
        id: "experiment-nth-user-orientation.spotlight.dismiss",
        defaultMessage: "Dismiss Tour"
    },
    progress: {
        id: "experiment-nth-user-orientation.spotlight.progress",
        defaultMessage: "{step} of {steps}"
    }
});
const $90247d71b6534bef$export$9a4454cd199ce080 = (0, $kSwu1.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.headline",
        defaultMessage: "Your space, your start"
    },
    body: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.body",
        defaultMessage: "This is your personal space. Create more to organize your team\u2019s work."
    }
});
const $90247d71b6534bef$export$252e22890fb2efa6 = (0, $kSwu1.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.headline",
        defaultMessage: "Catch up on team activity here"
    },
    body: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.body",
        defaultMessage: "See recent pages, team updates, and quick links tailored for you."
    }
});
const $90247d71b6534bef$export$6794fada8079fe55 = (0, $kSwu1.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.headline",
        defaultMessage: "Now let\u2019s create your first page!"
    },
    body: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.body",
        defaultMessage: "With a template, a page is a click away. Hover on one for a preview."
    }
});
module.exports["spotlight"] = $90247d71b6534bef$export$ce22f6f6b0034afd;
module.exports["editorSpaceSpotlight"] = $90247d71b6534bef$export$9a4454cd199ce080;
module.exports["editorForYouSpotlight"] = $90247d71b6534bef$export$252e22890fb2efa6;
module.exports["editorBpqaSpotlight"] = $90247d71b6534bef$export$6794fada8079fe55;

});

parcelRegister("2AgON", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

const $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS = {
    'nth-user-orientation-editor-space-spotlight': 'nthUserOrientationEditorSpaceSpotlight',
    'nth-user-orientation-editor-for-you-spotlight': 'nthUserOrientationEditorForYouSpotlight',
    'nth-user-orientation-editor-bpqa-spotlight': 'nthUserOrientationEditorBpqaSpotlight'
};
function $3c36b21fe0d55bcd$export$b54fada573f13a91({ spotlightId: spotlightId, isVisible: isVisible, onNext: onNext, onBack: onBack, onDismiss: onDismiss }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // Fire render event when spotlight becomes visible
    (0, $cozmU.useEffect)(()=>{
        if (isVisible) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'rendered',
                actionSubject: 'spotlight',
                actionSubjectId: $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS[spotlightId],
                source: 'nth-user-orientation'
            }
        }).fire();
    }, [
        isVisible,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleNext = (0, $cozmU.useCallback)(()=>{
        if (onNext) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'next',
                    source: spotlightId
                }
            }).fire();
            onNext();
        }
    }, [
        onNext,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleBack = (0, $cozmU.useCallback)(()=>{
        if (onBack) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'back',
                    source: spotlightId
                }
            }).fire();
            onBack();
        }
    }, [
        onBack,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissTour',
                source: spotlightId
            }
        }).fire();
        onDismiss();
    }, [
        onDismiss,
        createAnalyticsEvent,
        spotlightId
    ]);
    return {
        handleNext: onNext ? handleNext : undefined,
        handleBack: onBack ? handleBack : undefined,
        handleDismiss: handleDismiss
    };
}
module.exports["useSpotlightAnalytics"] = $3c36b21fe0d55bcd$export$b54fada573f13a91;

});

parcelRegister("35Nok", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $cd2e96a49affba4b$export$4b64aca38e15f2eb = ({ gif: gif, placeholder: placeholder, skip: skip = false })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const gifSrc = gif[colorMode ?? 'light'];
    const placeholderSrc = placeholder[colorMode ?? 'light'];
    const [isReady, setIsReady] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        setIsReady(false);
        const image = new Image();
        image.onload = ()=>{
            setIsReady(true);
        };
        image.onerror = ()=>{
            setIsReady(false);
        };
        image.src = gifSrc;
        // If the image has already loaded (cached), handle it immediately
        if (image.complete) setIsReady(true);
    }, [
        gifSrc,
        skip
    ]);
    return isReady ? gifSrc : placeholderSrc;
};
module.exports["usePreloadGif"] = $cd2e96a49affba4b$export$4b64aca38e15f2eb;

});

parcelRegister("3SChL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $751fcd22fac4dec6$export$7a357837346c6789 = {
    editor: [
        'nth-user-orientation-editor-space-spotlight',
        'nth-user-orientation-editor-for-you-spotlight',
        'nth-user-orientation-editor-bpqa-spotlight'
    ]
};
const $751fcd22fac4dec6$var$detectTour = (renderedSpotlights)=>{
    // Find the first tour where all required spotlights are registered
    for (const [tour, spotlights] of Object.entries($751fcd22fac4dec6$export$7a357837346c6789)){
        if (spotlights.every((spotlight)=>renderedSpotlights.has(spotlight))) return tour;
    }
    return null;
};
const $751fcd22fac4dec6$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        active: false,
        step: 0,
        renderedSpotlights: new Set(),
        hasInteracted: false
    },
    actions: {
        activate: ()=>({ setState: setState })=>{
                setState({
                    active: true,
                    step: 0
                });
            },
        reset: ()=>({ setState: setState })=>{
                setState({
                    active: false,
                    step: 0,
                    hasInteracted: false
                });
            },
        next: ()=>({ setState: setState, getState: getState })=>{
                const nextStep = Math.min(getState().step + 1, 2);
                setState({
                    step: nextStep,
                    hasInteracted: true
                });
            },
        back: ()=>({ setState: setState, getState: getState })=>{
                const prevStep = Math.max(getState().step - 1, 0);
                setState({
                    step: prevStep,
                    hasInteracted: true
                });
            },
        registerSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.add(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            },
        deregisterSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.delete(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            }
    },
    name: 'experiment-nth-user-orientation-store'
});
const $751fcd22fac4dec6$export$6d3060c9729a9bf7 = (0, $kBr4q.createStateHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$31ec7099503725e8 = (0, $kBr4q.createActionsHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$e9b94d8bc34db24 = (spotlightId)=>{
    const { next: next, back: back, reset: reset, registerSpotlight: registerSpotlight, deregisterSpotlight: deregisterSpotlight } = $751fcd22fac4dec6$export$31ec7099503725e8();
    const { step: step, active: active, renderedSpotlights: renderedSpotlights, hasInteracted: hasInteracted } = $751fcd22fac4dec6$export$6d3060c9729a9bf7();
    // Auto-register/deregister the spotlight when spotlights use this hook. This way
    // we can keep track of which spotlights are currently rendered, and use that list
    // to figure out if the user is eligible for a tour.
    (0, $cozmU.useEffect)(()=>{
        registerSpotlight({
            spotlightId: spotlightId
        });
        return ()=>{
            deregisterSpotlight({
                spotlightId: spotlightId
            });
        };
    }, [
        spotlightId,
        registerSpotlight,
        deregisterSpotlight
    ]);
    const detectedTour = (0, $cozmU.useMemo)(()=>$751fcd22fac4dec6$var$detectTour(renderedSpotlights), [
        renderedSpotlights
    ]);
    if (!active || !detectedTour) return {
        reset: reset,
        back: back,
        next: next,
        currentStep: null,
        progress: {
            step: 0,
            steps: 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
    return {
        reset: reset,
        back: back,
        next: next,
        currentStep: $751fcd22fac4dec6$export$7a357837346c6789[detectedTour][step],
        progress: {
            step: step + 1,
            steps: detectedTour ? $751fcd22fac4dec6$export$7a357837346c6789[detectedTour].length : 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
};
module.exports["useNthUserOrientationState"] = $751fcd22fac4dec6$export$6d3060c9729a9bf7;
module.exports["useNthUserOrientationActions"] = $751fcd22fac4dec6$export$31ec7099503725e8;
module.exports["useTour"] = $751fcd22fac4dec6$export$e9b94d8bc34db24;

});

parcelRegister("jo3kP", function(module, exports) {
const $2034ef6195fd7775$var$COLLABORATION_GRAPH_MAX_RESULTS = 50;
const $2034ef6195fd7775$export$f757fae6e9facd6f = async (integration, cloudId, userId)=>{
    const payload = {
        context: {
            contextType: integration,
            principalId: userId,
            siteId: cloudId
        },
        modelRequestParams: {
            experience: 'CgUserNearbyUser'
        },
        expanded: true,
        maxNumberOfResults: $2034ef6195fd7775$var$COLLABORATION_GRAPH_MAX_RESULTS,
        userId: userId
    };
    const response = await fetch('/gateway/api/collaboration/v1/collaborationgraph/user/user', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
    const result = (await response.json())?.collaborationGraphEntities?.filter((en)=>en?.userProfile !== undefined && en?.userProfile?.account_type !== 'app' && en?.userProfile?.account_status !== 'deactivated' && en?.userProfile?.account_status !== 'deleted').map(({ userProfile: { account_id: account_id, name: name, picture: picture } })=>({
            id: account_id,
            name: name,
            avatar: picture
        }));
    return result;
};
module.exports["getUsersFromCollaborationGraph"] = $2034ef6195fd7775$export$f757fae6e9facd6f;

});

parcelRegister("cRtgQ", function(module, exports) {
// oxlint-disable-next-line eslint/no-redeclare
const $7b0b1cbcfa971992$export$696c71818ae3f184 = {
    FREE: 'free',
    STANDARD: 'standard',
    PREMIUM: 'premium',
    ESSENTIALS: 'essentials',
    ENTERPRISE: 'enterprise'
};
const $7b0b1cbcfa971992$export$993d0f36af4bf76f = {
    LAND: 'land',
    CLOSE: 'close'
};
const $7b0b1cbcfa971992$export$c57f0d43fd595f43 = {
    SAME: 'same',
    NEW: 'new'
};
const $7b0b1cbcfa971992$export$d1609d6291f3d60d = {
    NEXT: 'next',
    CLOSE: 'close',
    GO_TO_PRODUCT: 'go-to-product',
    RETURN_TO_PRODUCT: 'return-to-product'
};
module.exports["Behaviours"] = $7b0b1cbcfa971992$export$993d0f36af4bf76f;
module.exports["TargetTabs"] = $7b0b1cbcfa971992$export$c57f0d43fd595f43;
module.exports["Prompts"] = $7b0b1cbcfa971992$export$d1609d6291f3d60d;

});

parcelRegister("du2pt", function(module, exports) {

var $6ROIE = parcelRequire("6ROIE");

const $4049e7ac00025053$export$9143c254bff9f7b7 = (object, propertyNames)=>propertyNames.reduce((accumulator, property)=>{
        const value = object[property];
        if (value !== undefined) accumulator[property] = value;
        return accumulator;
    }, {});
const $4049e7ac00025053$export$42e62ee12e8ced48 = (extensionsWhitelist)=>(options)=>{
        const filteredOptions = $4049e7ac00025053$export$9143c254bff9f7b7(options, extensionsWhitelist);
        return new (0, $6ROIE.CrossFlowExtensions)(filteredOptions);
    };
const $4049e7ac00025053$export$86a865d89ef3c690 = (...extensions)=>{
    const combinedOptions = Object.assign({}, ...extensions);
    return new (0, $6ROIE.CrossFlowExtensions)(combinedOptions);
};
module.exports["createProductExtensions"] = $4049e7ac00025053$export$42e62ee12e8ced48;

});

parcelRegister("aDe4X", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gkHoc = parcelRequire("gkHoc");

var $6Mfv2 = parcelRequire("6Mfv2");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $ivb8S = parcelRequire("ivb8S");


var $b4VFP = parcelRequire("b4VFP");

var $dBcar = parcelRequire("dBcar");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $2FNNv = parcelRequire("2FNNv");


var $30D0J = parcelRequire("30D0J");

const $d12c0291e106b88f$var$HOME_ONBOARDING_TAKEOVER_NTH_USER_DAYS = 14;
const $d12c0291e106b88f$export$de7bc1ba49cd35c5 = ()=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { accessStatus: accessStatus, userId: userId } = (0, $bQm3c.useSessionData)();
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    // User is licensed (site admin or nth user)
    const hasAdminOrUseAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER)
        });
    }, [
        experienceTracker
    ]);
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
        ...Object.values((0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS))
    ], !hasAdminOrUseAccess);
    const { isFoundingAdmin: isFoundingAdmin, takeoverSeenAt: takeoverSeenAt } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const takeoverExpired = Boolean(takeoverSeenAt) && (0, $6Mfv2.default)(Date.now(), (0, $gkHoc.default)(new Date(takeoverSeenAt), $d12c0291e106b88f$var$HOME_ONBOARDING_TAKEOVER_NTH_USER_DAYS));
    const { data: userPersonalizationQueryData, loading: userPersonalizationQueryLoading, error: userPersonalizationQueryError } = (0, $30D0J.useExperimentalUserPersonalizationQuery)({
        skip: !hasAdminOrUseAccess || takeoverExpired,
        variables: {
            userId: userId
        }
    });
    const attributes = userPersonalizationQueryData?.experimentalUserPersonalization?.attributes ?? [];
    const isEstablishedUser = attributes.find((attr)=>attr?.name === isEstablishedUserTraitName)?.value === 'true';
    const isEstablishedUserReady = !userPersonalizationQueryLoading && !userPersonalizationQueryError;
    const isNotEstablishedUser = isEstablishedUserReady && !isEstablishedUser;
    const isEligible = Boolean(hasAdminOrUseAccess && (takeoverSeenAt ?? isNotEstablishedUser) && !isFoundingAdmin);
    if (onboardingStateError || userPersonalizationQueryError) experienceTracker.stopOnError({
        name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER),
        error: onboardingStateError || userPersonalizationQueryError
    });
    return {
        isEligible: isEligible,
        isVisible: isEligible && !takeoverExpired,
        loading: onboardingStateLoading || userPersonalizationQueryLoading
    };
};
module.exports["useNthUserHomeOnboardingTakeoverV2Eligibility"] = $d12c0291e106b88f$export$de7bc1ba49cd35c5;

});


//# sourceMappingURL=GlobalNavigationComponent.31e22560.js.map
